// @ts-nocheck
import { GraphQLClient, RequestOptions } from "graphql-request";
import { GraphQLError, print } from "graphql";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  Dimension: { input: any; output: any };
  HexColor: { input: any; output: any };
  JSON: { input: any; output: any };
  Quality: { input: any; output: any };
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2C = Entry &
  _Node & {
    __typename?: "AccordionD2C";
    _id: Scalars["ID"]["output"];
    columnWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<AccordionD2CItemsCollection>;
    itemsCursorCollection?: Maybe<AccordionD2CItemsCursorCollection>;
    linkedFrom?: Maybe<AccordionD2CLinkingCollections>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CColumnWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionD2c) */
export type AccordionD2CUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type AccordionD2CCollection = {
  __typename?: "AccordionD2CCollection";
  items: Array<Maybe<AccordionD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type AccordionD2CCursorCollection = {
  __typename?: "AccordionD2CCursorCollection";
  items: Array<Maybe<AccordionD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type AccordionD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionD2CFilter>>>;
  columnWidth?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  columnWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  columnWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfAccordionItemD2CNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CItemsCollection = {
  __typename?: "AccordionD2CItemsCollection";
  items: Array<Maybe<AccordionItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum AccordionD2CItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type AccordionD2CItemsCursorCollection = {
  __typename?: "AccordionD2CItemsCursorCollection";
  items: Array<Maybe<AccordionItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum AccordionD2CItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type AccordionD2CLinkingCollections = {
  __typename?: "AccordionD2CLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type AccordionD2CLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionD2CLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2CLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AccordionD2CLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum AccordionD2CLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum AccordionD2CLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum AccordionD2CLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum AccordionD2CLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionD2CLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionD2COrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2C = Entry &
  _Node & {
    __typename?: "AccordionItemD2C";
    _id: Scalars["ID"]["output"];
    contentBlocksCollection?: Maybe<AccordionItemD2CContentBlocksCollection>;
    contentBlocksCursorCollection?: Maybe<AccordionItemD2CContentBlocksCursorCollection>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<AccordionItemD2CLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2CContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CContentBlocksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2CContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CContentBlocksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2CLabelArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/accordionItemD2c) */
export type AccordionItemD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AccordionItemD2CCollection = {
  __typename?: "AccordionItemD2CCollection";
  items: Array<Maybe<AccordionItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type AccordionItemD2CContentBlocksCollection = {
  __typename?: "AccordionItemD2CContentBlocksCollection";
  items: Array<Maybe<AccordionItemD2CContentBlocksItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type AccordionItemD2CContentBlocksCursorCollection = {
  __typename?: "AccordionItemD2CContentBlocksCursorCollection";
  items: Array<Maybe<AccordionItemD2CContentBlocksItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type AccordionItemD2CContentBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionItemD2CContentBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionItemD2CContentBlocksFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionItemD2CContentBlocksItem = GeometryTable | SectionMedia | SectionText;

export type AccordionItemD2CCursorCollection = {
  __typename?: "AccordionItemD2CCursorCollection";
  items: Array<Maybe<AccordionItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type AccordionItemD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionItemD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionItemD2CFilter>>>;
  contentBlocks?: InputMaybe<CfcontentBlocksMultiTypeNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionItemD2CLinkingCollections = {
  __typename?: "AccordionItemD2CLinkingCollections";
  accordionD2CCollection?: Maybe<AccordionD2CCollection>;
  accordionD2CCursorCollection?: Maybe<AccordionD2CCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type AccordionItemD2CLinkingCollectionsAccordionD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2CLinkingCollectionsAccordionD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionItemD2CLinkingCollectionsAccordionD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2CLinkingCollectionsAccordionD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionItemD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionItemD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionItemD2CLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2CLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AccordionItemD2CLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2CLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AccordionItemD2CLinkingCollectionsAccordionD2CCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionItemD2CLinkingCollectionsAccordionD2CCursorCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionItemD2CLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionItemD2CLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AccordionItemD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = _Node & {
  __typename?: "Asset";
  _id: Scalars["ID"]["output"];
  contentType?: Maybe<Scalars["String"]["output"]>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars["String"]["output"]>;
  fileName?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["Int"]["output"]>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars["Int"]["output"]>;
  sys: Sys;
  title?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  width?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  transform?: InputMaybe<ImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AssetCollection = {
  __typename?: "AssetCollection";
  items: Array<Maybe<Asset>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type AssetCursorCollection = {
  __typename?: "AssetCursorCollection";
  items: Array<Maybe<Asset>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars["String"]["input"]>;
  contentType_contains?: InputMaybe<Scalars["String"]["input"]>;
  contentType_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentType_not?: InputMaybe<Scalars["String"]["input"]>;
  contentType_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fileName?: InputMaybe<Scalars["String"]["input"]>;
  fileName_contains?: InputMaybe<Scalars["String"]["input"]>;
  fileName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fileName_not?: InputMaybe<Scalars["String"]["input"]>;
  fileName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  height_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  height_gt?: InputMaybe<Scalars["Int"]["input"]>;
  height_gte?: InputMaybe<Scalars["Int"]["input"]>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  height_lt?: InputMaybe<Scalars["Int"]["input"]>;
  height_lte?: InputMaybe<Scalars["Int"]["input"]>;
  height_not?: InputMaybe<Scalars["Int"]["input"]>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
  size_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  size_gt?: InputMaybe<Scalars["Int"]["input"]>;
  size_gte?: InputMaybe<Scalars["Int"]["input"]>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  size_lt?: InputMaybe<Scalars["Int"]["input"]>;
  size_lte?: InputMaybe<Scalars["Int"]["input"]>;
  size_not?: InputMaybe<Scalars["Int"]["input"]>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  url_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url_not?: InputMaybe<Scalars["String"]["input"]>;
  url_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
  width_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  width_gt?: InputMaybe<Scalars["Int"]["input"]>;
  width_gte?: InputMaybe<Scalars["Int"]["input"]>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  width_lt?: InputMaybe<Scalars["Int"]["input"]>;
  width_lte?: InputMaybe<Scalars["Int"]["input"]>;
  width_not?: InputMaybe<Scalars["Int"]["input"]>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type AssetLinkingCollections = {
  __typename?: "AssetLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AssetOrder {
  ContentTypeAsc = "contentType_ASC",
  ContentTypeDesc = "contentType_DESC",
  FileNameAsc = "fileName_ASC",
  FileNameDesc = "fileName_DESC",
  HeightAsc = "height_ASC",
  HeightDesc = "height_DESC",
  SizeAsc = "size_ASC",
  SizeDesc = "size_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
  WidthAsc = "width_ASC",
  WidthDesc = "width_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type Athlete = Entry &
  _Node & {
    __typename?: "Athlete";
    _id: Scalars["ID"]["output"];
    biography?: Maybe<AthleteBiography>;
    contentfulMetadata: ContentfulMetadata;
    country?: Maybe<Scalars["String"]["output"]>;
    firstName?: Maybe<Scalars["String"]["output"]>;
    image?: Maybe<MediaImage>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    lastName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<AthleteLinkingCollections>;
    resultsCollection?: Maybe<AthleteResultsCollection>;
    resultsCursorCollection?: Maybe<AthleteResultsCursorCollection>;
    socialLinksCollection?: Maybe<AthleteSocialLinksCollection>;
    socialLinksCursorCollection?: Maybe<AthleteSocialLinksCursorCollection>;
    sys: Sys;
    team?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteBiographyArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteCountryArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteFirstNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteLastNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteResultsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteResultsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteResultsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteResultsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteSocialLinksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteSocialLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SocialLinksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteSocialLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteSocialLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SocialLinksFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athlete) */
export type AthleteTeamArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteBiography = {
  __typename?: "AthleteBiography";
  json: Scalars["JSON"]["output"];
  links: AthleteBiographyLinks;
};

export type AthleteBiographyAssets = {
  __typename?: "AthleteBiographyAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AthleteBiographyEntries = {
  __typename?: "AthleteBiographyEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AthleteBiographyLinks = {
  __typename?: "AthleteBiographyLinks";
  assets: AthleteBiographyAssets;
  entries: AthleteBiographyEntries;
  resources: AthleteBiographyResources;
};

export type AthleteBiographyResources = {
  __typename?: "AthleteBiographyResources";
  block: Array<AthleteBiographyResourcesBlock>;
  hyperlink: Array<AthleteBiographyResourcesHyperlink>;
  inline: Array<AthleteBiographyResourcesInline>;
};

export type AthleteBiographyResourcesBlock = ResourceLink & {
  __typename?: "AthleteBiographyResourcesBlock";
  sys: ResourceSys;
};

export type AthleteBiographyResourcesHyperlink = ResourceLink & {
  __typename?: "AthleteBiographyResourcesHyperlink";
  sys: ResourceSys;
};

export type AthleteBiographyResourcesInline = ResourceLink & {
  __typename?: "AthleteBiographyResourcesInline";
  sys: ResourceSys;
};

export type AthleteCollection = {
  __typename?: "AthleteCollection";
  items: Array<Maybe<Athlete>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type AthleteCursorCollection = {
  __typename?: "AthleteCursorCollection";
  items: Array<Maybe<Athlete>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type AthleteFilter = {
  AND?: InputMaybe<Array<InputMaybe<AthleteFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AthleteFilter>>>;
  biography_contains?: InputMaybe<Scalars["String"]["input"]>;
  biography_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  biography_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  country_contains?: InputMaybe<Scalars["String"]["input"]>;
  country_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  country_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  country_not?: InputMaybe<Scalars["String"]["input"]>;
  country_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  firstName_contains?: InputMaybe<Scalars["String"]["input"]>;
  firstName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  firstName_not?: InputMaybe<Scalars["String"]["input"]>;
  firstName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  image?: InputMaybe<CfMediaImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastName_contains?: InputMaybe<Scalars["String"]["input"]>;
  lastName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastName_not?: InputMaybe<Scalars["String"]["input"]>;
  lastName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  results?: InputMaybe<CfAthleteResultsNestedFilter>;
  resultsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  socialLinks?: InputMaybe<CfSocialLinksNestedFilter>;
  socialLinksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_contains?: InputMaybe<Scalars["String"]["input"]>;
  team_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  team_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  team_not?: InputMaybe<Scalars["String"]["input"]>;
  team_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  team_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AthleteLinkingCollections = {
  __typename?: "AthleteLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionQuoteCollection?: Maybe<SectionQuoteCollection>;
  sectionQuoteCursorCollection?: Maybe<SectionQuoteCursorCollection>;
};

export type AthleteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteLinkingCollectionsSectionQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteLinkingCollectionsSectionQuoteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteLinkingCollectionsSectionQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteLinkingCollectionsSectionQuoteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AthleteLinkingCollectionsSectionQuoteCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AthleteLinkingCollectionsSectionQuoteCursorCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum AthleteOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResults = Entry &
  _Node & {
    __typename?: "AthleteResults";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    date?: Maybe<Scalars["DateTime"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<AthleteResultsLinkingCollections>;
    position?: Maybe<Scalars["String"]["output"]>;
    race?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResultsDateArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResultsInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResultsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResultsPositionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/athleteResults) */
export type AthleteResultsRaceArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteResultsCollection = {
  __typename?: "AthleteResultsCollection";
  items: Array<Maybe<AthleteResults>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum AthleteResultsCollectionOrder {
  DateAsc = "date_ASC",
  DateDesc = "date_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PositionAsc = "position_ASC",
  PositionDesc = "position_DESC",
  RaceAsc = "race_ASC",
  RaceDesc = "race_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type AthleteResultsCursorCollection = {
  __typename?: "AthleteResultsCursorCollection";
  items: Array<Maybe<AthleteResults>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum AthleteResultsCursorCollectionOrder {
  DateAsc = "date_ASC",
  DateDesc = "date_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PositionAsc = "position_ASC",
  PositionDesc = "position_DESC",
  RaceAsc = "race_ASC",
  RaceDesc = "race_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type AthleteResultsFilter = {
  AND?: InputMaybe<Array<InputMaybe<AthleteResultsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AthleteResultsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  date_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  date_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  position?: InputMaybe<Scalars["String"]["input"]>;
  position_contains?: InputMaybe<Scalars["String"]["input"]>;
  position_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  position_not?: InputMaybe<Scalars["String"]["input"]>;
  position_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  race_contains?: InputMaybe<Scalars["String"]["input"]>;
  race_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  race_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  race_not?: InputMaybe<Scalars["String"]["input"]>;
  race_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  race_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AthleteResultsLinkingCollections = {
  __typename?: "AthleteResultsLinkingCollections";
  athleteCollection?: Maybe<AthleteCollection>;
  athleteCursorCollection?: Maybe<AthleteCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type AthleteResultsLinkingCollectionsAthleteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsLinkingCollectionsAthleteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteResultsLinkingCollectionsAthleteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsLinkingCollectionsAthleteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteResultsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AthleteResultsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AthleteResultsLinkingCollectionsAthleteCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum AthleteResultsLinkingCollectionsAthleteCursorCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum AthleteResultsOrder {
  DateAsc = "date_ASC",
  DateDesc = "date_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PositionAsc = "position_ASC",
  PositionDesc = "position_DESC",
  RaceAsc = "race_ASC",
  RaceDesc = "race_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type AthleteSocialLinksCollection = {
  __typename?: "AthleteSocialLinksCollection";
  items: Array<Maybe<SocialLinks>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum AthleteSocialLinksCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PlatformAsc = "platform_ASC",
  PlatformDesc = "platform_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export type AthleteSocialLinksCursorCollection = {
  __typename?: "AthleteSocialLinksCursorCollection";
  items: Array<Maybe<SocialLinks>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum AthleteSocialLinksCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PlatformAsc = "platform_ASC",
  PlatformDesc = "platform_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type Campaign = Entry &
  _Node & {
    __typename?: "Campaign";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<CampaignLinkingCollections>;
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type CampaignEndDateArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type CampaignInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type CampaignLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type CampaignStartDateArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/campaign) */
export type CampaignTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CampaignCollection = {
  __typename?: "CampaignCollection";
  items: Array<Maybe<Campaign>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type CampaignCursorCollection = {
  __typename?: "CampaignCursorCollection";
  items: Array<Maybe<Campaign>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type CampaignFilter = {
  AND?: InputMaybe<Array<InputMaybe<CampaignFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  endDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  startDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CampaignLinkingCollections = {
  __typename?: "CampaignLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type CampaignLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CampaignLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CampaignOrder {
  EndDateAsc = "endDate_ASC",
  EndDateDesc = "endDate_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  StartDateAsc = "startDate_ASC",
  StartDateDesc = "startDate_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type Catalog = Entry &
  _Node & {
    __typename?: "Catalog";
    _id: Scalars["ID"]["output"];
    catalogId?: Maybe<Scalars["String"]["output"]>;
    catalogName?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    image?: Maybe<Image>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<CatalogLinkingCollections>;
    logo?: Maybe<Image>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    video?: Maybe<Video>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogCatalogIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogCatalogNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogLogoArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/catalog) */
export type CatalogVideoArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<VideoFilter>;
};

export type CatalogCollection = {
  __typename?: "CatalogCollection";
  items: Array<Maybe<Catalog>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type CatalogCursorCollection = {
  __typename?: "CatalogCursorCollection";
  items: Array<Maybe<Catalog>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type CatalogFilter = {
  AND?: InputMaybe<Array<InputMaybe<CatalogFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CatalogFilter>>>;
  catalogId?: InputMaybe<Scalars["String"]["input"]>;
  catalogId_contains?: InputMaybe<Scalars["String"]["input"]>;
  catalogId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  catalogId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  catalogId_not?: InputMaybe<Scalars["String"]["input"]>;
  catalogId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  catalogId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  catalogName?: InputMaybe<Scalars["String"]["input"]>;
  catalogName_contains?: InputMaybe<Scalars["String"]["input"]>;
  catalogName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  catalogName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  catalogName_not?: InputMaybe<Scalars["String"]["input"]>;
  catalogName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  catalogName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  image?: InputMaybe<CfImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  logo?: InputMaybe<CfImageNestedFilter>;
  logo_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  video?: InputMaybe<CfVideoNestedFilter>;
  video_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollections = {
  __typename?: "CatalogLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type CatalogLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CatalogLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CatalogLinkingCollectionsListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum CatalogLinkingCollectionsListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum CatalogLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CatalogLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CatalogLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CatalogLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CatalogOrder {
  CatalogIdAsc = "catalogId_ASC",
  CatalogIdDesc = "catalogId_DESC",
  CatalogNameAsc = "catalogName_ASC",
  CatalogNameDesc = "catalogName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichment = Entry &
  _Node & {
    __typename?: "CategoryEnrichment";
    _id: Scalars["ID"]["output"];
    categoryCode?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    contentfulMetadata: ContentfulMetadata;
    firstContent?: Maybe<CategoryEnrichmentFirstContent>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<CategoryEnrichmentLinkingCollections>;
    secondContent?: Maybe<CategoryEnrichmentSecondContent>;
    sys: Sys;
    thirdContent?: Maybe<CategoryEnrichmentThirdContent>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentCategoryCodeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentFirstContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentSecondContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/categoryEnrichment) */
export type CategoryEnrichmentThirdContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CategoryEnrichmentCollection = {
  __typename?: "CategoryEnrichmentCollection";
  items: Array<Maybe<CategoryEnrichment>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type CategoryEnrichmentCursorCollection = {
  __typename?: "CategoryEnrichmentCursorCollection";
  items: Array<Maybe<CategoryEnrichment>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type CategoryEnrichmentFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryEnrichmentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryEnrichmentFilter>>>;
  categoryCode_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  categoryCode_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  categoryCode_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  categoryCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  secondContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  thirdContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CategoryEnrichmentFirstContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

export type CategoryEnrichmentLinkingCollections = {
  __typename?: "CategoryEnrichmentLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type CategoryEnrichmentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CategoryEnrichmentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CategoryEnrichmentOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type CategoryEnrichmentSecondContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

export type CategoryEnrichmentThirdContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type Collection = Entry &
  _Node & {
    __typename?: "Collection";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    image?: Maybe<Image>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<CollectionLinkingCollections>;
    name?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type CollectionDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type CollectionImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type CollectionInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type CollectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/collection) */
export type CollectionNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionCollection = {
  __typename?: "CollectionCollection";
  items: Array<Maybe<Collection>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type CollectionCursorCollection = {
  __typename?: "CollectionCursorCollection";
  items: Array<Maybe<Collection>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type CollectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CollectionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  image?: InputMaybe<CfImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name_not?: InputMaybe<Scalars["String"]["input"]>;
  name_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CollectionLinkingCollections = {
  __typename?: "CollectionLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type CollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CollectionLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CollectionLinkingCollectionsListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum CollectionLinkingCollectionsListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum CollectionLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CollectionLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CollectionLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CollectionLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum CollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type Config = Entry &
  _Node & {
    __typename?: "Config";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ConfigLinkingCollections>;
    slugCollectionPage?: Maybe<Scalars["String"]["output"]>;
    slugDashboardPage?: Maybe<Scalars["String"]["output"]>;
    slugProductDetailPage?: Maybe<Scalars["String"]["output"]>;
    slugProductListingPage?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigSlugCollectionPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigSlugDashboardPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigSlugProductDetailPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/config) */
export type ConfigSlugProductListingPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfigCollection = {
  __typename?: "ConfigCollection";
  items: Array<Maybe<Config>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ConfigCursorCollection = {
  __typename?: "ConfigCursorCollection";
  items: Array<Maybe<Config>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ConfigFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConfigFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConfigFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugCollectionPage?: InputMaybe<Scalars["String"]["input"]>;
  slugCollectionPage_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugCollectionPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slugCollectionPage_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugCollectionPage_not?: InputMaybe<Scalars["String"]["input"]>;
  slugCollectionPage_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugCollectionPage_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugDashboardPage?: InputMaybe<Scalars["String"]["input"]>;
  slugDashboardPage_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugDashboardPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slugDashboardPage_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugDashboardPage_not?: InputMaybe<Scalars["String"]["input"]>;
  slugDashboardPage_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugDashboardPage_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugProductDetailPage?: InputMaybe<Scalars["String"]["input"]>;
  slugProductDetailPage_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugProductDetailPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slugProductDetailPage_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugProductDetailPage_not?: InputMaybe<Scalars["String"]["input"]>;
  slugProductDetailPage_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugProductDetailPage_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugProductListingPage?: InputMaybe<Scalars["String"]["input"]>;
  slugProductListingPage_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugProductListingPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slugProductListingPage_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slugProductListingPage_not?: InputMaybe<Scalars["String"]["input"]>;
  slugProductListingPage_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slugProductListingPage_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ConfigLinkingCollections = {
  __typename?: "ConfigLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ConfigLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfigLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ConfigOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugCollectionPageAsc = "slugCollectionPage_ASC",
  SlugCollectionPageDesc = "slugCollectionPage_DESC",
  SlugDashboardPageAsc = "slugDashboardPage_ASC",
  SlugDashboardPageDesc = "slugDashboardPage_DESC",
  SlugProductDetailPageAsc = "slugProductDetailPage_ASC",
  SlugProductDetailPageDesc = "slugProductDetailPage_DESC",
  SlugProductListingPageAsc = "slugProductListingPage_ASC",
  SlugProductListingPageDesc = "slugProductListingPage_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItem = Entry &
  _Node & {
    __typename?: "ContentItem";
    _id: Scalars["ID"]["output"];
    backgroundImage?: Maybe<Image>;
    body?: Maybe<ContentItemBody>;
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    image?: Maybe<Image>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ContentItemLinkingCollections>;
    linksCollection?: Maybe<ContentItemLinksCollection>;
    linksCursorCollection?: Maybe<ContentItemLinksCursorCollection>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemBackgroundImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemBodyArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemLinksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentItem) */
export type ContentItemTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemBody = {
  __typename?: "ContentItemBody";
  json: Scalars["JSON"]["output"];
  links: ContentItemBodyLinks;
};

export type ContentItemBodyAssets = {
  __typename?: "ContentItemBodyAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentItemBodyEntries = {
  __typename?: "ContentItemBodyEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentItemBodyLinks = {
  __typename?: "ContentItemBodyLinks";
  assets: ContentItemBodyAssets;
  entries: ContentItemBodyEntries;
  resources: ContentItemBodyResources;
};

export type ContentItemBodyResources = {
  __typename?: "ContentItemBodyResources";
  block: Array<ContentItemBodyResourcesBlock>;
  hyperlink: Array<ContentItemBodyResourcesHyperlink>;
  inline: Array<ContentItemBodyResourcesInline>;
};

export type ContentItemBodyResourcesBlock = ResourceLink & {
  __typename?: "ContentItemBodyResourcesBlock";
  sys: ResourceSys;
};

export type ContentItemBodyResourcesHyperlink = ResourceLink & {
  __typename?: "ContentItemBodyResourcesHyperlink";
  sys: ResourceSys;
};

export type ContentItemBodyResourcesInline = ResourceLink & {
  __typename?: "ContentItemBodyResourcesInline";
  sys: ResourceSys;
};

export type ContentItemCollection = {
  __typename?: "ContentItemCollection";
  items: Array<Maybe<ContentItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ContentItemCursorCollection = {
  __typename?: "ContentItemCursorCollection";
  items: Array<Maybe<ContentItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ContentItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentItemFilter>>>;
  backgroundImage?: InputMaybe<CfImageNestedFilter>;
  backgroundImage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  body_contains?: InputMaybe<Scalars["String"]["input"]>;
  body_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  body_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  image?: InputMaybe<CfImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  links?: InputMaybe<CfLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ContentItemLinkingCollections = {
  __typename?: "ContentItemLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type ContentItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentItemLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ContentItemLinkingCollectionsListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentItemLinkingCollectionsListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentItemLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ContentItemLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ContentItemLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ContentItemLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export type ContentItemLinksCollection = {
  __typename?: "ContentItemLinksCollection";
  items: Array<Maybe<Link>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum ContentItemLinksCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export type ContentItemLinksCursorCollection = {
  __typename?: "ContentItemLinksCursorCollection";
  items: Array<Maybe<Link>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum ContentItemLinksCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export enum ContentItemOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPage = Entry &
  _Node & {
    __typename?: "ContentPage";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ContentPageLinkingCollections>;
    microcopiesCollection?: Maybe<ContentPageMicrocopiesCollection>;
    microcopiesCursorCollection?: Maybe<ContentPageMicrocopiesCursorCollection>;
    pageType?: Maybe<Scalars["String"]["output"]>;
    primaryTopic?: Maybe<ContentPagePrimaryTopic>;
    sectionsCollection?: Maybe<ContentPageSectionsCollection>;
    sectionsCursorCollection?: Maybe<ContentPageSectionsCursorCollection>;
    seoMetadata?: Maybe<Seo>;
    slug?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageMicrocopiesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageMicrocopiesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageMicrocopiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageMicrocopiesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPagePageTypeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPagePrimaryTopicArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentPageSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageSectionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentPageSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageSeoMetadataArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SeoFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageSlugArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentPage) */
export type ContentPageTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentPageCollection = {
  __typename?: "ContentPageCollection";
  items: Array<Maybe<ContentPage>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ContentPageCursorCollection = {
  __typename?: "ContentPageCursorCollection";
  items: Array<Maybe<ContentPage>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ContentPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentPageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopies?: InputMaybe<CfMicrocopyItemNestedFilter>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageType?: InputMaybe<Scalars["String"]["input"]>;
  pageType_contains?: InputMaybe<Scalars["String"]["input"]>;
  pageType_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageType_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pageType_not?: InputMaybe<Scalars["String"]["input"]>;
  pageType_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  pageType_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  primaryTopic_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sections?: InputMaybe<CfsectionsMultiTypeNestedFilter>;
  sectionsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoMetadata?: InputMaybe<CfSeoNestedFilter>;
  seoMetadata_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  slug_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slug_not?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ContentPageLinkingCollections = {
  __typename?: "ContentPageLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  linkActionCollection?: Maybe<LinkActionCollection>;
  linkActionCursorCollection?: Maybe<LinkActionCursorCollection>;
};

export type ContentPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentPageLinkingCollectionsLinkActionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageLinkingCollectionsLinkActionCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentPageLinkingCollectionsLinkActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageLinkingCollectionsLinkActionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ContentPageLinkingCollectionsLinkActionCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum ContentPageLinkingCollectionsLinkActionCursorCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type ContentPageMicrocopiesCollection = {
  __typename?: "ContentPageMicrocopiesCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum ContentPageMicrocopiesCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ContentPageMicrocopiesCursorCollection = {
  __typename?: "ContentPageMicrocopiesCursorCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum ContentPageMicrocopiesCursorCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ContentPageOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export type ContentPagePrimaryTopic = PrimaryTopicCollection | PrimaryTopicProductCategory | ProductFamily;

export type ContentPageSectionsCollection = {
  __typename?: "ContentPageSectionsCollection";
  items: Array<Maybe<ContentPageSectionsItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ContentPageSectionsCursorCollection = {
  __typename?: "ContentPageSectionsCursorCollection";
  items: Array<Maybe<ContentPageSectionsItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ContentPageSectionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentPageSectionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentPageSectionsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ContentPageSectionsItem =
  | AccordionD2C
  | ContentSliderD2C
  | GeometryTable
  | Hotspot
  | ProductListing
  | SectionClaim
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionIntroText
  | SectionMedia
  | SectionQuote
  | SectionSlider
  | SectionTagline
  | SectionTeaser
  | SectionText
  | SectionTextImage
  | TabContainerD2C;

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2C = Entry &
  _Node & {
    __typename?: "ContentSliderD2C";
    _id: Scalars["ID"]["output"];
    autoplay?: Maybe<Scalars["Boolean"]["output"]>;
    autoplayDuration?: Maybe<Scalars["Int"]["output"]>;
    behavior?: Maybe<Scalars["String"]["output"]>;
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ContentSliderD2CLinkingCollections>;
    navigationLayout?: Maybe<Scalars["String"]["output"]>;
    showNavigationArrows?: Maybe<Scalars["Boolean"]["output"]>;
    slidesCollection?: Maybe<ContentSliderD2CSlidesCollection>;
    slidesCursorCollection?: Maybe<ContentSliderD2CSlidesCursorCollection>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CAutoplayArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CAutoplayDurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CBehaviorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CNavigationLayoutArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CShowNavigationArrowsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CSlidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CSlidesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/contentSliderD2c) */
export type ContentSliderD2CUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type ContentSliderD2CCollection = {
  __typename?: "ContentSliderD2CCollection";
  items: Array<Maybe<ContentSliderD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ContentSliderD2CCursorCollection = {
  __typename?: "ContentSliderD2CCursorCollection";
  items: Array<Maybe<ContentSliderD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ContentSliderD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentSliderD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentSliderD2CFilter>>>;
  autoplay?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration_gt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_gte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplayDuration_lt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_lte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplay_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  behavior?: InputMaybe<Scalars["String"]["input"]>;
  behavior_contains?: InputMaybe<Scalars["String"]["input"]>;
  behavior_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  behavior_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  behavior_not?: InputMaybe<Scalars["String"]["input"]>;
  behavior_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  behavior_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  navigationLayout?: InputMaybe<Scalars["String"]["input"]>;
  navigationLayout_contains?: InputMaybe<Scalars["String"]["input"]>;
  navigationLayout_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationLayout_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  navigationLayout_not?: InputMaybe<Scalars["String"]["input"]>;
  navigationLayout_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  navigationLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  showNavigationArrows?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNavigationArrows_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNavigationArrows_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  slides?: InputMaybe<CfSectionTextImageNestedFilter>;
  slidesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollections = {
  __typename?: "ContentSliderD2CLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
};

export type ContentSliderD2CLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentSliderD2CLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2CLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ContentSliderD2CLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentSliderD2CLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentSliderD2CLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentSliderD2CLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ContentSliderD2COrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BehaviorAsc = "behavior_ASC",
  BehaviorDesc = "behavior_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationLayoutAsc = "navigationLayout_ASC",
  NavigationLayoutDesc = "navigationLayout_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ContentSliderD2CSlidesCollection = {
  __typename?: "ContentSliderD2CSlidesCollection";
  items: Array<Maybe<SectionTextImage>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum ContentSliderD2CSlidesCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ContentSliderD2CSlidesCursorCollection = {
  __typename?: "ContentSliderD2CSlidesCursorCollection";
  items: Array<Maybe<SectionTextImage>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum ContentSliderD2CSlidesCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ContentfulMetadata = {
  __typename?: "ContentfulMetadata";
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: "ContentfulTag";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItem = Entry &
  _Node & {
    __typename?: "CounterItem";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<CounterItemLinkingCollections>;
    prefix?: Maybe<Scalars["String"]["output"]>;
    subline?: Maybe<Scalars["String"]["output"]>;
    suffix?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    value?: Maybe<Scalars["Int"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemPrefixArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemSublineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemSuffixArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/counterItem) */
export type CounterItemValueArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemCollection = {
  __typename?: "CounterItemCollection";
  items: Array<Maybe<CounterItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type CounterItemCursorCollection = {
  __typename?: "CounterItemCursorCollection";
  items: Array<Maybe<CounterItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type CounterItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<CounterItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CounterItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  prefix_contains?: InputMaybe<Scalars["String"]["input"]>;
  prefix_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  prefix_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  prefix_not?: InputMaybe<Scalars["String"]["input"]>;
  prefix_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  prefix_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline?: InputMaybe<Scalars["String"]["input"]>;
  subline_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline_not?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  suffix_contains?: InputMaybe<Scalars["String"]["input"]>;
  suffix_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  suffix_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  suffix_not?: InputMaybe<Scalars["String"]["input"]>;
  suffix_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  suffix_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["Int"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_gt?: InputMaybe<Scalars["Int"]["input"]>;
  value_gte?: InputMaybe<Scalars["Int"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  value_lt?: InputMaybe<Scalars["Int"]["input"]>;
  value_lte?: InputMaybe<Scalars["Int"]["input"]>;
  value_not?: InputMaybe<Scalars["Int"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type CounterItemLinkingCollections = {
  __typename?: "CounterItemLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  sectionCounterCollection?: Maybe<SectionCounterCollection>;
  sectionCounterCursorCollection?: Maybe<SectionCounterCursorCollection>;
};

export type CounterItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemLinkingCollectionsSectionCounterCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemLinkingCollectionsSectionCounterCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CounterItemLinkingCollectionsSectionCounterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemLinkingCollectionsSectionCounterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CounterItemLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum CounterItemLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum CounterItemLinkingCollectionsSectionCounterCollectionOrder {
  FootnoteAsc = "footnote_ASC",
  FootnoteDesc = "footnote_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum CounterItemLinkingCollectionsSectionCounterCursorCollectionOrder {
  FootnoteAsc = "footnote_ASC",
  FootnoteDesc = "footnote_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum CounterItemOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PrefixAsc = "prefix_ASC",
  PrefixDesc = "prefix_DESC",
  SublineAsc = "subline_ASC",
  SublineDesc = "subline_DESC",
  SuffixAsc = "suffix_ASC",
  SuffixDesc = "suffix_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  ValueAsc = "value_ASC",
  ValueDesc = "value_DESC",
}

export type CursorPages = {
  __typename?: "CursorPages";
  next?: Maybe<Scalars["String"]["output"]>;
  prev?: Maybe<Scalars["String"]["output"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigation = Entry &
  _Node & {
    __typename?: "DivisionNavigation";
    _id: Scalars["ID"]["output"];
    ariaLabel?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    divisionsCollection?: Maybe<DivisionNavigationDivisionsCollection>;
    divisionsCursorCollection?: Maybe<DivisionNavigationDivisionsCursorCollection>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<DivisionNavigationLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigationAriaLabelArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigationDivisionsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DivisionNavigationDivisionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigationDivisionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DivisionNavigationDivisionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigationInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/divisionNavigation) */
export type DivisionNavigationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type DivisionNavigationCollection = {
  __typename?: "DivisionNavigationCollection";
  items: Array<Maybe<DivisionNavigation>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type DivisionNavigationCursorCollection = {
  __typename?: "DivisionNavigationCursorCollection";
  items: Array<Maybe<DivisionNavigation>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type DivisionNavigationDivisionsCollection = {
  __typename?: "DivisionNavigationDivisionsCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum DivisionNavigationDivisionsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type DivisionNavigationDivisionsCursorCollection = {
  __typename?: "DivisionNavigationDivisionsCursorCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum DivisionNavigationDivisionsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type DivisionNavigationFilter = {
  AND?: InputMaybe<Array<InputMaybe<DivisionNavigationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DivisionNavigationFilter>>>;
  ariaLabel?: InputMaybe<Scalars["String"]["input"]>;
  ariaLabel_contains?: InputMaybe<Scalars["String"]["input"]>;
  ariaLabel_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ariaLabel_not?: InputMaybe<Scalars["String"]["input"]>;
  ariaLabel_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  divisions?: InputMaybe<CfTeaserItemNestedFilter>;
  divisionsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type DivisionNavigationLinkingCollections = {
  __typename?: "DivisionNavigationLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type DivisionNavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DivisionNavigationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum DivisionNavigationOrder {
  AriaLabelAsc = "ariaLabel_ASC",
  AriaLabelDesc = "ariaLabel_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/document) */
export type Document = Entry &
  _Node & {
    __typename?: "Document";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    document?: Maybe<Scalars["JSON"]["output"]>;
    image?: Maybe<Image>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<DocumentLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/document) */
export type DocumentDocumentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/document) */
export type DocumentImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/document) */
export type DocumentInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/document) */
export type DocumentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type DocumentCollection = {
  __typename?: "DocumentCollection";
  items: Array<Maybe<Document>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type DocumentCursorCollection = {
  __typename?: "DocumentCursorCollection";
  items: Array<Maybe<Document>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type DocumentFilter = {
  AND?: InputMaybe<Array<InputMaybe<DocumentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DocumentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  document_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  image?: InputMaybe<CfImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type DocumentLinkingCollections = {
  __typename?: "DocumentLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type DocumentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DocumentLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum DocumentLinkingCollectionsListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum DocumentLinkingCollectionsListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum DocumentLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum DocumentLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum DocumentLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum DocumentLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum DocumentOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/editorialText) */
export type EditorialText = Entry &
  _Node & {
    __typename?: "EditorialText";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<EditorialTextLinkingCollections>;
    sys: Sys;
    text?: Maybe<EditorialTextText>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/editorialText) */
export type EditorialTextInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/editorialText) */
export type EditorialTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/editorialText) */
export type EditorialTextTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextCollection = {
  __typename?: "EditorialTextCollection";
  items: Array<Maybe<EditorialText>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type EditorialTextCursorCollection = {
  __typename?: "EditorialTextCursorCollection";
  items: Array<Maybe<EditorialText>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type EditorialTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<EditorialTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EditorialTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditorialTextLinkingCollections = {
  __typename?: "EditorialTextLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionIntroTextCollection?: Maybe<SectionIntroTextCollection>;
  sectionIntroTextCursorCollection?: Maybe<SectionIntroTextCursorCollection>;
  sectionTextCollection?: Maybe<SectionTextCollection>;
  sectionTextCursorCollection?: Maybe<SectionTextCursorCollection>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
};

export type EditorialTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionIntroTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionIntroTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionIntroTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionIntroTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionTextImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditorialTextLinkingCollectionsSectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextLinkingCollectionsSectionTextImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum EditorialTextLinkingCollectionsSectionIntroTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum EditorialTextLinkingCollectionsSectionIntroTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum EditorialTextLinkingCollectionsSectionTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum EditorialTextLinkingCollectionsSectionTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum EditorialTextLinkingCollectionsSectionTextImageCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum EditorialTextLinkingCollectionsSectionTextImageCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum EditorialTextOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type EditorialTextText = {
  __typename?: "EditorialTextText";
  json: Scalars["JSON"]["output"];
  links: EditorialTextTextLinks;
};

export type EditorialTextTextAssets = {
  __typename?: "EditorialTextTextAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type EditorialTextTextEntries = {
  __typename?: "EditorialTextTextEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type EditorialTextTextLinks = {
  __typename?: "EditorialTextTextLinks";
  assets: EditorialTextTextAssets;
  entries: EditorialTextTextEntries;
  resources: EditorialTextTextResources;
};

export type EditorialTextTextResources = {
  __typename?: "EditorialTextTextResources";
  block: Array<EditorialTextTextResourcesBlock>;
  hyperlink: Array<EditorialTextTextResourcesHyperlink>;
  inline: Array<EditorialTextTextResourcesInline>;
};

export type EditorialTextTextResourcesBlock = ResourceLink & {
  __typename?: "EditorialTextTextResourcesBlock";
  sys: ResourceSys;
};

export type EditorialTextTextResourcesHyperlink = ResourceLink & {
  __typename?: "EditorialTextTextResourcesHyperlink";
  sys: ResourceSys;
};

export type EditorialTextTextResourcesInline = ResourceLink & {
  __typename?: "EditorialTextTextResourcesInline";
  sys: ResourceSys;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: "EntryCollection";
  items: Array<Maybe<Entry>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type EntryCursorCollection = {
  __typename?: "EntryCursorCollection";
  items: Array<Maybe<Entry>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItem) */
export type GalleryItem = Entry &
  _Node & {
    __typename?: "GalleryItem";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    image?: Maybe<MediaImage>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<GalleryItemLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItem) */
export type GalleryItemImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItem) */
export type GalleryItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItem) */
export type GalleryItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type GalleryItemCollection = {
  __typename?: "GalleryItemCollection";
  items: Array<Maybe<GalleryItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type GalleryItemCursorCollection = {
  __typename?: "GalleryItemCursorCollection";
  items: Array<Maybe<GalleryItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type GalleryItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<GalleryItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GalleryItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image?: InputMaybe<CfMediaImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type GalleryItemLinkingCollections = {
  __typename?: "GalleryItemLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  sectionGalleryCollection?: Maybe<SectionGalleryCollection>;
  sectionGalleryCursorCollection?: Maybe<SectionGalleryCursorCollection>;
};

export type GalleryItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemLinkingCollectionsSectionGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsSectionGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemLinkingCollectionsSectionGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemLinkingCollectionsSectionGalleryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum GalleryItemLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GalleryItemLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GalleryItemLinkingCollectionsSectionGalleryCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum GalleryItemLinkingCollectionsSectionGalleryCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum GalleryItemOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItemWithText) */
export type GalleryItemWithText = Entry &
  _Node & {
    __typename?: "GalleryItemWithText";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    image?: Maybe<MediaImage>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<GalleryItemWithTextLinkingCollections>;
    sys: Sys;
    text?: Maybe<SectionText>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItemWithText) */
export type GalleryItemWithTextImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItemWithText) */
export type GalleryItemWithTextInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItemWithText) */
export type GalleryItemWithTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/galleryItemWithText) */
export type GalleryItemWithTextTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextFilter>;
};

export type GalleryItemWithTextCollection = {
  __typename?: "GalleryItemWithTextCollection";
  items: Array<Maybe<GalleryItemWithText>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type GalleryItemWithTextCursorCollection = {
  __typename?: "GalleryItemWithTextCursorCollection";
  items: Array<Maybe<GalleryItemWithText>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type GalleryItemWithTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<GalleryItemWithTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GalleryItemWithTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image?: InputMaybe<CfMediaImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfSectionTextNestedFilter>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemWithTextLinkingCollections = {
  __typename?: "GalleryItemWithTextLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionGalleryCollection?: Maybe<SectionGalleryCollection>;
  sectionGalleryCursorCollection?: Maybe<SectionGalleryCursorCollection>;
};

export type GalleryItemWithTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemWithTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemWithTextLinkingCollectionsSectionGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemWithTextLinkingCollectionsSectionGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GalleryItemWithTextLinkingCollectionsSectionGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemWithTextLinkingCollectionsSectionGalleryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum GalleryItemWithTextLinkingCollectionsSectionGalleryCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum GalleryItemWithTextLinkingCollectionsSectionGalleryCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum GalleryItemWithTextOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTable = Entry &
  _Node & {
    __typename?: "GeometryTable";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    defaultUnit?: Maybe<Scalars["String"]["output"]>;
    frameSize?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<GeometryTableLinkingCollections>;
    productCodes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    showUnitToggle?: Maybe<Scalars["Boolean"]["output"]>;
    sizesIn?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    uiConfigurationSingle?: Maybe<UiConfiguration>;
    unitInches?: Maybe<Scalars["String"]["output"]>;
    unitMm?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableDefaultUnitArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableFrameSizeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableProductCodesArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableShowUnitToggleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableSizesInArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableUiConfigurationSingleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableUnitInchesArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/geometryTable) */
export type GeometryTableUnitMmArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableCollection = {
  __typename?: "GeometryTableCollection";
  items: Array<Maybe<GeometryTable>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type GeometryTableCursorCollection = {
  __typename?: "GeometryTableCursorCollection";
  items: Array<Maybe<GeometryTable>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type GeometryTableFilter = {
  AND?: InputMaybe<Array<InputMaybe<GeometryTableFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GeometryTableFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultUnit?: InputMaybe<Scalars["String"]["input"]>;
  defaultUnit_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultUnit_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultUnit_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  defaultUnit_not?: InputMaybe<Scalars["String"]["input"]>;
  defaultUnit_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultUnit_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  frameSize?: InputMaybe<Scalars["String"]["input"]>;
  frameSize_contains?: InputMaybe<Scalars["String"]["input"]>;
  frameSize_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  frameSize_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  frameSize_not?: InputMaybe<Scalars["String"]["input"]>;
  frameSize_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  frameSize_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCodes_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCodes_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCodes_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCodes_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showUnitToggle?: InputMaybe<Scalars["Boolean"]["input"]>;
  showUnitToggle_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showUnitToggle_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  sizesIn?: InputMaybe<Scalars["String"]["input"]>;
  sizesIn_contains?: InputMaybe<Scalars["String"]["input"]>;
  sizesIn_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sizesIn_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sizesIn_not?: InputMaybe<Scalars["String"]["input"]>;
  sizesIn_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  sizesIn_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfigurationSingle?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfigurationSingle_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  unitInches?: InputMaybe<Scalars["String"]["input"]>;
  unitInches_contains?: InputMaybe<Scalars["String"]["input"]>;
  unitInches_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  unitInches_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  unitInches_not?: InputMaybe<Scalars["String"]["input"]>;
  unitInches_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  unitInches_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  unitMm?: InputMaybe<Scalars["String"]["input"]>;
  unitMm_contains?: InputMaybe<Scalars["String"]["input"]>;
  unitMm_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  unitMm_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  unitMm_not?: InputMaybe<Scalars["String"]["input"]>;
  unitMm_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  unitMm_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type GeometryTableLinkingCollections = {
  __typename?: "GeometryTableLinkingCollections";
  accordionItemD2CCollection?: Maybe<AccordionItemD2CCollection>;
  accordionItemD2CCursorCollection?: Maybe<AccordionItemD2CCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type GeometryTableLinkingCollectionsAccordionItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsAccordionItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsAccordionItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsAccordionItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GeometryTableLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum GeometryTableLinkingCollectionsAccordionItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GeometryTableLinkingCollectionsAccordionItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GeometryTableLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum GeometryTableLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum GeometryTableLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum GeometryTableLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum GeometryTableLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GeometryTableLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum GeometryTableOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  DefaultUnitAsc = "defaultUnit_ASC",
  DefaultUnitDesc = "defaultUnit_DESC",
  FrameSizeAsc = "frameSize_ASC",
  FrameSizeDesc = "frameSize_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowUnitToggleAsc = "showUnitToggle_ASC",
  ShowUnitToggleDesc = "showUnitToggle_DESC",
  SizesInAsc = "sizesIn_ASC",
  SizesInDesc = "sizesIn_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UnitInchesAsc = "unitInches_ASC",
  UnitInchesDesc = "unitInches_DESC",
  UnitMmAsc = "unitMm_ASC",
  UnitMmDesc = "unitMm_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlock = Entry &
  _Node & {
    __typename?: "HeadlineBlock";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    eyebrow?: Maybe<Scalars["String"]["output"]>;
    headline?: Maybe<HeadlineBlockHeadline>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<HeadlineBlockLinkingCollections>;
    subline?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlockEyebrowArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlockHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlockInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlockLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/headlineBlock) */
export type HeadlineBlockSublineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockCollection = {
  __typename?: "HeadlineBlockCollection";
  items: Array<Maybe<HeadlineBlock>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type HeadlineBlockCursorCollection = {
  __typename?: "HeadlineBlockCursorCollection";
  items: Array<Maybe<HeadlineBlock>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type HeadlineBlockFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeadlineBlockFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeadlineBlockFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrow?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow_not?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline?: InputMaybe<Scalars["String"]["input"]>;
  subline_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline_not?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeadlineBlockHeadline = {
  __typename?: "HeadlineBlockHeadline";
  json: Scalars["JSON"]["output"];
  links: HeadlineBlockHeadlineLinks;
};

export type HeadlineBlockHeadlineAssets = {
  __typename?: "HeadlineBlockHeadlineAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeadlineBlockHeadlineEntries = {
  __typename?: "HeadlineBlockHeadlineEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeadlineBlockHeadlineLinks = {
  __typename?: "HeadlineBlockHeadlineLinks";
  assets: HeadlineBlockHeadlineAssets;
  entries: HeadlineBlockHeadlineEntries;
  resources: HeadlineBlockHeadlineResources;
};

export type HeadlineBlockHeadlineResources = {
  __typename?: "HeadlineBlockHeadlineResources";
  block: Array<HeadlineBlockHeadlineResourcesBlock>;
  hyperlink: Array<HeadlineBlockHeadlineResourcesHyperlink>;
  inline: Array<HeadlineBlockHeadlineResourcesInline>;
};

export type HeadlineBlockHeadlineResourcesBlock = ResourceLink & {
  __typename?: "HeadlineBlockHeadlineResourcesBlock";
  sys: ResourceSys;
};

export type HeadlineBlockHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: "HeadlineBlockHeadlineResourcesHyperlink";
  sys: ResourceSys;
};

export type HeadlineBlockHeadlineResourcesInline = ResourceLink & {
  __typename?: "HeadlineBlockHeadlineResourcesInline";
  sys: ResourceSys;
};

export type HeadlineBlockLinkingCollections = {
  __typename?: "HeadlineBlockLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionGalleryCollection?: Maybe<SectionGalleryCollection>;
  sectionGalleryCursorCollection?: Maybe<SectionGalleryCursorCollection>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionIntroTextCollection?: Maybe<SectionIntroTextCollection>;
  sectionIntroTextCursorCollection?: Maybe<SectionIntroTextCursorCollection>;
  sectionMediaCollection?: Maybe<SectionMediaCollection>;
  sectionMediaCursorCollection?: Maybe<SectionMediaCursorCollection>;
  sectionTextCollection?: Maybe<SectionTextCollection>;
  sectionTextCursorCollection?: Maybe<SectionTextCursorCollection>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
};

export type HeadlineBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionGalleryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionIntroTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionIntroTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionIntroTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionIntroTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionTextImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HeadlineBlockLinkingCollectionsSectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockLinkingCollectionsSectionTextImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum HeadlineBlockLinkingCollectionsSectionGalleryCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionGalleryCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionHeroCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionHeroCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionIntroTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionIntroTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionMediaCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionMediaCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionTextImageCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HeadlineBlockLinkingCollectionsSectionTextImageCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HeadlineBlockOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SublineAsc = "subline_ASC",
  SublineDesc = "subline_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePage = Entry &
  _Node & {
    __typename?: "HomePage";
    _id: Scalars["ID"]["output"];
    bottomSectionCollection?: Maybe<HomePageBottomSectionCollection>;
    bottomSectionCursorCollection?: Maybe<HomePageBottomSectionCursorCollection>;
    contentSectionsCollection?: Maybe<HomePageContentSectionsCollection>;
    contentSectionsCursorCollection?: Maybe<HomePageContentSectionsCursorCollection>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    introSectionCollection?: Maybe<HomePageIntroSectionCollection>;
    introSectionCursorCollection?: Maybe<HomePageIntroSectionCursorCollection>;
    linkedFrom?: Maybe<HomePageLinkingCollections>;
    microcopiesCollection?: Maybe<HomePageMicrocopiesCollection>;
    microcopiesCursorCollection?: Maybe<HomePageMicrocopiesCursorCollection>;
    seoMetadata?: Maybe<Seo>;
    slug?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageBottomSectionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageBottomSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTaglineFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageBottomSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageBottomSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTaglineFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageContentSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HomePageContentSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageContentSectionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HomePageContentSectionsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageIntroSectionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageIntroSectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageIntroSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageIntroSectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageMicrocopiesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageMicrocopiesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageMicrocopiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageMicrocopiesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageSeoMetadataArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SeoFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageSlugArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/homePage) */
export type HomePageTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HomePageBottomSectionCollection = {
  __typename?: "HomePageBottomSectionCollection";
  items: Array<Maybe<SectionTagline>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum HomePageBottomSectionCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type HomePageBottomSectionCursorCollection = {
  __typename?: "HomePageBottomSectionCursorCollection";
  items: Array<Maybe<SectionTagline>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum HomePageBottomSectionCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type HomePageCollection = {
  __typename?: "HomePageCollection";
  items: Array<Maybe<HomePage>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type HomePageContentSectionsCollection = {
  __typename?: "HomePageContentSectionsCollection";
  items: Array<Maybe<HomePageContentSectionsItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type HomePageContentSectionsCursorCollection = {
  __typename?: "HomePageContentSectionsCursorCollection";
  items: Array<Maybe<HomePageContentSectionsItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type HomePageContentSectionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<HomePageContentSectionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HomePageContentSectionsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HomePageContentSectionsItem =
  | AccordionD2C
  | ContentSliderD2C
  | GeometryTable
  | Hotspot
  | ProductListing
  | SectionClaim
  | SectionCounter
  | SectionGallery
  | SectionMedia
  | SectionQuote
  | SectionSlider
  | SectionTeaser
  | SectionText
  | SectionTextImage
  | TabContainerD2C;

export type HomePageCursorCollection = {
  __typename?: "HomePageCursorCollection";
  items: Array<Maybe<HomePage>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type HomePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<HomePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HomePageFilter>>>;
  bottomSection?: InputMaybe<CfSectionTaglineNestedFilter>;
  bottomSectionCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentSections?: InputMaybe<CfcontentSectionsMultiTypeNestedFilter>;
  contentSectionsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  introSection?: InputMaybe<CfSectionHeroNestedFilter>;
  introSectionCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  microcopies?: InputMaybe<CfMicrocopyItemNestedFilter>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoMetadata?: InputMaybe<CfSeoNestedFilter>;
  seoMetadata_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  slug_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slug_not?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type HomePageIntroSectionCollection = {
  __typename?: "HomePageIntroSectionCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum HomePageIntroSectionCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export type HomePageIntroSectionCursorCollection = {
  __typename?: "HomePageIntroSectionCursorCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum HomePageIntroSectionCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export type HomePageLinkingCollections = {
  __typename?: "HomePageLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type HomePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HomePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HomePageMicrocopiesCollection = {
  __typename?: "HomePageMicrocopiesCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum HomePageMicrocopiesCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type HomePageMicrocopiesCursorCollection = {
  __typename?: "HomePageMicrocopiesCursorCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum HomePageMicrocopiesCursorCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HomePageOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type Hotspot = Entry &
  _Node & {
    __typename?: "Hotspot";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    fullWidth?: Maybe<Scalars["Boolean"]["output"]>;
    hotspotColor?: Maybe<Scalars["String"]["output"]>;
    hotspots?: Maybe<Scalars["JSON"]["output"]>;
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<HotspotLinkingCollections>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotFullWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotHotspotColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotHotspotsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotImageUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/hotspot) */
export type HotspotUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type HotspotCollection = {
  __typename?: "HotspotCollection";
  items: Array<Maybe<Hotspot>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type HotspotCursorCollection = {
  __typename?: "HotspotCursorCollection";
  items: Array<Maybe<Hotspot>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type HotspotFilter = {
  AND?: InputMaybe<Array<InputMaybe<HotspotFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HotspotFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullWidth?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  hotspotColor?: InputMaybe<Scalars["String"]["input"]>;
  hotspotColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  hotspotColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  hotspotColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hotspotColor_not?: InputMaybe<Scalars["String"]["input"]>;
  hotspotColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  hotspotColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hotspots_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  imageUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollections = {
  __typename?: "HotspotLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type HotspotLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotspotLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum HotspotLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum HotspotLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum HotspotLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum HotspotLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum HotspotLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HotspotLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum HotspotOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  HotspotColorAsc = "hotspotColor_ASC",
  HotspotColorDesc = "hotspotColor_DESC",
  ImageUrlAsc = "imageUrl_ASC",
  ImageUrlDesc = "imageUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type Image = Entry &
  _Node & {
    __typename?: "Image";
    _id: Scalars["ID"]["output"];
    alternativeText?: Maybe<Scalars["String"]["output"]>;
    caption?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    image?: Maybe<Scalars["JSON"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ImageLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type ImageAlternativeTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type ImageCaptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type ImageImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type ImageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/image) */
export type ImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ImageCollection = {
  __typename?: "ImageCollection";
  items: Array<Maybe<Image>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ImageCursorCollection = {
  __typename?: "ImageCursorCollection";
  items: Array<Maybe<Image>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageFilter>>>;
  alternativeText?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  alternativeText_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  alternativeText_not?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export enum ImageFormat {
  /** AVIF image format. */
  Avif = "AVIF",
  /** JPG image format. */
  Jpg = "JPG",
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = "JPG_PROGRESSIVE",
  /** PNG image format */
  Png = "PNG",
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = "PNG8",
  /** WebP image format. */
  Webp = "WEBP",
}

export type ImageLinkingCollections = {
  __typename?: "ImageLinkingCollections";
  catalogCollection?: Maybe<CatalogCollection>;
  catalogCursorCollection?: Maybe<CatalogCursorCollection>;
  collectionCollection?: Maybe<CollectionCollection>;
  collectionCursorCollection?: Maybe<CollectionCursorCollection>;
  contentItemCollection?: Maybe<ContentItemCollection>;
  contentItemCursorCollection?: Maybe<ContentItemCursorCollection>;
  documentCollection?: Maybe<DocumentCollection>;
  documentCursorCollection?: Maybe<DocumentCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
};

export type ImageLinkingCollectionsCatalogCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsCatalogCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsCatalogCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsCatalogCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsCollectionCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsCollectionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsContentItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsContentItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsContentItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsContentItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsDocumentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsDocumentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsDocumentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsDocumentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsProductCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsProductCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImageLinkingCollectionsProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageLinkingCollectionsProductCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ImageLinkingCollectionsCatalogCollectionOrder {
  CatalogIdAsc = "catalogId_ASC",
  CatalogIdDesc = "catalogId_DESC",
  CatalogNameAsc = "catalogName_ASC",
  CatalogNameDesc = "catalogName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ImageLinkingCollectionsCatalogCursorCollectionOrder {
  CatalogIdAsc = "catalogId_ASC",
  CatalogIdDesc = "catalogId_DESC",
  CatalogNameAsc = "catalogName_ASC",
  CatalogNameDesc = "catalogName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ImageLinkingCollectionsCollectionCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageLinkingCollectionsCollectionCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageLinkingCollectionsContentItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ImageLinkingCollectionsContentItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ImageLinkingCollectionsDocumentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageLinkingCollectionsDocumentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageLinkingCollectionsProductCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageLinkingCollectionsProductCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageOrder {
  AlternativeTextAsc = "alternativeText_ASC",
  AlternativeTextDesc = "alternativeText_DESC",
  CaptionAsc = "caption_ASC",
  CaptionDesc = "caption_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = "BOTTOM",
  /** Focus the resizing on the bottom left. */
  BottomLeft = "BOTTOM_LEFT",
  /** Focus the resizing on the bottom right. */
  BottomRight = "BOTTOM_RIGHT",
  /** Focus the resizing on the center. */
  Center = "CENTER",
  /** Focus the resizing on the largest face. */
  Face = "FACE",
  /** Focus the resizing on the area containing all the faces. */
  Faces = "FACES",
  /** Focus the resizing on the left. */
  Left = "LEFT",
  /** Focus the resizing on the right. */
  Right = "RIGHT",
  /** Focus the resizing on the top. */
  Top = "TOP",
  /** Focus the resizing on the top left. */
  TopLeft = "TOP_LEFT",
  /** Focus the resizing on the top right. */
  TopRight = "TOP_RIGHT",
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = "CROP",
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = "FILL",
  /** Resizes the image to fit into the specified dimensions. */
  Fit = "FIT",
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = "PAD",
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = "SCALE",
  /** Creates a thumbnail from the image. */
  Thumb = "THUMB",
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars["HexColor"]["input"]>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars["Int"]["input"]>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars["Dimension"]["input"]>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars["Quality"]["input"]>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars["Dimension"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type Link = Entry &
  _Node & {
    __typename?: "Link";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<LinkLinkingCollections>;
    page?: Maybe<Page>;
    sys: Sys;
    text?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type LinkInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type LinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type LinkPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type LinkTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/link) */
export type LinkUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkAction = Entry &
  _Node & {
    __typename?: "LinkAction";
    _id: Scalars["ID"]["output"];
    anchor?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    externalUrl?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    internalPage?: Maybe<ContentPage>;
    linkedFrom?: Maybe<LinkActionLinkingCollections>;
    microcopy?: Maybe<MicrocopyItem>;
    sys: Sys;
    target?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
    variant?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionAnchorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionExternalUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionInternalPageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentPageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionMicrocopyArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionTargetArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/linkAction) */
export type LinkActionVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionCollection = {
  __typename?: "LinkActionCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type LinkActionCursorCollection = {
  __typename?: "LinkActionCursorCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type LinkActionFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkActionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkActionFilter>>>;
  anchor?: InputMaybe<Scalars["String"]["input"]>;
  anchor_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchor_not?: InputMaybe<Scalars["String"]["input"]>;
  anchor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  externalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalPage?: InputMaybe<CfContentPageNestedFilter>;
  internalPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  microcopy?: InputMaybe<CfMicrocopyItemNestedFilter>;
  microcopy_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  target?: InputMaybe<Scalars["String"]["input"]>;
  target_contains?: InputMaybe<Scalars["String"]["input"]>;
  target_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  target_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  target_not?: InputMaybe<Scalars["String"]["input"]>;
  target_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant?: InputMaybe<Scalars["String"]["input"]>;
  variant_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant_not?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LinkActionLinkingCollections = {
  __typename?: "LinkActionLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationColumnD2CCollection?: Maybe<NavigationColumnD2CCollection>;
  navigationColumnD2CCursorCollection?: Maybe<NavigationColumnD2CCursorCollection>;
  navigationD2CCollection?: Maybe<NavigationD2CCollection>;
  navigationD2CCursorCollection?: Maybe<NavigationD2CCursorCollection>;
  navigationItemD2CCollection?: Maybe<NavigationItemD2CCollection>;
  navigationItemD2CCursorCollection?: Maybe<NavigationItemD2CCursorCollection>;
  navigationLinkItemD2CCollection?: Maybe<NavigationLinkItemD2CCollection>;
  navigationLinkItemD2CCursorCollection?: Maybe<NavigationLinkItemD2CCursorCollection>;
  navigationMegaMenuD2CCollection?: Maybe<NavigationMegaMenuD2CCollection>;
  navigationMegaMenuD2CCursorCollection?: Maybe<NavigationMegaMenuD2CCursorCollection>;
  navigationTeaserD2CCollection?: Maybe<NavigationTeaserD2CCollection>;
  navigationTeaserD2CCursorCollection?: Maybe<NavigationTeaserD2CCursorCollection>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  teaserItemCursorCollection?: Maybe<TeaserItemCursorCollection>;
};

export type LinkActionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationColumnD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationColumnD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationColumnD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationColumnD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationLinkItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationLinkItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationLinkItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationLinkItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationMegaMenuD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationMegaMenuD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationMegaMenuD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationTeaserD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationTeaserD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsNavigationTeaserD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsNavigationTeaserD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsSectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsSectionHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsSectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsSectionHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsSectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsSectionTextImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsSectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsSectionTextImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkActionLinkingCollectionsTeaserItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionLinkingCollectionsTeaserItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum LinkActionLinkingCollectionsNavigationColumnD2CCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationColumnD2CCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationLinkItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationLinkItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationMegaMenuD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationTeaserD2CCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsNavigationTeaserD2CCursorCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsSectionHeroCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum LinkActionLinkingCollectionsSectionHeroCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum LinkActionLinkingCollectionsSectionTextImageCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsSectionTextImageCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsTeaserItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionLinkingCollectionsTeaserItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum LinkActionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type LinkCollection = {
  __typename?: "LinkCollection";
  items: Array<Maybe<Link>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type LinkCursorCollection = {
  __typename?: "LinkCursorCollection";
  items: Array<Maybe<Link>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type LinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  page?: InputMaybe<CfPageNestedFilter>;
  page_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  url_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url_not?: InputMaybe<Scalars["String"]["input"]>;
  url_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type LinkLinkingCollections = {
  __typename?: "LinkLinkingCollections";
  contentItemCollection?: Maybe<ContentItemCollection>;
  contentItemCursorCollection?: Maybe<ContentItemCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type LinkLinkingCollectionsContentItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsContentItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkLinkingCollectionsContentItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsContentItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum LinkLinkingCollectionsContentItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum LinkLinkingCollectionsContentItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum LinkLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum LinkLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum LinkOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type List = Entry &
  _Node & {
    __typename?: "List";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    entriesCollection?: Maybe<ListEntriesCollection>;
    entriesCursorCollection?: Maybe<ListEntriesCursorCollection>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ListLinkingCollections>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type ListEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ListEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type ListEntriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ListEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type ListInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type ListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/list) */
export type ListTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListCollection = {
  __typename?: "ListCollection";
  items: Array<Maybe<List>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ListCursorCollection = {
  __typename?: "ListCursorCollection";
  items: Array<Maybe<List>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ListEntriesCollection = {
  __typename?: "ListEntriesCollection";
  items: Array<Maybe<ListEntriesItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ListEntriesCursorCollection = {
  __typename?: "ListEntriesCursorCollection";
  items: Array<Maybe<ListEntriesItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ListEntriesFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListEntriesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListEntriesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ListEntriesItem = Catalog | Collection | ContentItem | Document | Product;

export type ListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  entries?: InputMaybe<CfentriesMultiTypeNestedFilter>;
  entriesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ListLinkingCollections = {
  __typename?: "ListLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type ListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ListLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ListLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ListLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ListLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ListOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImage = Entry &
  _Node & {
    __typename?: "MediaImage";
    _id: Scalars["ID"]["output"];
    alternativeText?: Maybe<Scalars["String"]["output"]>;
    caption?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    hasFocalPoint?: Maybe<Scalars["Boolean"]["output"]>;
    image?: Maybe<Scalars["JSON"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<MediaImageLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageAlternativeTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageCaptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageHasFocalPointArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaImage) */
export type MediaImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MediaImageCollection = {
  __typename?: "MediaImageCollection";
  items: Array<Maybe<MediaImage>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MediaImageCursorCollection = {
  __typename?: "MediaImageCursorCollection";
  items: Array<Maybe<MediaImage>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type MediaImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaImageFilter>>>;
  alternativeText?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  alternativeText_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  alternativeText_not?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasFocalPoint?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFocalPoint_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFocalPoint_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaImageLinkingCollections = {
  __typename?: "MediaImageLinkingCollections";
  athleteCollection?: Maybe<AthleteCollection>;
  athleteCursorCollection?: Maybe<AthleteCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  galleryItemCollection?: Maybe<GalleryItemCollection>;
  galleryItemCursorCollection?: Maybe<GalleryItemCursorCollection>;
  galleryItemWithTextCollection?: Maybe<GalleryItemWithTextCollection>;
  galleryItemWithTextCursorCollection?: Maybe<GalleryItemWithTextCursorCollection>;
  navigationTeaserD2CCollection?: Maybe<NavigationTeaserD2CCollection>;
  navigationTeaserD2CCursorCollection?: Maybe<NavigationTeaserD2CCursorCollection>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionMediaCollection?: Maybe<SectionMediaCollection>;
  sectionMediaCursorCollection?: Maybe<SectionMediaCursorCollection>;
  sectionQuoteCollection?: Maybe<SectionQuoteCollection>;
  sectionQuoteCursorCollection?: Maybe<SectionQuoteCursorCollection>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
  seoCollection?: Maybe<SeoCollection>;
  seoCursorCollection?: Maybe<SeoCursorCollection>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  teaserItemCursorCollection?: Maybe<TeaserItemCursorCollection>;
};

export type MediaImageLinkingCollectionsAthleteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsAthleteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsAthleteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsAthleteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsGalleryItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsGalleryItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsGalleryItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsGalleryItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsGalleryItemWithTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsGalleryItemWithTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsGalleryItemWithTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsGalleryItemWithTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsNavigationTeaserD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsNavigationTeaserD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsNavigationTeaserD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsNavigationTeaserD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionQuoteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionQuoteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionTextImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSectionTextImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSeoCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSeoCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsSeoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsSeoCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaImageLinkingCollectionsTeaserItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageLinkingCollectionsTeaserItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MediaImageLinkingCollectionsAthleteCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum MediaImageLinkingCollectionsAthleteCursorCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum MediaImageLinkingCollectionsGalleryItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsGalleryItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsGalleryItemWithTextCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsGalleryItemWithTextCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsNavigationTeaserD2CCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsNavigationTeaserD2CCursorCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionHeroCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum MediaImageLinkingCollectionsSectionHeroCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum MediaImageLinkingCollectionsSectionMediaCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionMediaCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionQuoteCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionQuoteCursorCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionTextImageCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSectionTextImageCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsSeoCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  ExcludeLinksFromRankingsNofollowAsc = "excludeLinksFromRankingsNofollow_ASC",
  ExcludeLinksFromRankingsNofollowDesc = "excludeLinksFromRankingsNofollow_DESC",
  HideFromSearchEnginesNoindexAsc = "hideFromSearchEnginesNoindex_ASC",
  HideFromSearchEnginesNoindexDesc = "hideFromSearchEnginesNoindex_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MediaImageLinkingCollectionsSeoCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  ExcludeLinksFromRankingsNofollowAsc = "excludeLinksFromRankingsNofollow_ASC",
  ExcludeLinksFromRankingsNofollowDesc = "excludeLinksFromRankingsNofollow_DESC",
  HideFromSearchEnginesNoindexAsc = "hideFromSearchEnginesNoindex_ASC",
  HideFromSearchEnginesNoindexDesc = "hideFromSearchEnginesNoindex_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MediaImageLinkingCollectionsTeaserItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageLinkingCollectionsTeaserItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaImageOrder {
  AlternativeTextAsc = "alternativeText_ASC",
  AlternativeTextDesc = "alternativeText_DESC",
  CaptionAsc = "caption_ASC",
  CaptionDesc = "caption_DESC",
  HasFocalPointAsc = "hasFocalPoint_ASC",
  HasFocalPointDesc = "hasFocalPoint_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideo = Entry &
  _Node & {
    __typename?: "MediaVideo";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    externalVideoUrl?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<MediaVideoLinkingCollections>;
    poster?: Maybe<Scalars["JSON"]["output"]>;
    sys: Sys;
    video?: Maybe<Scalars["JSON"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideoExternalVideoUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideoInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideoPosterArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/mediaVideo) */
export type MediaVideoVideoArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoCollection = {
  __typename?: "MediaVideoCollection";
  items: Array<Maybe<MediaVideo>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MediaVideoCursorCollection = {
  __typename?: "MediaVideoCursorCollection";
  items: Array<Maybe<MediaVideo>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type MediaVideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaVideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaVideoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalVideoUrl?: InputMaybe<Scalars["String"]["input"]>;
  externalVideoUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalVideoUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  externalVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  externalVideoUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  externalVideoUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  poster_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  video_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollections = {
  __typename?: "MediaVideoLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionMediaCollection?: Maybe<SectionMediaCollection>;
  sectionMediaCursorCollection?: Maybe<SectionMediaCursorCollection>;
};

export type MediaVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollectionsSectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoLinkingCollectionsSectionHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollectionsSectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoLinkingCollectionsSectionHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollectionsSectionMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoLinkingCollectionsSectionMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaVideoLinkingCollectionsSectionMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoLinkingCollectionsSectionMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MediaVideoLinkingCollectionsSectionHeroCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum MediaVideoLinkingCollectionsSectionHeroCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum MediaVideoLinkingCollectionsSectionMediaCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaVideoLinkingCollectionsSectionMediaCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MediaVideoOrder {
  ExternalVideoUrlAsc = "externalVideoUrl_ASC",
  ExternalVideoUrlDesc = "externalVideoUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopy) */
export type Microcopy = Entry &
  _Node & {
    __typename?: "Microcopy";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    key?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<MicrocopyLinkingCollections>;
    sys: Sys;
    value?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopy) */
export type MicrocopyKeyArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopy) */
export type MicrocopyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopy) */
export type MicrocopyValueArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyCollection = {
  __typename?: "MicrocopyCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MicrocopyCursorCollection = {
  __typename?: "MicrocopyCursorCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type MicrocopyFilter = {
  AND?: InputMaybe<Array<InputMaybe<MicrocopyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MicrocopyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_not?: InputMaybe<Scalars["String"]["input"]>;
  key_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  value_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  value_not?: InputMaybe<Scalars["String"]["input"]>;
  value_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopyItem) */
export type MicrocopyItem = Entry &
  _Node & {
    __typename?: "MicrocopyItem";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    key?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<MicrocopyItemLinkingCollections>;
    sys: Sys;
    value?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopyItem) */
export type MicrocopyItemKeyArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopyItem) */
export type MicrocopyItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/microcopyItem) */
export type MicrocopyItemValueArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemCollection = {
  __typename?: "MicrocopyItemCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MicrocopyItemCursorCollection = {
  __typename?: "MicrocopyItemCursorCollection";
  items: Array<Maybe<MicrocopyItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type MicrocopyItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<MicrocopyItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MicrocopyItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_not?: InputMaybe<Scalars["String"]["input"]>;
  key_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  value_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  value_not?: InputMaybe<Scalars["String"]["input"]>;
  value_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MicrocopyItemLinkingCollections = {
  __typename?: "MicrocopyItemLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  linkActionCollection?: Maybe<LinkActionCollection>;
  linkActionCursorCollection?: Maybe<LinkActionCursorCollection>;
};

export type MicrocopyItemLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsLinkActionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsLinkActionCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyItemLinkingCollectionsLinkActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemLinkingCollectionsLinkActionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MicrocopyItemLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MicrocopyItemLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MicrocopyItemLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MicrocopyItemLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum MicrocopyItemLinkingCollectionsLinkActionCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum MicrocopyItemLinkingCollectionsLinkActionCursorCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum MicrocopyItemOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type MicrocopyLinkingCollections = {
  __typename?: "MicrocopyLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type MicrocopyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MicrocopyLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MicrocopyLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MicrocopyLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum MicrocopyLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum MicrocopyLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum MicrocopyLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum MicrocopyLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum MicrocopyOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type Migrations = Entry &
  _Node & {
    __typename?: "Migrations";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<MigrationsLinkingCollections>;
    migrationId?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    status?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type MigrationsExecutedAtArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type MigrationsInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type MigrationsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type MigrationsMigrationIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/migrations) */
export type MigrationsStatusArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MigrationsCollection = {
  __typename?: "MigrationsCollection";
  items: Array<Maybe<Migrations>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type MigrationsCursorCollection = {
  __typename?: "MigrationsCursorCollection";
  items: Array<Maybe<Migrations>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type MigrationsFilter = {
  AND?: InputMaybe<Array<InputMaybe<MigrationsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MigrationsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  executedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  executedAt_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  executedAt_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  executedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  migrationId_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  migrationId_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  migrationId_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  migrationId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  status_contains?: InputMaybe<Scalars["String"]["input"]>;
  status_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status_not?: InputMaybe<Scalars["String"]["input"]>;
  status_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MigrationsLinkingCollections = {
  __typename?: "MigrationsLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type MigrationsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MigrationsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MigrationsOrder {
  ExecutedAtAsc = "executedAt_ASC",
  ExecutedAtDesc = "executedAt_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  StatusAsc = "status_ASC",
  StatusDesc = "status_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2C = Entry &
  _Node & {
    __typename?: "NavigationColumnD2C";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    cta?: Maybe<LinkAction>;
    headline?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<NavigationColumnD2CItemsCollection>;
    itemsCursorCollection?: Maybe<NavigationColumnD2CItemsCursorCollection>;
    linkedFrom?: Maybe<NavigationColumnD2CLinkingCollections>;
    sys: Sys;
    teaser?: Maybe<NavigationTeaserD2C>;
    text?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CCtaArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2CItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2CItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CTeaserArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationColumnD2c) */
export type NavigationColumnD2CTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CCollection = {
  __typename?: "NavigationColumnD2CCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationColumnD2CCursorCollection = {
  __typename?: "NavigationColumnD2CCursorCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationColumnD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationColumnD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationColumnD2CFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfLinkActionNestedFilter>;
  cta_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline?: InputMaybe<Scalars["String"]["input"]>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_not?: InputMaybe<Scalars["String"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfNavigationLinkItemD2CNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfNavigationTeaserD2CNestedFilter>;
  teaser_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NavigationColumnD2CItemsCollection = {
  __typename?: "NavigationColumnD2CItemsCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationColumnD2CItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationColumnD2CItemsCursorCollection = {
  __typename?: "NavigationColumnD2CItemsCursorCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationColumnD2CItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationColumnD2CLinkingCollections = {
  __typename?: "NavigationColumnD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationD2CCollection?: Maybe<NavigationD2CCollection>;
  navigationD2CCursorCollection?: Maybe<NavigationD2CCursorCollection>;
  navigationMegaMenuD2CCollection?: Maybe<NavigationMegaMenuD2CCollection>;
  navigationMegaMenuD2CCursorCollection?: Maybe<NavigationMegaMenuD2CCursorCollection>;
};

export type NavigationColumnD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CLinkingCollectionsNavigationD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2CLinkingCollectionsNavigationD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CLinkingCollectionsNavigationD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2CLinkingCollectionsNavigationD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder>>
  >;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NavigationColumnD2CLinkingCollectionsNavigationD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationColumnD2CLinkingCollectionsNavigationD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationColumnD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationColumnD2COrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2C = Entry &
  _Node & {
    __typename?: "NavigationD2C";
    _id: Scalars["ID"]["output"];
    addressesCollection?: Maybe<NavigationD2CAddressesCollection>;
    addressesCursorCollection?: Maybe<NavigationD2CAddressesCursorCollection>;
    columnsCollection?: Maybe<NavigationD2CColumnsCollection>;
    columnsCursorCollection?: Maybe<NavigationD2CColumnsCursorCollection>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<NavigationD2CLinkingCollections>;
    navigationItemsCollection?: Maybe<NavigationD2CNavigationItemsCollection>;
    navigationItemsCursorCollection?: Maybe<NavigationD2CNavigationItemsCursorCollection>;
    navigationType?: Maybe<Scalars["String"]["output"]>;
    serviceLinksCollection?: Maybe<NavigationD2CServiceLinksCollection>;
    serviceLinksCursorCollection?: Maybe<NavigationD2CServiceLinksCursorCollection>;
    sys: Sys;
    teaser?: Maybe<NavigationTeaserD2C>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CAddressesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CAddressesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CAddressesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CAddressesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CNavigationItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CNavigationItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CNavigationItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CNavigationItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CNavigationTypeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CServiceLinksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CServiceLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CServiceLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2CServiceLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationD2c) */
export type NavigationD2CTeaserArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

export type NavigationD2CAddressesCollection = {
  __typename?: "NavigationD2CAddressesCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationD2CAddressesCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CAddressesCursorCollection = {
  __typename?: "NavigationD2CAddressesCursorCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationD2CAddressesCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CCollection = {
  __typename?: "NavigationD2CCollection";
  items: Array<Maybe<NavigationD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationD2CColumnsCollection = {
  __typename?: "NavigationD2CColumnsCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationD2CColumnsCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CColumnsCursorCollection = {
  __typename?: "NavigationD2CColumnsCursorCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationD2CColumnsCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CCursorCollection = {
  __typename?: "NavigationD2CCursorCollection";
  items: Array<Maybe<NavigationD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationD2CFilter>>>;
  addresses?: InputMaybe<CfNavigationColumnD2CNestedFilter>;
  addressesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  columns?: InputMaybe<CfNavigationColumnD2CNestedFilter>;
  columnsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  navigationItems?: InputMaybe<CfNavigationItemD2CNestedFilter>;
  navigationItemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationType?: InputMaybe<Scalars["String"]["input"]>;
  navigationType_contains?: InputMaybe<Scalars["String"]["input"]>;
  navigationType_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationType_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  navigationType_not?: InputMaybe<Scalars["String"]["input"]>;
  navigationType_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  navigationType_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  serviceLinks?: InputMaybe<CfLinkActionNestedFilter>;
  serviceLinksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfNavigationTeaserD2CNestedFilter>;
  teaser_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationD2CLinkingCollections = {
  __typename?: "NavigationD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type NavigationD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationD2CNavigationItemsCollection = {
  __typename?: "NavigationD2CNavigationItemsCollection";
  items: Array<Maybe<NavigationItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationD2CNavigationItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CNavigationItemsCursorCollection = {
  __typename?: "NavigationD2CNavigationItemsCursorCollection";
  items: Array<Maybe<NavigationItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationD2CNavigationItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationD2CServiceLinksCollection = {
  __typename?: "NavigationD2CServiceLinksCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationD2CServiceLinksCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type NavigationD2CServiceLinksCursorCollection = {
  __typename?: "NavigationD2CServiceLinksCursorCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationD2CServiceLinksCursorCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2C = Entry &
  _Node & {
    __typename?: "NavigationItemD2C";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<LinkAction>;
    linkedFrom?: Maybe<NavigationItemD2CLinkingCollections>;
    megaMenu?: Maybe<NavigationMegaMenuD2C>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2CLabelArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2CLinkArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationItemD2c) */
export type NavigationItemD2CMegaMenuArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationMegaMenuD2CFilter>;
};

export type NavigationItemD2CCollection = {
  __typename?: "NavigationItemD2CCollection";
  items: Array<Maybe<NavigationItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationItemD2CCursorCollection = {
  __typename?: "NavigationItemD2CCursorCollection";
  items: Array<Maybe<NavigationItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationItemD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationItemD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationItemD2CFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link?: InputMaybe<CfLinkActionNestedFilter>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  megaMenu?: InputMaybe<CfNavigationMegaMenuD2CNestedFilter>;
  megaMenu_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationItemD2CLinkingCollections = {
  __typename?: "NavigationItemD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationD2CCollection?: Maybe<NavigationD2CCollection>;
  navigationD2CCursorCollection?: Maybe<NavigationD2CCursorCollection>;
};

export type NavigationItemD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationItemD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationItemD2CLinkingCollectionsNavigationD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationItemD2CLinkingCollectionsNavigationD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationItemD2CLinkingCollectionsNavigationD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationItemD2CLinkingCollectionsNavigationD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NavigationItemD2CLinkingCollectionsNavigationD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationItemD2CLinkingCollectionsNavigationD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationItemD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2C = Entry &
  _Node & {
    __typename?: "NavigationLinkItemD2C";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<LinkAction>;
    linkedFrom?: Maybe<NavigationLinkItemD2CLinkingCollections>;
    subItemsCollection?: Maybe<NavigationLinkItemD2CSubItemsCollection>;
    subItemsCursorCollection?: Maybe<NavigationLinkItemD2CSubItemsCursorCollection>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CLabelArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CLinkArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CSubItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CSubItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationLinkItemD2c) */
export type NavigationLinkItemD2CSubItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CSubItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

export type NavigationLinkItemD2CCollection = {
  __typename?: "NavigationLinkItemD2CCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationLinkItemD2CCursorCollection = {
  __typename?: "NavigationLinkItemD2CCursorCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationLinkItemD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link?: InputMaybe<CfLinkActionNestedFilter>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subItems?: InputMaybe<CfNavigationLinkItemD2CNestedFilter>;
  subItemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationLinkItemD2CLinkingCollections = {
  __typename?: "NavigationLinkItemD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationColumnD2CCollection?: Maybe<NavigationColumnD2CCollection>;
  navigationColumnD2CCursorCollection?: Maybe<NavigationColumnD2CCursorCollection>;
  navigationLinkItemD2CCollection?: Maybe<NavigationLinkItemD2CCollection>;
  navigationLinkItemD2CCursorCollection?: Maybe<NavigationLinkItemD2CCursorCollection>;
};

export type NavigationLinkItemD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationLinkItemD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCursorCollectionOrder>>
  >;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCursorCollectionOrder>>
  >;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationLinkItemD2CLinkingCollectionsNavigationColumnD2CCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationLinkItemD2CLinkingCollectionsNavigationLinkItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationLinkItemD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationLinkItemD2CSubItemsCollection = {
  __typename?: "NavigationLinkItemD2CSubItemsCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationLinkItemD2CSubItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationLinkItemD2CSubItemsCursorCollection = {
  __typename?: "NavigationLinkItemD2CSubItemsCursorCollection";
  items: Array<Maybe<NavigationLinkItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationLinkItemD2CSubItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2C = Entry &
  _Node & {
    __typename?: "NavigationMegaMenuD2C";
    _id: Scalars["ID"]["output"];
    columnsCollection?: Maybe<NavigationMegaMenuD2CColumnsCollection>;
    columnsCursorCollection?: Maybe<NavigationMegaMenuD2CColumnsCursorCollection>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<NavigationMegaMenuD2CLinkingCollections>;
    mobileTeaser?: Maybe<NavigationTeaserD2C>;
    secondaryColumnsCollection?: Maybe<NavigationMegaMenuD2CSecondaryColumnsCollection>;
    secondaryColumnsCursorCollection?: Maybe<NavigationMegaMenuD2CSecondaryColumnsCursorCollection>;
    serviceLinksCollection?: Maybe<NavigationMegaMenuD2CServiceLinksCollection>;
    serviceLinksCursorCollection?: Maybe<NavigationMegaMenuD2CServiceLinksCursorCollection>;
    sys: Sys;
    teasersCollection?: Maybe<NavigationMegaMenuD2CTeasersCollection>;
    teasersCursorCollection?: Maybe<NavigationMegaMenuD2CTeasersCursorCollection>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CMobileTeaserArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CSecondaryColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CSecondaryColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CSecondaryColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CSecondaryColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CServiceLinksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CServiceLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CServiceLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CServiceLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CTeasersCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CTeasersCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationMegaMenuD2c) */
export type NavigationMegaMenuD2CTeasersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CTeasersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

export type NavigationMegaMenuD2CCollection = {
  __typename?: "NavigationMegaMenuD2CCollection";
  items: Array<Maybe<NavigationMegaMenuD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationMegaMenuD2CColumnsCollection = {
  __typename?: "NavigationMegaMenuD2CColumnsCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationMegaMenuD2CColumnsCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CColumnsCursorCollection = {
  __typename?: "NavigationMegaMenuD2CColumnsCursorCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationMegaMenuD2CColumnsCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CCursorCollection = {
  __typename?: "NavigationMegaMenuD2CCursorCollection";
  items: Array<Maybe<NavigationMegaMenuD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationMegaMenuD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CFilter>>>;
  columns?: InputMaybe<CfNavigationColumnD2CNestedFilter>;
  columnsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  mobileTeaser?: InputMaybe<CfNavigationTeaserD2CNestedFilter>;
  mobileTeaser_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  secondaryColumns?: InputMaybe<CfNavigationColumnD2CNestedFilter>;
  secondaryColumnsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceLinks?: InputMaybe<CfLinkActionNestedFilter>;
  serviceLinksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  teasers?: InputMaybe<CfNavigationTeaserD2CNestedFilter>;
  teasersCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationMegaMenuD2CLinkingCollections = {
  __typename?: "NavigationMegaMenuD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationItemD2CCollection?: Maybe<NavigationItemD2CCollection>;
  navigationItemD2CCursorCollection?: Maybe<NavigationItemD2CCursorCollection>;
};

export type NavigationMegaMenuD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationMegaMenuD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationMegaMenuD2CLinkingCollectionsNavigationItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationMegaMenuD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CSecondaryColumnsCollection = {
  __typename?: "NavigationMegaMenuD2CSecondaryColumnsCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationMegaMenuD2CSecondaryColumnsCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CSecondaryColumnsCursorCollection = {
  __typename?: "NavigationMegaMenuD2CSecondaryColumnsCursorCollection";
  items: Array<Maybe<NavigationColumnD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationMegaMenuD2CSecondaryColumnsCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CServiceLinksCollection = {
  __typename?: "NavigationMegaMenuD2CServiceLinksCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationMegaMenuD2CServiceLinksCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type NavigationMegaMenuD2CServiceLinksCursorCollection = {
  __typename?: "NavigationMegaMenuD2CServiceLinksCursorCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationMegaMenuD2CServiceLinksCursorCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type NavigationMegaMenuD2CTeasersCollection = {
  __typename?: "NavigationMegaMenuD2CTeasersCollection";
  items: Array<Maybe<NavigationTeaserD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum NavigationMegaMenuD2CTeasersCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type NavigationMegaMenuD2CTeasersCursorCollection = {
  __typename?: "NavigationMegaMenuD2CTeasersCursorCollection";
  items: Array<Maybe<NavigationTeaserD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum NavigationMegaMenuD2CTeasersCursorCollectionOrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2C = Entry &
  _Node & {
    __typename?: "NavigationTeaserD2C";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    eyebrow?: Maybe<Scalars["String"]["output"]>;
    headline?: Maybe<NavigationTeaserD2CHeadline>;
    image?: Maybe<MediaImage>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<LinkAction>;
    linkedFrom?: Maybe<NavigationTeaserD2CLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CEyebrowArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CLinkArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/navigationTeaserD2c) */
export type NavigationTeaserD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type NavigationTeaserD2CCollection = {
  __typename?: "NavigationTeaserD2CCollection";
  items: Array<Maybe<NavigationTeaserD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type NavigationTeaserD2CCursorCollection = {
  __typename?: "NavigationTeaserD2CCursorCollection";
  items: Array<Maybe<NavigationTeaserD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type NavigationTeaserD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow_not?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<CfMediaImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link?: InputMaybe<CfLinkActionNestedFilter>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationTeaserD2CHeadline = {
  __typename?: "NavigationTeaserD2CHeadline";
  json: Scalars["JSON"]["output"];
  links: NavigationTeaserD2CHeadlineLinks;
};

export type NavigationTeaserD2CHeadlineAssets = {
  __typename?: "NavigationTeaserD2CHeadlineAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NavigationTeaserD2CHeadlineEntries = {
  __typename?: "NavigationTeaserD2CHeadlineEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NavigationTeaserD2CHeadlineLinks = {
  __typename?: "NavigationTeaserD2CHeadlineLinks";
  assets: NavigationTeaserD2CHeadlineAssets;
  entries: NavigationTeaserD2CHeadlineEntries;
  resources: NavigationTeaserD2CHeadlineResources;
};

export type NavigationTeaserD2CHeadlineResources = {
  __typename?: "NavigationTeaserD2CHeadlineResources";
  block: Array<NavigationTeaserD2CHeadlineResourcesBlock>;
  hyperlink: Array<NavigationTeaserD2CHeadlineResourcesHyperlink>;
  inline: Array<NavigationTeaserD2CHeadlineResourcesInline>;
};

export type NavigationTeaserD2CHeadlineResourcesBlock = ResourceLink & {
  __typename?: "NavigationTeaserD2CHeadlineResourcesBlock";
  sys: ResourceSys;
};

export type NavigationTeaserD2CHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: "NavigationTeaserD2CHeadlineResourcesHyperlink";
  sys: ResourceSys;
};

export type NavigationTeaserD2CHeadlineResourcesInline = ResourceLink & {
  __typename?: "NavigationTeaserD2CHeadlineResourcesInline";
  sys: ResourceSys;
};

export type NavigationTeaserD2CLinkingCollections = {
  __typename?: "NavigationTeaserD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationColumnD2CCollection?: Maybe<NavigationColumnD2CCollection>;
  navigationColumnD2CCursorCollection?: Maybe<NavigationColumnD2CCursorCollection>;
  navigationD2CCollection?: Maybe<NavigationD2CCollection>;
  navigationD2CCursorCollection?: Maybe<NavigationD2CCursorCollection>;
  navigationMegaMenuD2CCollection?: Maybe<NavigationMegaMenuD2CCollection>;
  navigationMegaMenuD2CCursorCollection?: Maybe<NavigationMegaMenuD2CCursorCollection>;
};

export type NavigationTeaserD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder>>
  >;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2CLinkingCollectionsNavigationColumnD2CCursorCollectionOrder {
  HeadlineAsc = "headline_ASC",
  HeadlineDesc = "headline_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2CLinkingCollectionsNavigationD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2CLinkingCollectionsNavigationD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationTypeAsc = "navigationType_ASC",
  NavigationTypeDesc = "navigationType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2CLinkingCollectionsNavigationMegaMenuD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum NavigationTeaserD2COrder {
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type Page = Entry &
  _Node & {
    __typename?: "Page";
    _id: Scalars["ID"]["output"];
    bottomContentAreaCollection?: Maybe<PageBottomContentAreaCollection>;
    bottomContentAreaCursorCollection?: Maybe<PageBottomContentAreaCursorCollection>;
    canonicalUrl?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<PageLinkingCollections>;
    microcopiesCollection?: Maybe<PageMicrocopiesCollection>;
    microcopiesCursorCollection?: Maybe<PageMicrocopiesCursorCollection>;
    noIndex?: Maybe<Scalars["Boolean"]["output"]>;
    nofollow?: Maybe<Scalars["Boolean"]["output"]>;
    path?: Maybe<Scalars["String"]["output"]>;
    seoDescription?: Maybe<Scalars["String"]["output"]>;
    seoKeywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    seoTitle?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    topContentAreaCollection?: Maybe<PageTopContentAreaCollection>;
    topContentAreaCursorCollection?: Maybe<PageTopContentAreaCursorCollection>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageBottomContentAreaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageBottomContentAreaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageBottomContentAreaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageBottomContentAreaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageMicrocopiesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageMicrocopiesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageMicrocopiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageMicrocopiesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageNoIndexArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageNofollowArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PagePathArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageSeoDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageSeoKeywordsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageSeoTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageTopContentAreaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageTopContentAreaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/page) */
export type PageTopContentAreaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageTopContentAreaFilter>;
};

export type PageBottomContentAreaCollection = {
  __typename?: "PageBottomContentAreaCollection";
  items: Array<Maybe<PageBottomContentAreaItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageBottomContentAreaCursorCollection = {
  __typename?: "PageBottomContentAreaCursorCollection";
  items: Array<Maybe<PageBottomContentAreaItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageBottomContentAreaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageBottomContentAreaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageBottomContentAreaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  ui?: InputMaybe<Scalars["String"]["input"]>;
  ui_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  ui_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ui_not?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PageBottomContentAreaItem = PageSectionItem | PageSectionList;

export type PageCollection = {
  __typename?: "PageCollection";
  items: Array<Maybe<Page>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageCursorCollection = {
  __typename?: "PageCursorCollection";
  items: Array<Maybe<Page>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  bottomContentArea?: InputMaybe<CfbottomContentAreaMultiTypeNestedFilter>;
  bottomContentAreaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  canonicalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopies?: InputMaybe<CfMicrocopyNestedFilter>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  path_contains?: InputMaybe<Scalars["String"]["input"]>;
  path_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  path_not?: InputMaybe<Scalars["String"]["input"]>;
  path_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoDescription?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoDescription_not?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoTitle?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoTitle_not?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  topContentArea?: InputMaybe<CftopContentAreaMultiTypeNestedFilter>;
  topContentAreaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageLinkingCollections = {
  __typename?: "PageLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  linkCollection?: Maybe<LinkCollection>;
  linkCursorCollection?: Maybe<LinkCursorCollection>;
};

export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageLinkingCollectionsLinkCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageLinkingCollectionsLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum PageLinkingCollectionsLinkCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export enum PageLinkingCollectionsLinkCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export type PageMicrocopiesCollection = {
  __typename?: "PageMicrocopiesCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum PageMicrocopiesCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PageMicrocopiesCursorCollection = {
  __typename?: "PageMicrocopiesCursorCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum PageMicrocopiesCursorCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PageOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItem = Entry &
  _Node & {
    __typename?: "PageSectionItem";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    entry?: Maybe<PageSectionItemEntry>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<PageSectionItemLinkingCollections>;
    microcopiesCollection?: Maybe<PageSectionItemMicrocopiesCollection>;
    microcopiesCursorCollection?: Maybe<PageSectionItemMicrocopiesCursorCollection>;
    sys: Sys;
    ui?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemEntryArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionItemEntryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemMicrocopiesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemMicrocopiesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemMicrocopiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemMicrocopiesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionItem) */
export type PageSectionItemUiArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionItemCollection = {
  __typename?: "PageSectionItemCollection";
  items: Array<Maybe<PageSectionItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageSectionItemCursorCollection = {
  __typename?: "PageSectionItemCursorCollection";
  items: Array<Maybe<PageSectionItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageSectionItemEntry = Catalog | Collection | ContentItem | Document | Product;

export type PageSectionItemEntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageSectionItemEntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageSectionItemEntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageSectionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageSectionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageSectionItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  entry?: InputMaybe<CfentryMultiTypeNestedFilter>;
  entry_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopies?: InputMaybe<CfMicrocopyNestedFilter>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  ui?: InputMaybe<Scalars["String"]["input"]>;
  ui_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  ui_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ui_not?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PageSectionItemLinkingCollections = {
  __typename?: "PageSectionItemLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type PageSectionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionItemLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionItemLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum PageSectionItemLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PageSectionItemLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PageSectionItemMicrocopiesCollection = {
  __typename?: "PageSectionItemMicrocopiesCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum PageSectionItemMicrocopiesCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PageSectionItemMicrocopiesCursorCollection = {
  __typename?: "PageSectionItemMicrocopiesCursorCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum PageSectionItemMicrocopiesCursorCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PageSectionItemOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionList = Entry &
  _Node & {
    __typename?: "PageSectionList";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    entriesCollection?: Maybe<PageSectionListEntriesCollection>;
    entriesCursorCollection?: Maybe<PageSectionListEntriesCursorCollection>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<Link>;
    linkedFrom?: Maybe<PageSectionListLinkingCollections>;
    microcopiesCollection?: Maybe<PageSectionListMicrocopiesCollection>;
    microcopiesCursorCollection?: Maybe<PageSectionListMicrocopiesCursorCollection>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    ui?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionListEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListEntriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionListEntriesFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListLinkArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListMicrocopiesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListMicrocopiesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListMicrocopiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListMicrocopiesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/pageSectionList) */
export type PageSectionListUiArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionListCollection = {
  __typename?: "PageSectionListCollection";
  items: Array<Maybe<PageSectionList>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageSectionListCursorCollection = {
  __typename?: "PageSectionListCursorCollection";
  items: Array<Maybe<PageSectionList>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageSectionListEntriesCollection = {
  __typename?: "PageSectionListEntriesCollection";
  items: Array<Maybe<PageSectionListEntriesItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageSectionListEntriesCursorCollection = {
  __typename?: "PageSectionListEntriesCursorCollection";
  items: Array<Maybe<PageSectionListEntriesItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageSectionListEntriesFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageSectionListEntriesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageSectionListEntriesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageSectionListEntriesItem = Catalog | Collection | ContentItem | Document | List | Product;

export type PageSectionListFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageSectionListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageSectionListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  entries?: InputMaybe<CfentriesMultiTypeNestedFilter>;
  entriesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link?: InputMaybe<CfLinkNestedFilter>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  microcopies?: InputMaybe<CfMicrocopyNestedFilter>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ui?: InputMaybe<Scalars["String"]["input"]>;
  ui_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  ui_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ui_not?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type PageSectionListLinkingCollections = {
  __typename?: "PageSectionListLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type PageSectionListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionListLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PageSectionListLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum PageSectionListLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PageSectionListLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PageSectionListMicrocopiesCollection = {
  __typename?: "PageSectionListMicrocopiesCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum PageSectionListMicrocopiesCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PageSectionListMicrocopiesCursorCollection = {
  __typename?: "PageSectionListMicrocopiesCursorCollection";
  items: Array<Maybe<Microcopy>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum PageSectionListMicrocopiesCursorCollectionOrder {
  KeyAsc = "key_ASC",
  KeyDesc = "key_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PageSectionListOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export type PageTopContentAreaCollection = {
  __typename?: "PageTopContentAreaCollection";
  items: Array<Maybe<PageTopContentAreaItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PageTopContentAreaCursorCollection = {
  __typename?: "PageTopContentAreaCursorCollection";
  items: Array<Maybe<PageTopContentAreaItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PageTopContentAreaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageTopContentAreaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageTopContentAreaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageTopContentAreaItem =
  | AccordionD2C
  | AccordionItemD2C
  | CounterItem
  | GalleryItem
  | GeometryTable
  | Hotspot
  | PageSectionItem
  | PageSectionList
  | ProductListing
  | SectionClaim
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicCollection) */
export type PrimaryTopicCollection = Entry &
  _Node & {
    __typename?: "PrimaryTopicCollection";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<PrimaryTopicCollectionLinkingCollections>;
    name?: Maybe<Scalars["String"]["output"]>;
    pimId?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicCollection) */
export type PrimaryTopicCollectionInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicCollection) */
export type PrimaryTopicCollectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicCollection) */
export type PrimaryTopicCollectionNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicCollection) */
export type PrimaryTopicCollectionPimIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicCollectionCollection = {
  __typename?: "PrimaryTopicCollectionCollection";
  items: Array<Maybe<PrimaryTopicCollection>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PrimaryTopicCollectionCursorCollection = {
  __typename?: "PrimaryTopicCollectionCursorCollection";
  items: Array<Maybe<PrimaryTopicCollection>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PrimaryTopicCollectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name_not?: InputMaybe<Scalars["String"]["input"]>;
  name_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pimId?: InputMaybe<Scalars["String"]["input"]>;
  pimId_contains?: InputMaybe<Scalars["String"]["input"]>;
  pimId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pimId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pimId_not?: InputMaybe<Scalars["String"]["input"]>;
  pimId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  pimId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PrimaryTopicCollectionLinkingCollections = {
  __typename?: "PrimaryTopicCollectionLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type PrimaryTopicCollectionLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicCollectionLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicCollectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum PrimaryTopicCollectionLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum PrimaryTopicCollectionLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum PrimaryTopicCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  PimIdAsc = "pimId_ASC",
  PimIdDesc = "pimId_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategory = Entry &
  _Node & {
    __typename?: "PrimaryTopicProductCategory";
    _id: Scalars["ID"]["output"];
    commerceCategoryId?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    lastImportDate?: Maybe<Scalars["DateTime"]["output"]>;
    linkedFrom?: Maybe<PrimaryTopicProductCategoryLinkingCollections>;
    parentTopicsCollection?: Maybe<PrimaryTopicProductCategoryParentTopicsCollection>;
    parentTopicsCursorCollection?: Maybe<PrimaryTopicProductCategoryParentTopicsCursorCollection>;
    sourceLastModifiedDate?: Maybe<Scalars["DateTime"]["output"]>;
    sourcePlpUrl?: Maybe<Scalars["String"]["output"]>;
    sourceSystemUid?: Maybe<Scalars["Int"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryCommerceCategoryIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryLastImportDateArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryParentTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryParentTopicsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicProductCategoryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategoryParentTopicsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryParentTopicsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicProductCategoryFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategorySourceLastModifiedDateArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategorySourcePlpUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/primaryTopicProductCategory) */
export type PrimaryTopicProductCategorySourceSystemUidArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryCollection = {
  __typename?: "PrimaryTopicProductCategoryCollection";
  items: Array<Maybe<PrimaryTopicProductCategory>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type PrimaryTopicProductCategoryCursorCollection = {
  __typename?: "PrimaryTopicProductCategoryCursorCollection";
  items: Array<Maybe<PrimaryTopicProductCategory>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type PrimaryTopicProductCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryFilter>>>;
  commerceCategoryId?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_contains?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  commerceCategoryId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  commerceCategoryId_not?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastImportDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastImportDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  lastImportDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  parentTopics?: InputMaybe<CfPrimaryTopicProductCategoryNestedFilter>;
  parentTopicsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceLastModifiedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceLastModifiedDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  sourceLastModifiedDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  sourcePlpUrl?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourcePlpUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sourcePlpUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sourceSystemUid?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceSystemUid_gt?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_gte?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sourceSystemUid_lt?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_lte?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_not?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PrimaryTopicProductCategoryLinkingCollections = {
  __typename?: "PrimaryTopicProductCategoryLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  primaryTopicProductCategoryCollection?: Maybe<PrimaryTopicProductCategoryCollection>;
  primaryTopicProductCategoryCursorCollection?: Maybe<PrimaryTopicProductCategoryCursorCollection>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCollectionOrder>>
  >;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<
    Array<InputMaybe<PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCursorCollectionOrder>>
  >;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum PrimaryTopicProductCategoryLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum PrimaryTopicProductCategoryLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCollectionOrder {
  CommerceCategoryIdAsc = "commerceCategoryId_ASC",
  CommerceCategoryIdDesc = "commerceCategoryId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastImportDateAsc = "lastImportDate_ASC",
  LastImportDateDesc = "lastImportDate_DESC",
  SourceLastModifiedDateAsc = "sourceLastModifiedDate_ASC",
  SourceLastModifiedDateDesc = "sourceLastModifiedDate_DESC",
  SourcePlpUrlAsc = "sourcePlpUrl_ASC",
  SourcePlpUrlDesc = "sourcePlpUrl_DESC",
  SourceSystemUidAsc = "sourceSystemUid_ASC",
  SourceSystemUidDesc = "sourceSystemUid_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PrimaryTopicProductCategoryLinkingCollectionsPrimaryTopicProductCategoryCursorCollectionOrder {
  CommerceCategoryIdAsc = "commerceCategoryId_ASC",
  CommerceCategoryIdDesc = "commerceCategoryId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastImportDateAsc = "lastImportDate_ASC",
  LastImportDateDesc = "lastImportDate_DESC",
  SourceLastModifiedDateAsc = "sourceLastModifiedDate_ASC",
  SourceLastModifiedDateDesc = "sourceLastModifiedDate_DESC",
  SourcePlpUrlAsc = "sourcePlpUrl_ASC",
  SourcePlpUrlDesc = "sourcePlpUrl_DESC",
  SourceSystemUidAsc = "sourceSystemUid_ASC",
  SourceSystemUidDesc = "sourceSystemUid_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum PrimaryTopicProductCategoryOrder {
  CommerceCategoryIdAsc = "commerceCategoryId_ASC",
  CommerceCategoryIdDesc = "commerceCategoryId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastImportDateAsc = "lastImportDate_ASC",
  LastImportDateDesc = "lastImportDate_DESC",
  SourceLastModifiedDateAsc = "sourceLastModifiedDate_ASC",
  SourceLastModifiedDateDesc = "sourceLastModifiedDate_DESC",
  SourcePlpUrlAsc = "sourcePlpUrl_ASC",
  SourcePlpUrlDesc = "sourcePlpUrl_DESC",
  SourceSystemUidAsc = "sourceSystemUid_ASC",
  SourceSystemUidDesc = "sourceSystemUid_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PrimaryTopicProductCategoryParentTopicsCollection = {
  __typename?: "PrimaryTopicProductCategoryParentTopicsCollection";
  items: Array<Maybe<PrimaryTopicProductCategory>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum PrimaryTopicProductCategoryParentTopicsCollectionOrder {
  CommerceCategoryIdAsc = "commerceCategoryId_ASC",
  CommerceCategoryIdDesc = "commerceCategoryId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastImportDateAsc = "lastImportDate_ASC",
  LastImportDateDesc = "lastImportDate_DESC",
  SourceLastModifiedDateAsc = "sourceLastModifiedDate_ASC",
  SourceLastModifiedDateDesc = "sourceLastModifiedDate_DESC",
  SourcePlpUrlAsc = "sourcePlpUrl_ASC",
  SourcePlpUrlDesc = "sourcePlpUrl_DESC",
  SourceSystemUidAsc = "sourceSystemUid_ASC",
  SourceSystemUidDesc = "sourceSystemUid_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type PrimaryTopicProductCategoryParentTopicsCursorCollection = {
  __typename?: "PrimaryTopicProductCategoryParentTopicsCursorCollection";
  items: Array<Maybe<PrimaryTopicProductCategory>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum PrimaryTopicProductCategoryParentTopicsCursorCollectionOrder {
  CommerceCategoryIdAsc = "commerceCategoryId_ASC",
  CommerceCategoryIdDesc = "commerceCategoryId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastImportDateAsc = "lastImportDate_ASC",
  LastImportDateDesc = "lastImportDate_DESC",
  SourceLastModifiedDateAsc = "sourceLastModifiedDate_ASC",
  SourceLastModifiedDateDesc = "sourceLastModifiedDate_DESC",
  SourcePlpUrlAsc = "sourcePlpUrl_ASC",
  SourcePlpUrlDesc = "sourcePlpUrl_DESC",
  SourceSystemUidAsc = "sourceSystemUid_ASC",
  SourceSystemUidDesc = "sourceSystemUid_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type Product = Entry &
  _Node & {
    __typename?: "Product";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ProductLinkingCollections>;
    media?: Maybe<ProductMedia>;
    productCode?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type ProductDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type ProductInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type ProductLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type ProductMediaArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/product) */
export type ProductProductCodeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductCollection = {
  __typename?: "ProductCollection";
  items: Array<Maybe<Product>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ProductCursorCollection = {
  __typename?: "ProductCursorCollection";
  items: Array<Maybe<Product>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichment = Entry &
  _Node & {
    __typename?: "ProductEnrichment";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    firstContent?: Maybe<ProductEnrichmentFirstContent>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ProductEnrichmentLinkingCollections>;
    productCode?: Maybe<Scalars["String"]["output"]>;
    secondContent?: Maybe<ProductEnrichmentSecondContent>;
    sys: Sys;
    thirdContent?: Maybe<ProductEnrichmentThirdContent>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentFirstContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentProductCodeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentSecondContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productEnrichment) */
export type ProductEnrichmentThirdContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductEnrichmentCollection = {
  __typename?: "ProductEnrichmentCollection";
  items: Array<Maybe<ProductEnrichment>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ProductEnrichmentCursorCollection = {
  __typename?: "ProductEnrichmentCursorCollection";
  items: Array<Maybe<ProductEnrichment>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ProductEnrichmentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductEnrichmentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductEnrichmentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode?: InputMaybe<Scalars["String"]["input"]>;
  productCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode_not?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  secondContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  thirdContent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductEnrichmentFirstContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

export type ProductEnrichmentLinkingCollections = {
  __typename?: "ProductEnrichmentLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ProductEnrichmentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductEnrichmentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProductEnrichmentOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ProductEnrichmentSecondContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

export type ProductEnrichmentThirdContent =
  | SectionCounter
  | SectionGallery
  | SectionHero
  | SectionMedia
  | SectionQuote
  | SectionTagline
  | SectionText
  | SectionTextImage;

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productFamily) */
export type ProductFamily = Entry &
  _Node & {
    __typename?: "ProductFamily";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ProductFamilyLinkingCollections>;
    name?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productFamily) */
export type ProductFamilyInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productFamily) */
export type ProductFamilyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productFamily) */
export type ProductFamilyNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductFamilyCollection = {
  __typename?: "ProductFamilyCollection";
  items: Array<Maybe<ProductFamily>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ProductFamilyCursorCollection = {
  __typename?: "ProductFamilyCursorCollection";
  items: Array<Maybe<ProductFamily>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ProductFamilyFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFamilyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFamilyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name_not?: InputMaybe<Scalars["String"]["input"]>;
  name_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductFamilyLinkingCollections = {
  __typename?: "ProductFamilyLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ProductFamilyLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductFamilyLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductFamilyLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductFamilyLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductFamilyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductFamilyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProductFamilyLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductFamilyLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductFamilyOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NameAsc = "name_ASC",
  NameDesc = "name_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ProductFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  media_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCode?: InputMaybe<Scalars["String"]["input"]>;
  productCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode_not?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductLinkingCollections = {
  __typename?: "ProductLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
};

export type ProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsPageSectionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsPageSectionItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsPageSectionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductLinkingCollectionsPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsPageSectionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProductLinkingCollectionsListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductLinkingCollectionsListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductLinkingCollectionsPageSectionItemCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ProductLinkingCollectionsPageSectionItemCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ProductLinkingCollectionsPageSectionListCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

export enum ProductLinkingCollectionsPageSectionListCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UiAsc = "ui_ASC",
  UiDesc = "ui_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListItem) */
export type ProductListItem = Entry &
  _Node & {
    __typename?: "ProductListItem";
    _id: Scalars["ID"]["output"];
    colorCode?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ProductListItemLinkingCollections>;
    productCode?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListItem) */
export type ProductListItemColorCodeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListItem) */
export type ProductListItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListItem) */
export type ProductListItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListItem) */
export type ProductListItemProductCodeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListItemCollection = {
  __typename?: "ProductListItemCollection";
  items: Array<Maybe<ProductListItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ProductListItemCursorCollection = {
  __typename?: "ProductListItemCursorCollection";
  items: Array<Maybe<ProductListItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ProductListItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductListItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductListItemFilter>>>;
  colorCode?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  colorCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  colorCode_not?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode?: InputMaybe<Scalars["String"]["input"]>;
  productCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode_not?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductListItemLinkingCollections = {
  __typename?: "ProductListItemLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productListingCollection?: Maybe<ProductListingCollection>;
  productListingCursorCollection?: Maybe<ProductListingCursorCollection>;
};

export type ProductListItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListItemLinkingCollectionsProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListItemLinkingCollectionsProductListingCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListItemLinkingCollectionsProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListItemLinkingCollectionsProductListingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProductListItemLinkingCollectionsProductListingCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum ProductListItemLinkingCollectionsProductListingCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum ProductListItemOrder {
  ColorCodeAsc = "colorCode_ASC",
  ColorCodeDesc = "colorCode_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListing = Entry &
  _Node & {
    __typename?: "ProductListing";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    defaultSort?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ProductListingLinkingCollections>;
    pageSize?: Maybe<Scalars["Int"]["output"]>;
    paginationMode?: Maybe<Scalars["String"]["output"]>;
    productCategory?: Maybe<Scalars["String"]["output"]>;
    searchQuery?: Maybe<Scalars["String"]["output"]>;
    showCarouselNavigationArrows?: Maybe<Scalars["Boolean"]["output"]>;
    showFilters?: Maybe<Scalars["Boolean"]["output"]>;
    showSorting?: Maybe<Scalars["Boolean"]["output"]>;
    specificProductsCollection?: Maybe<ProductListingSpecificProductsCollection>;
    specificProductsCursorCollection?: Maybe<ProductListingSpecificProductsCursorCollection>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
    variant?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingDefaultSortArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingPageSizeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingPaginationModeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingProductCategoryArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingSearchQueryArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingShowCarouselNavigationArrowsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingShowFiltersArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingShowSortingArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingSpecificProductsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingSpecificProductsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingSpecificProductsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingSpecificProductsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/productListing) */
export type ProductListingVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingCollection = {
  __typename?: "ProductListingCollection";
  items: Array<Maybe<ProductListing>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ProductListingCursorCollection = {
  __typename?: "ProductListingCursorCollection";
  items: Array<Maybe<ProductListing>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ProductListingFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductListingFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductListingFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultSort?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultSort_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  defaultSort_not?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageSize_gt?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_gte?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  pageSize_lt?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_lte?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_not?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  paginationMode?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_contains?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paginationMode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paginationMode_not?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCategory?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCategory_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCategory_not?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_contains?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchQuery_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  searchQuery_not?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  showCarouselNavigationArrows?: InputMaybe<Scalars["Boolean"]["input"]>;
  showCarouselNavigationArrows_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showCarouselNavigationArrows_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  specificProducts?: InputMaybe<CfProductListItemNestedFilter>;
  specificProductsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant?: InputMaybe<Scalars["String"]["input"]>;
  variant_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant_not?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ProductListingLinkingCollections = {
  __typename?: "ProductListingLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  tabContainerItemD2CCollection?: Maybe<TabContainerItemD2CCollection>;
  tabContainerItemD2CCursorCollection?: Maybe<TabContainerItemD2CCursorCollection>;
};

export type ProductListingLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsTabContainerItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsTabContainerItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProductListingLinkingCollectionsTabContainerItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingLinkingCollectionsTabContainerItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProductListingLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ProductListingLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum ProductListingLinkingCollectionsTabContainerItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingLinkingCollectionsTabContainerItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum ProductListingOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type ProductListingSpecificProductsCollection = {
  __typename?: "ProductListingSpecificProductsCollection";
  items: Array<Maybe<ProductListItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum ProductListingSpecificProductsCollectionOrder {
  ColorCodeAsc = "colorCode_ASC",
  ColorCodeDesc = "colorCode_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ProductListingSpecificProductsCursorCollection = {
  __typename?: "ProductListingSpecificProductsCursorCollection";
  items: Array<Maybe<ProductListItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum ProductListingSpecificProductsCursorCollectionOrder {
  ColorCodeAsc = "colorCode_ASC",
  ColorCodeDesc = "colorCode_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ProductMedia = Image | Video;

export enum ProductOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type Query = {
  __typename?: "Query";
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  accordionD2C?: Maybe<AccordionD2C>;
  accordionD2CCollection?: Maybe<AccordionD2CCollection>;
  accordionD2CCursorCollection?: Maybe<AccordionD2CCursorCollection>;
  accordionItemD2C?: Maybe<AccordionItemD2C>;
  accordionItemD2CCollection?: Maybe<AccordionItemD2CCollection>;
  accordionItemD2CCursorCollection?: Maybe<AccordionItemD2CCursorCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  assetCursorCollection?: Maybe<AssetCursorCollection>;
  athlete?: Maybe<Athlete>;
  athleteCollection?: Maybe<AthleteCollection>;
  athleteCursorCollection?: Maybe<AthleteCursorCollection>;
  athleteResults?: Maybe<AthleteResults>;
  athleteResultsCollection?: Maybe<AthleteResultsCollection>;
  athleteResultsCursorCollection?: Maybe<AthleteResultsCursorCollection>;
  campaign?: Maybe<Campaign>;
  campaignCollection?: Maybe<CampaignCollection>;
  campaignCursorCollection?: Maybe<CampaignCursorCollection>;
  catalog?: Maybe<Catalog>;
  catalogCollection?: Maybe<CatalogCollection>;
  catalogCursorCollection?: Maybe<CatalogCursorCollection>;
  categoryEnrichment?: Maybe<CategoryEnrichment>;
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  collection?: Maybe<Collection>;
  collectionCollection?: Maybe<CollectionCollection>;
  collectionCursorCollection?: Maybe<CollectionCursorCollection>;
  config?: Maybe<Config>;
  configCollection?: Maybe<ConfigCollection>;
  configCursorCollection?: Maybe<ConfigCursorCollection>;
  contentItem?: Maybe<ContentItem>;
  contentItemCollection?: Maybe<ContentItemCollection>;
  contentItemCursorCollection?: Maybe<ContentItemCursorCollection>;
  contentPage?: Maybe<ContentPage>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  contentSliderD2C?: Maybe<ContentSliderD2C>;
  contentSliderD2CCollection?: Maybe<ContentSliderD2CCollection>;
  contentSliderD2CCursorCollection?: Maybe<ContentSliderD2CCursorCollection>;
  counterItem?: Maybe<CounterItem>;
  counterItemCollection?: Maybe<CounterItemCollection>;
  counterItemCursorCollection?: Maybe<CounterItemCursorCollection>;
  divisionNavigation?: Maybe<DivisionNavigation>;
  divisionNavigationCollection?: Maybe<DivisionNavigationCollection>;
  divisionNavigationCursorCollection?: Maybe<DivisionNavigationCursorCollection>;
  document?: Maybe<Document>;
  documentCollection?: Maybe<DocumentCollection>;
  documentCursorCollection?: Maybe<DocumentCursorCollection>;
  editorialText?: Maybe<EditorialText>;
  editorialTextCollection?: Maybe<EditorialTextCollection>;
  editorialTextCursorCollection?: Maybe<EditorialTextCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  galleryItem?: Maybe<GalleryItem>;
  galleryItemCollection?: Maybe<GalleryItemCollection>;
  galleryItemCursorCollection?: Maybe<GalleryItemCursorCollection>;
  galleryItemWithText?: Maybe<GalleryItemWithText>;
  galleryItemWithTextCollection?: Maybe<GalleryItemWithTextCollection>;
  galleryItemWithTextCursorCollection?: Maybe<GalleryItemWithTextCursorCollection>;
  geometryTable?: Maybe<GeometryTable>;
  geometryTableCollection?: Maybe<GeometryTableCollection>;
  geometryTableCursorCollection?: Maybe<GeometryTableCursorCollection>;
  headlineBlock?: Maybe<HeadlineBlock>;
  headlineBlockCollection?: Maybe<HeadlineBlockCollection>;
  headlineBlockCursorCollection?: Maybe<HeadlineBlockCursorCollection>;
  homePage?: Maybe<HomePage>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  hotspot?: Maybe<Hotspot>;
  hotspotCollection?: Maybe<HotspotCollection>;
  hotspotCursorCollection?: Maybe<HotspotCursorCollection>;
  image?: Maybe<Image>;
  imageCollection?: Maybe<ImageCollection>;
  imageCursorCollection?: Maybe<ImageCursorCollection>;
  link?: Maybe<Link>;
  linkAction?: Maybe<LinkAction>;
  linkActionCollection?: Maybe<LinkActionCollection>;
  linkActionCursorCollection?: Maybe<LinkActionCursorCollection>;
  linkCollection?: Maybe<LinkCollection>;
  linkCursorCollection?: Maybe<LinkCursorCollection>;
  list?: Maybe<List>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  mediaImage?: Maybe<MediaImage>;
  mediaImageCollection?: Maybe<MediaImageCollection>;
  mediaImageCursorCollection?: Maybe<MediaImageCursorCollection>;
  mediaVideo?: Maybe<MediaVideo>;
  mediaVideoCollection?: Maybe<MediaVideoCollection>;
  mediaVideoCursorCollection?: Maybe<MediaVideoCursorCollection>;
  microcopy?: Maybe<Microcopy>;
  microcopyCollection?: Maybe<MicrocopyCollection>;
  microcopyCursorCollection?: Maybe<MicrocopyCursorCollection>;
  microcopyItem?: Maybe<MicrocopyItem>;
  microcopyItemCollection?: Maybe<MicrocopyItemCollection>;
  microcopyItemCursorCollection?: Maybe<MicrocopyItemCursorCollection>;
  migrations?: Maybe<Migrations>;
  migrationsCollection?: Maybe<MigrationsCollection>;
  migrationsCursorCollection?: Maybe<MigrationsCursorCollection>;
  navigationColumnD2C?: Maybe<NavigationColumnD2C>;
  navigationColumnD2CCollection?: Maybe<NavigationColumnD2CCollection>;
  navigationColumnD2CCursorCollection?: Maybe<NavigationColumnD2CCursorCollection>;
  navigationD2C?: Maybe<NavigationD2C>;
  navigationD2CCollection?: Maybe<NavigationD2CCollection>;
  navigationD2CCursorCollection?: Maybe<NavigationD2CCursorCollection>;
  navigationItemD2C?: Maybe<NavigationItemD2C>;
  navigationItemD2CCollection?: Maybe<NavigationItemD2CCollection>;
  navigationItemD2CCursorCollection?: Maybe<NavigationItemD2CCursorCollection>;
  navigationLinkItemD2C?: Maybe<NavigationLinkItemD2C>;
  navigationLinkItemD2CCollection?: Maybe<NavigationLinkItemD2CCollection>;
  navigationLinkItemD2CCursorCollection?: Maybe<NavigationLinkItemD2CCursorCollection>;
  navigationMegaMenuD2C?: Maybe<NavigationMegaMenuD2C>;
  navigationMegaMenuD2CCollection?: Maybe<NavigationMegaMenuD2CCollection>;
  navigationMegaMenuD2CCursorCollection?: Maybe<NavigationMegaMenuD2CCursorCollection>;
  navigationTeaserD2C?: Maybe<NavigationTeaserD2C>;
  navigationTeaserD2CCollection?: Maybe<NavigationTeaserD2CCollection>;
  navigationTeaserD2CCursorCollection?: Maybe<NavigationTeaserD2CCursorCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  pageSectionItem?: Maybe<PageSectionItem>;
  pageSectionItemCollection?: Maybe<PageSectionItemCollection>;
  pageSectionItemCursorCollection?: Maybe<PageSectionItemCursorCollection>;
  pageSectionList?: Maybe<PageSectionList>;
  pageSectionListCollection?: Maybe<PageSectionListCollection>;
  pageSectionListCursorCollection?: Maybe<PageSectionListCursorCollection>;
  primaryTopicCollection?: Maybe<PrimaryTopicCollection>;
  primaryTopicCollectionCollection?: Maybe<PrimaryTopicCollectionCollection>;
  primaryTopicCollectionCursorCollection?: Maybe<PrimaryTopicCollectionCursorCollection>;
  primaryTopicProductCategory?: Maybe<PrimaryTopicProductCategory>;
  primaryTopicProductCategoryCollection?: Maybe<PrimaryTopicProductCategoryCollection>;
  primaryTopicProductCategoryCursorCollection?: Maybe<PrimaryTopicProductCategoryCursorCollection>;
  product?: Maybe<Product>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
  productEnrichment?: Maybe<ProductEnrichment>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
  productFamily?: Maybe<ProductFamily>;
  productFamilyCollection?: Maybe<ProductFamilyCollection>;
  productFamilyCursorCollection?: Maybe<ProductFamilyCursorCollection>;
  productListItem?: Maybe<ProductListItem>;
  productListItemCollection?: Maybe<ProductListItemCollection>;
  productListItemCursorCollection?: Maybe<ProductListItemCursorCollection>;
  productListing?: Maybe<ProductListing>;
  productListingCollection?: Maybe<ProductListingCollection>;
  productListingCursorCollection?: Maybe<ProductListingCursorCollection>;
  sectionClaim?: Maybe<SectionClaim>;
  sectionClaimCollection?: Maybe<SectionClaimCollection>;
  sectionClaimCursorCollection?: Maybe<SectionClaimCursorCollection>;
  sectionCounter?: Maybe<SectionCounter>;
  sectionCounterCollection?: Maybe<SectionCounterCollection>;
  sectionCounterCursorCollection?: Maybe<SectionCounterCursorCollection>;
  sectionGallery?: Maybe<SectionGallery>;
  sectionGalleryCollection?: Maybe<SectionGalleryCollection>;
  sectionGalleryCursorCollection?: Maybe<SectionGalleryCursorCollection>;
  sectionHero?: Maybe<SectionHero>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionIntroText?: Maybe<SectionIntroText>;
  sectionIntroTextCollection?: Maybe<SectionIntroTextCollection>;
  sectionIntroTextCursorCollection?: Maybe<SectionIntroTextCursorCollection>;
  sectionMedia?: Maybe<SectionMedia>;
  sectionMediaCollection?: Maybe<SectionMediaCollection>;
  sectionMediaCursorCollection?: Maybe<SectionMediaCursorCollection>;
  sectionQuote?: Maybe<SectionQuote>;
  sectionQuoteCollection?: Maybe<SectionQuoteCollection>;
  sectionQuoteCursorCollection?: Maybe<SectionQuoteCursorCollection>;
  sectionSlider?: Maybe<SectionSlider>;
  sectionSliderCollection?: Maybe<SectionSliderCollection>;
  sectionSliderCursorCollection?: Maybe<SectionSliderCursorCollection>;
  sectionTagline?: Maybe<SectionTagline>;
  sectionTaglineCollection?: Maybe<SectionTaglineCollection>;
  sectionTaglineCursorCollection?: Maybe<SectionTaglineCursorCollection>;
  sectionTeaser?: Maybe<SectionTeaser>;
  sectionTeaserCollection?: Maybe<SectionTeaserCollection>;
  sectionTeaserCursorCollection?: Maybe<SectionTeaserCursorCollection>;
  sectionText?: Maybe<SectionText>;
  sectionTextCollection?: Maybe<SectionTextCollection>;
  sectionTextCursorCollection?: Maybe<SectionTextCursorCollection>;
  sectionTextImage?: Maybe<SectionTextImage>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
  seo?: Maybe<Seo>;
  seoCollection?: Maybe<SeoCollection>;
  seoCursorCollection?: Maybe<SeoCursorCollection>;
  shippingInfoD2C?: Maybe<ShippingInfoD2C>;
  shippingInfoD2CCollection?: Maybe<ShippingInfoD2CCollection>;
  shippingInfoD2CCursorCollection?: Maybe<ShippingInfoD2CCursorCollection>;
  socialLinks?: Maybe<SocialLinks>;
  socialLinksCollection?: Maybe<SocialLinksCollection>;
  socialLinksCursorCollection?: Maybe<SocialLinksCursorCollection>;
  tabContainerD2C?: Maybe<TabContainerD2C>;
  tabContainerD2CCollection?: Maybe<TabContainerD2CCollection>;
  tabContainerD2CCursorCollection?: Maybe<TabContainerD2CCursorCollection>;
  tabContainerItemD2C?: Maybe<TabContainerItemD2C>;
  tabContainerItemD2CCollection?: Maybe<TabContainerItemD2CCollection>;
  tabContainerItemD2CCursorCollection?: Maybe<TabContainerItemD2CCursorCollection>;
  teaserItem?: Maybe<TeaserItem>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  teaserItemCursorCollection?: Maybe<TeaserItemCursorCollection>;
  uiConfiguration?: Maybe<UiConfiguration>;
  uiConfigurationCollection?: Maybe<UiConfigurationCollection>;
  uiConfigurationCursorCollection?: Maybe<UiConfigurationCursorCollection>;
  video?: Maybe<Video>;
  videoCollection?: Maybe<VideoCollection>;
  videoCursorCollection?: Maybe<VideoCursorCollection>;
};

export type Query_NodeArgs = {
  id: Scalars["ID"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Query_NodesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAccordionD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAccordionD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionD2CFilter>;
};

export type QueryAccordionD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionD2CFilter>;
};

export type QueryAccordionItemD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAccordionItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CFilter>;
};

export type QueryAccordionItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AccordionItemD2CFilter>;
};

export type QueryAssetArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AssetFilter>;
};

export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AssetFilter>;
};

export type QueryAthleteArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAthleteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteFilter>;
};

export type QueryAthleteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteFilter>;
};

export type QueryAthleteResultsArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAthleteResultsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteResultsFilter>;
};

export type QueryAthleteResultsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<AthleteResultsOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteResultsFilter>;
};

export type QueryCampaignArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCampaignCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CampaignOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CampaignFilter>;
};

export type QueryCampaignCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CampaignOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CampaignFilter>;
};

export type QueryCatalogArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCatalogCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CatalogFilter>;
};

export type QueryCatalogCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CatalogOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CatalogFilter>;
};

export type QueryCategoryEnrichmentArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CategoryEnrichmentOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CategoryEnrichmentFilter>;
};

export type QueryCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CategoryEnrichmentOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CategoryEnrichmentFilter>;
};

export type QueryCollectionArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CollectionFilter>;
};

export type QueryCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CollectionFilter>;
};

export type QueryConfigArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryConfigCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ConfigOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ConfigFilter>;
};

export type QueryConfigCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ConfigOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ConfigFilter>;
};

export type QueryContentItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContentItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentItemFilter>;
};

export type QueryContentItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentItemFilter>;
};

export type QueryContentPageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentPageFilter>;
};

export type QueryContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentPageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentPageFilter>;
};

export type QueryContentSliderD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContentSliderD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentSliderD2CFilter>;
};

export type QueryContentSliderD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ContentSliderD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ContentSliderD2CFilter>;
};

export type QueryCounterItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCounterItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CounterItemFilter>;
};

export type QueryCounterItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<CounterItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CounterItemFilter>;
};

export type QueryDivisionNavigationArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryDivisionNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DivisionNavigationOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<DivisionNavigationFilter>;
};

export type QueryDivisionNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DivisionNavigationOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<DivisionNavigationFilter>;
};

export type QueryDocumentArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryDocumentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<DocumentFilter>;
};

export type QueryDocumentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<DocumentOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<DocumentFilter>;
};

export type QueryEditorialTextArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryEditorialTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EditorialTextFilter>;
};

export type QueryEditorialTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EditorialTextOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EditorialTextFilter>;
};

export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EntryFilter>;
};

export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EntryFilter>;
};

export type QueryGalleryItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGalleryItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GalleryItemFilter>;
};

export type QueryGalleryItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GalleryItemFilter>;
};

export type QueryGalleryItemWithTextArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGalleryItemWithTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemWithTextOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GalleryItemWithTextFilter>;
};

export type QueryGalleryItemWithTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GalleryItemWithTextOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GalleryItemWithTextFilter>;
};

export type QueryGeometryTableArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGeometryTableCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GeometryTableFilter>;
};

export type QueryGeometryTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<GeometryTableOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<GeometryTableFilter>;
};

export type QueryHeadlineBlockArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryHeadlineBlockCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

export type QueryHeadlineBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HeadlineBlockOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

export type QueryHomePageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HomePageFilter>;
};

export type QueryHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HomePageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HomePageFilter>;
};

export type QueryHotspotArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryHotspotCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HotspotFilter>;
};

export type QueryHotspotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<HotspotOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HotspotFilter>;
};

export type QueryImageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

export type QueryImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ImageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ImageFilter>;
};

export type QueryLinkArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryLinkActionArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryLinkActionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

export type QueryLinkActionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkActionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

export type QueryLinkCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkFilter>;
};

export type QueryLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkFilter>;
};

export type QueryListArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ListOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ListFilter>;
};

export type QueryListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ListOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ListFilter>;
};

export type QueryMediaImageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMediaImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

export type QueryMediaImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaImageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

export type QueryMediaVideoArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMediaVideoCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaVideoFilter>;
};

export type QueryMediaVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MediaVideoOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaVideoFilter>;
};

export type QueryMicrocopyArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMicrocopyCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

export type QueryMicrocopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyFilter>;
};

export type QueryMicrocopyItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMicrocopyItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

export type QueryMicrocopyItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MicrocopyItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MicrocopyItemFilter>;
};

export type QueryMigrationsArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryMigrationsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MigrationsOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MigrationsFilter>;
};

export type QueryMigrationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<MigrationsOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MigrationsFilter>;
};

export type QueryNavigationColumnD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationColumnD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

export type QueryNavigationColumnD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationColumnD2CFilter>;
};

export type QueryNavigationD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationD2CFilter>;
};

export type QueryNavigationD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationD2CFilter>;
};

export type QueryNavigationItemD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationItemD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationItemD2CFilter>;
};

export type QueryNavigationItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationItemD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationItemD2CFilter>;
};

export type QueryNavigationLinkItemD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationLinkItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

export type QueryNavigationLinkItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkItemD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationLinkItemD2CFilter>;
};

export type QueryNavigationMegaMenuD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationMegaMenuD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationMegaMenuD2CFilter>;
};

export type QueryNavigationMegaMenuD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationMegaMenuD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationMegaMenuD2CFilter>;
};

export type QueryNavigationTeaserD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryNavigationTeaserD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

export type QueryNavigationTeaserD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<NavigationTeaserD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<NavigationTeaserD2CFilter>;
};

export type QueryPageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageFilter>;
};

export type QueryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageFilter>;
};

export type QueryPageSectionItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPageSectionItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionItemFilter>;
};

export type QueryPageSectionItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionItemFilter>;
};

export type QueryPageSectionListArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPageSectionListCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionListFilter>;
};

export type QueryPageSectionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PageSectionListOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PageSectionListFilter>;
};

export type QueryPrimaryTopicCollectionArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPrimaryTopicCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicCollectionFilter>;
};

export type QueryPrimaryTopicCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicCollectionFilter>;
};

export type QueryPrimaryTopicProductCategoryArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPrimaryTopicProductCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicProductCategoryFilter>;
};

export type QueryPrimaryTopicProductCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<PrimaryTopicProductCategoryOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<PrimaryTopicProductCategoryFilter>;
};

export type QueryProductArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryProductCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductFilter>;
};

export type QueryProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductFilter>;
};

export type QueryProductEnrichmentArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductEnrichmentOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductEnrichmentFilter>;
};

export type QueryProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductEnrichmentOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductEnrichmentFilter>;
};

export type QueryProductFamilyArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryProductFamilyCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductFamilyOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductFamilyFilter>;
};

export type QueryProductFamilyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductFamilyOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductFamilyFilter>;
};

export type QueryProductListItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryProductListItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListItemFilter>;
};

export type QueryProductListItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListItemFilter>;
};

export type QueryProductListingArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListingFilter>;
};

export type QueryProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ProductListingOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListingFilter>;
};

export type QuerySectionClaimArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionClaimCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionClaimFilter>;
};

export type QuerySectionClaimCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionClaimFilter>;
};

export type QuerySectionCounterArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionCounterCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionCounterFilter>;
};

export type QuerySectionCounterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionCounterFilter>;
};

export type QuerySectionGalleryArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionGalleryFilter>;
};

export type QuerySectionGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionGalleryFilter>;
};

export type QuerySectionHeroArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

export type QuerySectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

export type QuerySectionIntroTextArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionIntroTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionIntroTextOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionIntroTextFilter>;
};

export type QuerySectionIntroTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionIntroTextOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionIntroTextFilter>;
};

export type QuerySectionMediaArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionMediaFilter>;
};

export type QuerySectionMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionMediaFilter>;
};

export type QuerySectionQuoteArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionQuoteFilter>;
};

export type QuerySectionQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionQuoteFilter>;
};

export type QuerySectionSliderArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionSliderCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionSliderFilter>;
};

export type QuerySectionSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionSliderFilter>;
};

export type QuerySectionTaglineArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionTaglineCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTaglineFilter>;
};

export type QuerySectionTaglineCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTaglineFilter>;
};

export type QuerySectionTeaserArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTeaserFilter>;
};

export type QuerySectionTeaserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTeaserFilter>;
};

export type QuerySectionTextArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextFilter>;
};

export type QuerySectionTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextFilter>;
};

export type QuerySectionTextImageArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextImageFilter>;
};

export type QuerySectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionTextImageFilter>;
};

export type QuerySeoArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySeoCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SeoFilter>;
};

export type QuerySeoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SeoFilter>;
};

export type QueryShippingInfoD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryShippingInfoD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ShippingInfoD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ShippingInfoD2CFilter>;
};

export type QueryShippingInfoD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<ShippingInfoD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ShippingInfoD2CFilter>;
};

export type QuerySocialLinksArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySocialLinksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SocialLinksOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SocialLinksFilter>;
};

export type QuerySocialLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SocialLinksOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SocialLinksFilter>;
};

export type QueryTabContainerD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTabContainerD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerD2CFilter>;
};

export type QueryTabContainerD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerD2CFilter>;
};

export type QueryTabContainerItemD2CArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTabContainerItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2COrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerItemD2CFilter>;
};

export type QueryTabContainerItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2COrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerItemD2CFilter>;
};

export type QueryTeaserItemArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

export type QueryTeaserItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

export type QueryUiConfigurationArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryUiConfigurationCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type QueryUiConfigurationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type QueryVideoArgs = {
  id: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryVideoCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<VideoFilter>;
};

export type QueryVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<VideoFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: "ResourceSys";
  linkType: Scalars["String"]["output"];
  urn: Scalars["String"]["output"];
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaim = Entry &
  _Node & {
    __typename?: "SectionClaim";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    fullWidth?: Maybe<Scalars["Boolean"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionClaimLinkingCollections>;
    offsetLeftPercent?: Maybe<Scalars["Int"]["output"]>;
    sys: Sys;
    text?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimFullWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimOffsetLeftPercentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionClaim) */
export type SectionClaimUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionClaimCollection = {
  __typename?: "SectionClaimCollection";
  items: Array<Maybe<SectionClaim>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionClaimCursorCollection = {
  __typename?: "SectionClaimCursorCollection";
  items: Array<Maybe<SectionClaim>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionClaimFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionClaimFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionClaimFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullWidth?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  offsetLeftPercent?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  offsetLeftPercent_gt?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_gte?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  offsetLeftPercent_lt?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_lte?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_not?: InputMaybe<Scalars["Int"]["input"]>;
  offsetLeftPercent_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollections = {
  __typename?: "SectionClaimLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};

export type SectionClaimLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionClaimLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionClaimLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionClaimLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionClaimLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionClaimLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionClaimLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionClaimLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionClaimLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionClaimOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OffsetLeftPercentAsc = "offsetLeftPercent_ASC",
  OffsetLeftPercentDesc = "offsetLeftPercent_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounter = Entry &
  _Node & {
    __typename?: "SectionCounter";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    footnote?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<SectionCounterItemsCollection>;
    itemsCursorCollection?: Maybe<SectionCounterItemsCursorCollection>;
    linkedFrom?: Maybe<SectionCounterLinkingCollections>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterFootnoteArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CounterItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<CounterItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionCounter) */
export type SectionCounterUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionCounterCollection = {
  __typename?: "SectionCounterCollection";
  items: Array<Maybe<SectionCounter>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionCounterCursorCollection = {
  __typename?: "SectionCounterCursorCollection";
  items: Array<Maybe<SectionCounter>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionCounterFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionCounterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionCounterFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  footnote?: InputMaybe<Scalars["String"]["input"]>;
  footnote_contains?: InputMaybe<Scalars["String"]["input"]>;
  footnote_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  footnote_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  footnote_not?: InputMaybe<Scalars["String"]["input"]>;
  footnote_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  footnote_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfCounterItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterItemsCollection = {
  __typename?: "SectionCounterItemsCollection";
  items: Array<Maybe<CounterItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum SectionCounterItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PrefixAsc = "prefix_ASC",
  PrefixDesc = "prefix_DESC",
  SublineAsc = "subline_ASC",
  SublineDesc = "subline_DESC",
  SuffixAsc = "suffix_ASC",
  SuffixDesc = "suffix_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  ValueAsc = "value_ASC",
  ValueDesc = "value_DESC",
}

export type SectionCounterItemsCursorCollection = {
  __typename?: "SectionCounterItemsCursorCollection";
  items: Array<Maybe<CounterItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum SectionCounterItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PrefixAsc = "prefix_ASC",
  PrefixDesc = "prefix_DESC",
  SublineAsc = "subline_ASC",
  SublineDesc = "subline_DESC",
  SuffixAsc = "suffix_ASC",
  SuffixDesc = "suffix_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  ValueAsc = "value_ASC",
  ValueDesc = "value_DESC",
}

export type SectionCounterLinkingCollections = {
  __typename?: "SectionCounterLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionCounterLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionCounterLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionCounterLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionCounterLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionCounterLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionCounterLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionCounterLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionCounterLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionCounterOrder {
  FootnoteAsc = "footnote_ASC",
  FootnoteDesc = "footnote_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGallery = Entry &
  _Node & {
    __typename?: "SectionGallery";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    fullWidth?: Maybe<Scalars["Boolean"]["output"]>;
    headline?: Maybe<HeadlineBlock>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<SectionGalleryItemsCollection>;
    itemsCursorCollection?: Maybe<SectionGalleryItemsCursorCollection>;
    linkedFrom?: Maybe<SectionGalleryLinkingCollections>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
    variant?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryFullWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionGalleryItemsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionGalleryItemsFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionGallery) */
export type SectionGalleryVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryCollection = {
  __typename?: "SectionGalleryCollection";
  items: Array<Maybe<SectionGallery>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionGalleryCursorCollection = {
  __typename?: "SectionGalleryCursorCollection";
  items: Array<Maybe<SectionGallery>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionGalleryFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionGalleryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionGalleryFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullWidth?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfitemsMultiTypeNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant?: InputMaybe<Scalars["String"]["input"]>;
  variant_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant_not?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SectionGalleryItemsCollection = {
  __typename?: "SectionGalleryItemsCollection";
  items: Array<Maybe<SectionGalleryItemsItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionGalleryItemsCursorCollection = {
  __typename?: "SectionGalleryItemsCursorCollection";
  items: Array<Maybe<SectionGalleryItemsItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionGalleryItemsFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionGalleryItemsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionGalleryItemsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SectionGalleryItemsItem = GalleryItem | GalleryItemWithText;

export type SectionGalleryLinkingCollections = {
  __typename?: "SectionGalleryLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionGalleryLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionGalleryLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionGalleryLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionGalleryLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionGalleryLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionGalleryLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionGalleryLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionGalleryLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionGalleryOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHero = Entry &
  _Node & {
    __typename?: "SectionHero";
    _id: Scalars["ID"]["output"];
    additionalSlidesCollection?: Maybe<SectionHeroAdditionalSlidesCollection>;
    additionalSlidesCursorCollection?: Maybe<SectionHeroAdditionalSlidesCursorCollection>;
    autoplay?: Maybe<Scalars["Boolean"]["output"]>;
    autoplayDuration?: Maybe<Scalars["Int"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    buttonsPosition?: Maybe<Scalars["String"]["output"]>;
    content?: Maybe<HeadlineBlock>;
    contentfulMetadata: ContentfulMetadata;
    ctaCollection?: Maybe<SectionHeroCtaCollection>;
    ctaCursorCollection?: Maybe<SectionHeroCtaCursorCollection>;
    headlineSize?: Maybe<Scalars["String"]["output"]>;
    heroLayout?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionHeroLinkingCollections>;
    mediaCollection?: Maybe<SectionHeroMediaCollection>;
    mediaCursorCollection?: Maybe<SectionHeroMediaCursorCollection>;
    presentation?: Maybe<Scalars["String"]["output"]>;
    svg?: Maybe<MediaImage>;
    sys: Sys;
    textColor?: Maybe<Scalars["String"]["output"]>;
    textHorizontalPosition?: Maybe<Scalars["String"]["output"]>;
    textVerticalPosition?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroAdditionalSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroAdditionalSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroAdditionalSlidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroAdditionalSlidesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroAutoplayArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroAutoplayDurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroBackgroundColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroButtonsPositionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroContentArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroCtaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroHeadlineSizeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroHeroLayoutArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroMediaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroMediaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroPresentationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroSvgArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroTextColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroTextHorizontalPositionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionHero) */
export type SectionHeroTextVerticalPositionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroAdditionalSlidesCollection = {
  __typename?: "SectionHeroAdditionalSlidesCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum SectionHeroAdditionalSlidesCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export type SectionHeroAdditionalSlidesCursorCollection = {
  __typename?: "SectionHeroAdditionalSlidesCursorCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum SectionHeroAdditionalSlidesCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export type SectionHeroCollection = {
  __typename?: "SectionHeroCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionHeroCtaCollection = {
  __typename?: "SectionHeroCtaCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum SectionHeroCtaCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type SectionHeroCtaCursorCollection = {
  __typename?: "SectionHeroCtaCursorCollection";
  items: Array<Maybe<LinkAction>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum SectionHeroCtaCursorCollectionOrder {
  AnchorAsc = "anchor_ASC",
  AnchorDesc = "anchor_DESC",
  ExternalUrlAsc = "externalUrl_ASC",
  ExternalUrlDesc = "externalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TargetAsc = "target_ASC",
  TargetDesc = "target_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type SectionHeroCursorCollection = {
  __typename?: "SectionHeroCursorCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionHeroFilter>>>;
  additionalSlides?: InputMaybe<CfSectionHeroNestedFilter>;
  additionalSlidesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration_gt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_gte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplayDuration_lt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_lte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplay_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  backgroundColor_not?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  buttonsPosition?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  buttonsPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  buttonsPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  content?: InputMaybe<CfHeadlineBlockNestedFilter>;
  content_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfLinkActionNestedFilter>;
  ctaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineSize?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineSize_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineSize_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  heroLayout?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_contains?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  heroLayout_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  heroLayout_not?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  media?: InputMaybe<CfmediaMultiTypeNestedFilter>;
  mediaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  presentation?: InputMaybe<Scalars["String"]["input"]>;
  presentation_contains?: InputMaybe<Scalars["String"]["input"]>;
  presentation_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  presentation_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  presentation_not?: InputMaybe<Scalars["String"]["input"]>;
  presentation_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  presentation_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  svg?: InputMaybe<CfMediaImageNestedFilter>;
  svg_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  textColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textColor_not?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textHorizontalPosition?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textHorizontalPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textHorizontalPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVerticalPosition?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVerticalPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVerticalPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SectionHeroLinkingCollections = {
  __typename?: "SectionHeroLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
  sectionHeroCollection?: Maybe<SectionHeroCollection>;
  sectionHeroCursorCollection?: Maybe<SectionHeroCursorCollection>;
  sectionSliderCollection?: Maybe<SectionSliderCollection>;
  sectionSliderCursorCollection?: Maybe<SectionSliderCursorCollection>;
};

export type SectionHeroLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsSectionHeroCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsSectionHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsSectionHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsSectionHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsSectionSliderCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsSectionSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionHeroLinkingCollectionsSectionSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionHeroLinkingCollectionsSectionSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionHeroLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionHeroLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionHeroLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionHeroLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionHeroLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsSectionHeroCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum SectionHeroLinkingCollectionsSectionHeroCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export enum SectionHeroLinkingCollectionsSectionSliderCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionHeroLinkingCollectionsSectionSliderCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionHeroMediaCollection = {
  __typename?: "SectionHeroMediaCollection";
  items: Array<Maybe<SectionHeroMediaItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionHeroMediaCursorCollection = {
  __typename?: "SectionHeroMediaCursorCollection";
  items: Array<Maybe<SectionHeroMediaItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionHeroMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionHeroMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionHeroMediaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type SectionHeroMediaItem = MediaImage | MediaVideo;

export enum SectionHeroOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroText = Entry &
  _Node & {
    __typename?: "SectionIntroText";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    headline?: Maybe<HeadlineBlock>;
    headlineIntro?: Maybe<HeadlineBlock>;
    headlineLevel?: Maybe<Scalars["String"]["output"]>;
    headlineVariant?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionIntroTextLinkingCollections>;
    sys: Sys;
    textIntro?: Maybe<EditorialText>;
    textVariant?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextHeadlineIntroArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextHeadlineLevelArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextHeadlineVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextTextIntroArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EditorialTextFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextTextVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionIntroText) */
export type SectionIntroTextUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionIntroTextCollection = {
  __typename?: "SectionIntroTextCollection";
  items: Array<Maybe<SectionIntroText>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionIntroTextCursorCollection = {
  __typename?: "SectionIntroTextCursorCollection";
  items: Array<Maybe<SectionIntroText>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionIntroTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionIntroTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionIntroTextFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headlineIntro?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headlineIntro_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineLevel?: InputMaybe<Scalars["String"]["input"]>;
  headlineLevel_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineLevel_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineLevel_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineLevel_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineLevel_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineVariant?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  textIntro?: InputMaybe<CfEditorialTextNestedFilter>;
  textIntro_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVariant?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionIntroTextLinkingCollections = {
  __typename?: "SectionIntroTextLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type SectionIntroTextLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionIntroTextLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionIntroTextLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionIntroTextLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionIntroTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionIntroTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionIntroTextLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionIntroTextLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionIntroTextOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMedia = Entry &
  _Node & {
    __typename?: "SectionMedia";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    aspectRatio?: Maybe<Scalars["String"]["output"]>;
    autoplay?: Maybe<Scalars["Boolean"]["output"]>;
    backgroundVideo?: Maybe<Scalars["Boolean"]["output"]>;
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    fullWidth?: Maybe<Scalars["Boolean"]["output"]>;
    headline?: Maybe<HeadlineBlock>;
    headlineColor?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionMediaLinkingCollections>;
    loop?: Maybe<Scalars["Boolean"]["output"]>;
    media?: Maybe<SectionMediaMedia>;
    muted?: Maybe<Scalars["Boolean"]["output"]>;
    progressbarColor?: Maybe<Scalars["String"]["output"]>;
    showControls?: Maybe<Scalars["Boolean"]["output"]>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaAspectRatioArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaAutoplayArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaBackgroundVideoArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaFullWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaLoopArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaMediaArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionMediaMediaFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaMutedArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaProgressbarColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaShowControlsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionMedia) */
export type SectionMediaUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionMediaCollection = {
  __typename?: "SectionMediaCollection";
  items: Array<Maybe<SectionMedia>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionMediaCursorCollection = {
  __typename?: "SectionMediaCursorCollection";
  items: Array<Maybe<SectionMedia>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionMediaFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  aspectRatio?: InputMaybe<Scalars["String"]["input"]>;
  aspectRatio_contains?: InputMaybe<Scalars["String"]["input"]>;
  aspectRatio_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  aspectRatio_not?: InputMaybe<Scalars["String"]["input"]>;
  aspectRatio_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  autoplay?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundVideo?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundVideo_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundVideo_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullWidth?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  loop?: InputMaybe<Scalars["Boolean"]["input"]>;
  loop_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  loop_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  media?: InputMaybe<CfmediaMultiTypeNestedFilter>;
  media_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  muted?: InputMaybe<Scalars["Boolean"]["input"]>;
  muted_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  muted_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  progressbarColor?: InputMaybe<Scalars["String"]["input"]>;
  progressbarColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  progressbarColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  progressbarColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  progressbarColor_not?: InputMaybe<Scalars["String"]["input"]>;
  progressbarColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  progressbarColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  showControls?: InputMaybe<Scalars["Boolean"]["input"]>;
  showControls_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showControls_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollections = {
  __typename?: "SectionMediaLinkingCollections";
  accordionItemD2CCollection?: Maybe<AccordionItemD2CCollection>;
  accordionItemD2CCursorCollection?: Maybe<AccordionItemD2CCursorCollection>;
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionMediaLinkingCollectionsAccordionItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsAccordionItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsAccordionItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsAccordionItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionMediaLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionMediaLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionMediaLinkingCollectionsAccordionItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsAccordionItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionMediaLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionMediaLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionMediaLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionMediaLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionMediaLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionMediaMedia = MediaImage | MediaVideo;

export type SectionMediaMediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionMediaMediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionMediaMediaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum SectionMediaOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuote = Entry &
  _Node & {
    __typename?: "SectionQuote";
    _id: Scalars["ID"]["output"];
    athlete?: Maybe<Athlete>;
    authorImage?: Maybe<MediaImage>;
    authorName?: Maybe<Scalars["String"]["output"]>;
    authorTeam?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    eyebrow?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionQuoteLinkingCollections>;
    quoteText?: Maybe<SectionQuoteQuoteText>;
    quoteType?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteAthleteArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<AthleteFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteAuthorImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteAuthorNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteAuthorTeamArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteEyebrowArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteQuoteTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteQuoteTypeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionQuote) */
export type SectionQuoteUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionQuoteCollection = {
  __typename?: "SectionQuoteCollection";
  items: Array<Maybe<SectionQuote>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionQuoteCursorCollection = {
  __typename?: "SectionQuoteCursorCollection";
  items: Array<Maybe<SectionQuote>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionQuoteFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionQuoteFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionQuoteFilter>>>;
  athlete?: InputMaybe<CfAthleteNestedFilter>;
  athlete_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  authorImage?: InputMaybe<CfMediaImageNestedFilter>;
  authorImage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  authorName?: InputMaybe<Scalars["String"]["input"]>;
  authorName_contains?: InputMaybe<Scalars["String"]["input"]>;
  authorName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  authorName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  authorName_not?: InputMaybe<Scalars["String"]["input"]>;
  authorName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  authorName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  authorTeam?: InputMaybe<Scalars["String"]["input"]>;
  authorTeam_contains?: InputMaybe<Scalars["String"]["input"]>;
  authorTeam_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  authorTeam_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  authorTeam_not?: InputMaybe<Scalars["String"]["input"]>;
  authorTeam_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  authorTeam_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrow?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow_not?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  quoteText_contains?: InputMaybe<Scalars["String"]["input"]>;
  quoteText_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  quoteText_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  quoteType?: InputMaybe<Scalars["String"]["input"]>;
  quoteType_contains?: InputMaybe<Scalars["String"]["input"]>;
  quoteType_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  quoteType_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  quoteType_not?: InputMaybe<Scalars["String"]["input"]>;
  quoteType_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  quoteType_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollections = {
  __typename?: "SectionQuoteLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionQuoteLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionQuoteLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionQuoteLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionQuoteLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionQuoteLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionQuoteLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionQuoteLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionQuoteLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionQuoteOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionQuoteQuoteText = {
  __typename?: "SectionQuoteQuoteText";
  json: Scalars["JSON"]["output"];
  links: SectionQuoteQuoteTextLinks;
};

export type SectionQuoteQuoteTextAssets = {
  __typename?: "SectionQuoteQuoteTextAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SectionQuoteQuoteTextEntries = {
  __typename?: "SectionQuoteQuoteTextEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SectionQuoteQuoteTextLinks = {
  __typename?: "SectionQuoteQuoteTextLinks";
  assets: SectionQuoteQuoteTextAssets;
  entries: SectionQuoteQuoteTextEntries;
  resources: SectionQuoteQuoteTextResources;
};

export type SectionQuoteQuoteTextResources = {
  __typename?: "SectionQuoteQuoteTextResources";
  block: Array<SectionQuoteQuoteTextResourcesBlock>;
  hyperlink: Array<SectionQuoteQuoteTextResourcesHyperlink>;
  inline: Array<SectionQuoteQuoteTextResourcesInline>;
};

export type SectionQuoteQuoteTextResourcesBlock = ResourceLink & {
  __typename?: "SectionQuoteQuoteTextResourcesBlock";
  sys: ResourceSys;
};

export type SectionQuoteQuoteTextResourcesHyperlink = ResourceLink & {
  __typename?: "SectionQuoteQuoteTextResourcesHyperlink";
  sys: ResourceSys;
};

export type SectionQuoteQuoteTextResourcesInline = ResourceLink & {
  __typename?: "SectionQuoteQuoteTextResourcesInline";
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSlider = Entry &
  _Node & {
    __typename?: "SectionSlider";
    _id: Scalars["ID"]["output"];
    autoplay?: Maybe<Scalars["Boolean"]["output"]>;
    autoplayDuration?: Maybe<Scalars["Int"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    fullWidth?: Maybe<Scalars["Boolean"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionSliderLinkingCollections>;
    slidesCollection?: Maybe<SectionSliderSlidesCollection>;
    slidesCursorCollection?: Maybe<SectionSliderSlidesCursorCollection>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderAutoplayArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderAutoplayDurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderFullWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderSlidesCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderSlidesCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderSlidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderSlidesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<SectionHeroFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionSlider) */
export type SectionSliderUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionSliderCollection = {
  __typename?: "SectionSliderCollection";
  items: Array<Maybe<SectionSlider>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionSliderCursorCollection = {
  __typename?: "SectionSliderCursorCollection";
  items: Array<Maybe<SectionSlider>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionSliderFilter>>>;
  autoplay?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration_gt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_gte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplayDuration_lt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_lte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplay_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  fullWidth?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  fullWidth_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slides?: InputMaybe<CfSectionHeroNestedFilter>;
  slidesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollections = {
  __typename?: "SectionSliderLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
};

export type SectionSliderLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionSliderLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionSliderLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionSliderLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionSliderLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionSliderLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionSliderLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionSliderOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionSliderSlidesCollection = {
  __typename?: "SectionSliderSlidesCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum SectionSliderSlidesCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

export type SectionSliderSlidesCursorCollection = {
  __typename?: "SectionSliderSlidesCursorCollection";
  items: Array<Maybe<SectionHero>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum SectionSliderSlidesCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  ButtonsPositionAsc = "buttonsPosition_ASC",
  ButtonsPositionDesc = "buttonsPosition_DESC",
  HeadlineSizeAsc = "headlineSize_ASC",
  HeadlineSizeDesc = "headlineSize_DESC",
  HeroLayoutAsc = "heroLayout_ASC",
  HeroLayoutDesc = "heroLayout_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PresentationAsc = "presentation_ASC",
  PresentationDesc = "presentation_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
  TextHorizontalPositionAsc = "textHorizontalPosition_ASC",
  TextHorizontalPositionDesc = "textHorizontalPosition_DESC",
  TextVerticalPositionAsc = "textVerticalPosition_ASC",
  TextVerticalPositionDesc = "textVerticalPosition_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTagline = Entry &
  _Node & {
    __typename?: "SectionTagline";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionTaglineLinkingCollections>;
    sys: Sys;
    text?: Maybe<SectionTaglineText>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTaglineAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTaglineInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTaglineLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTaglineTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTagline) */
export type SectionTaglineUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionTaglineCollection = {
  __typename?: "SectionTaglineCollection";
  items: Array<Maybe<SectionTagline>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionTaglineCursorCollection = {
  __typename?: "SectionTaglineCursorCollection";
  items: Array<Maybe<SectionTagline>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionTaglineFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionTaglineFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionTaglineFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollections = {
  __typename?: "SectionTaglineLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionTaglineLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTaglineLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTaglineLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionTaglineLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTaglineLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTaglineLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTaglineLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTaglineLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTaglineOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionTaglineText = {
  __typename?: "SectionTaglineText";
  json: Scalars["JSON"]["output"];
  links: SectionTaglineTextLinks;
};

export type SectionTaglineTextAssets = {
  __typename?: "SectionTaglineTextAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SectionTaglineTextEntries = {
  __typename?: "SectionTaglineTextEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SectionTaglineTextLinks = {
  __typename?: "SectionTaglineTextLinks";
  assets: SectionTaglineTextAssets;
  entries: SectionTaglineTextEntries;
  resources: SectionTaglineTextResources;
};

export type SectionTaglineTextResources = {
  __typename?: "SectionTaglineTextResources";
  block: Array<SectionTaglineTextResourcesBlock>;
  hyperlink: Array<SectionTaglineTextResourcesHyperlink>;
  inline: Array<SectionTaglineTextResourcesInline>;
};

export type SectionTaglineTextResourcesBlock = ResourceLink & {
  __typename?: "SectionTaglineTextResourcesBlock";
  sys: ResourceSys;
};

export type SectionTaglineTextResourcesHyperlink = ResourceLink & {
  __typename?: "SectionTaglineTextResourcesHyperlink";
  sys: ResourceSys;
};

export type SectionTaglineTextResourcesInline = ResourceLink & {
  __typename?: "SectionTaglineTextResourcesInline";
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaser = Entry &
  _Node & {
    __typename?: "SectionTeaser";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<SectionTeaserItemsCollection>;
    itemsCursorCollection?: Maybe<SectionTeaserItemsCursorCollection>;
    linkedFrom?: Maybe<SectionTeaserLinkingCollections>;
    sys: Sys;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaserInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaserItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaserItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TeaserItemFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTeaser) */
export type SectionTeaserUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionTeaserCollection = {
  __typename?: "SectionTeaserCollection";
  items: Array<Maybe<SectionTeaser>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionTeaserCursorCollection = {
  __typename?: "SectionTeaserCursorCollection";
  items: Array<Maybe<SectionTeaser>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionTeaserFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfTeaserItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserItemsCollection = {
  __typename?: "SectionTeaserItemsCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum SectionTeaserItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionTeaserItemsCursorCollection = {
  __typename?: "SectionTeaserItemsCursorCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum SectionTeaserItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionTeaserLinkingCollections = {
  __typename?: "SectionTeaserLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
};

export type SectionTeaserLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTeaserLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTeaserLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionTeaserLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTeaserLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTeaserLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTeaserLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTeaserOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionText = Entry &
  _Node & {
    __typename?: "SectionText";
    _id: Scalars["ID"]["output"];
    anchorId?: Maybe<Scalars["String"]["output"]>;
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    headline?: Maybe<HeadlineBlock>;
    headlineDash?: Maybe<Scalars["Boolean"]["output"]>;
    headlineVariant?: Maybe<Scalars["String"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionTextLinkingCollections>;
    sys: Sys;
    text?: Maybe<EditorialText>;
    textColumns?: Maybe<Scalars["Int"]["output"]>;
    textVariant?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextAnchorIdArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextHeadlineDashArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextHeadlineVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EditorialTextFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextTextColumnsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextTextVariantArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionText) */
export type SectionTextUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionTextCollection = {
  __typename?: "SectionTextCollection";
  items: Array<Maybe<SectionText>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionTextCursorCollection = {
  __typename?: "SectionTextCursorCollection";
  items: Array<Maybe<SectionText>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionTextFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headlineDash?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineDash_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineDash_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineVariant?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfEditorialTextNestedFilter>;
  textColumns?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColumns_gt?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_gte?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  textColumns_lt?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_lte?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_not?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  textVariant?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImage = Entry &
  _Node & {
    __typename?: "SectionTextImage";
    _id: Scalars["ID"]["output"];
    containerWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    cta?: Maybe<LinkAction>;
    headline?: Maybe<HeadlineBlock>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SectionTextImageLinkingCollections>;
    media?: Maybe<MediaImage>;
    orderReverse?: Maybe<Scalars["Boolean"]["output"]>;
    sys: Sys;
    text?: Maybe<EditorialText>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageContainerWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageCtaArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageHeadlineArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<HeadlineBlockFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageMediaArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageOrderReverseArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageTextArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<EditorialTextFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/sectionTextImage) */
export type SectionTextImageUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type SectionTextImageCollection = {
  __typename?: "SectionTextImageCollection";
  items: Array<Maybe<SectionTextImage>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SectionTextImageCursorCollection = {
  __typename?: "SectionTextImageCursorCollection";
  items: Array<Maybe<SectionTextImage>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SectionTextImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionTextImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionTextImageFilter>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfLinkActionNestedFilter>;
  cta_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline?: InputMaybe<CfHeadlineBlockNestedFilter>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  media?: InputMaybe<CfMediaImageNestedFilter>;
  media_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfEditorialTextNestedFilter>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollections = {
  __typename?: "SectionTextImageLinkingCollections";
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  contentSliderD2CCollection?: Maybe<ContentSliderD2CCollection>;
  contentSliderD2CCursorCollection?: Maybe<ContentSliderD2CCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionTextImageLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsContentSliderD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsContentSliderD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsContentSliderD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsContentSliderD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextImageLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextImageLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionTextImageLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextImageLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextImageLinkingCollectionsContentSliderD2CCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BehaviorAsc = "behavior_ASC",
  BehaviorDesc = "behavior_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationLayoutAsc = "navigationLayout_ASC",
  NavigationLayoutDesc = "navigationLayout_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsContentSliderD2CCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BehaviorAsc = "behavior_ASC",
  BehaviorDesc = "behavior_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationLayoutAsc = "navigationLayout_ASC",
  NavigationLayoutDesc = "navigationLayout_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextImageLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextImageLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextImageOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type SectionTextLinkingCollections = {
  __typename?: "SectionTextLinkingCollections";
  accordionItemD2CCollection?: Maybe<AccordionItemD2CCollection>;
  accordionItemD2CCursorCollection?: Maybe<AccordionItemD2CCursorCollection>;
  categoryEnrichmentCollection?: Maybe<CategoryEnrichmentCollection>;
  categoryEnrichmentCursorCollection?: Maybe<CategoryEnrichmentCursorCollection>;
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  galleryItemWithTextCollection?: Maybe<GalleryItemWithTextCollection>;
  galleryItemWithTextCursorCollection?: Maybe<GalleryItemWithTextCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productEnrichmentCollection?: Maybe<ProductEnrichmentCollection>;
  productEnrichmentCursorCollection?: Maybe<ProductEnrichmentCursorCollection>;
};

export type SectionTextLinkingCollectionsAccordionItemD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsAccordionItemD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsAccordionItemD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsAccordionItemD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsCategoryEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsCategoryEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsCategoryEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsCategoryEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsGalleryItemWithTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsGalleryItemWithTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsGalleryItemWithTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsGalleryItemWithTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsProductEnrichmentCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsProductEnrichmentCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SectionTextLinkingCollectionsProductEnrichmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SectionTextLinkingCollectionsProductEnrichmentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SectionTextLinkingCollectionsAccordionItemD2CCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsAccordionItemD2CCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LabelAsc = "label_ASC",
  LabelDesc = "label_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsCategoryEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsCategoryEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextLinkingCollectionsGalleryItemWithTextCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsGalleryItemWithTextCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SectionTextLinkingCollectionsPageCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsPageCursorCollectionOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NoIndexAsc = "noIndex_ASC",
  NoIndexDesc = "noIndex_DESC",
  NofollowAsc = "nofollow_ASC",
  NofollowDesc = "nofollow_DESC",
  PathAsc = "path_ASC",
  PathDesc = "path_DESC",
  SeoDescriptionAsc = "seoDescription_ASC",
  SeoDescriptionDesc = "seoDescription_DESC",
  SeoTitleAsc = "seoTitle_ASC",
  SeoTitleDesc = "seoTitle_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsProductEnrichmentCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextLinkingCollectionsProductEnrichmentCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum SectionTextOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type Seo = Entry &
  _Node & {
    __typename?: "Seo";
    _id: Scalars["ID"]["output"];
    canonicalUrl?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    description?: Maybe<Scalars["String"]["output"]>;
    excludeLinksFromRankingsNofollow?: Maybe<Scalars["Boolean"]["output"]>;
    hideFromSearchEnginesNoindex?: Maybe<Scalars["Boolean"]["output"]>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    linkedFrom?: Maybe<SeoLinkingCollections>;
    openGraphImage?: Maybe<MediaImage>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoDescriptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoExcludeLinksFromRankingsNofollowArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoHideFromSearchEnginesNoindexArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoKeywordsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoOpenGraphImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/seo) */
export type SeoTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoCollection = {
  __typename?: "SeoCollection";
  items: Array<Maybe<Seo>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SeoCursorCollection = {
  __typename?: "SeoCursorCollection";
  items: Array<Maybe<Seo>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SeoFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoFilter>>>;
  canonicalUrl?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  canonicalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  excludeLinksFromRankingsNofollow?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludeLinksFromRankingsNofollow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludeLinksFromRankingsNofollow_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  openGraphImage?: InputMaybe<CfMediaImageNestedFilter>;
  openGraphImage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SeoLinkingCollections = {
  __typename?: "SeoLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
};

export type SeoLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SeoLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SeoLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SeoLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SeoLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SeoLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum SeoOrder {
  CanonicalUrlAsc = "canonicalUrl_ASC",
  CanonicalUrlDesc = "canonicalUrl_DESC",
  ExcludeLinksFromRankingsNofollowAsc = "excludeLinksFromRankingsNofollow_ASC",
  ExcludeLinksFromRankingsNofollowDesc = "excludeLinksFromRankingsNofollow_DESC",
  HideFromSearchEnginesNoindexAsc = "hideFromSearchEnginesNoindex_ASC",
  HideFromSearchEnginesNoindexDesc = "hideFromSearchEnginesNoindex_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2C = Entry &
  _Node & {
    __typename?: "ShippingInfoD2C";
    _id: Scalars["ID"]["output"];
    baseSite?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    deliveryTime?: Maybe<ShippingInfoD2CDeliveryTime>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<ShippingInfoD2CLinkingCollections>;
    returnDetail?: Maybe<ShippingInfoD2CReturnDetail>;
    shippingDetail?: Maybe<ShippingInfoD2CShippingDetail>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CBaseSiteArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CDeliveryTimeArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CReturnDetailArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/shippingInfoD2c) */
export type ShippingInfoD2CShippingDetailArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ShippingInfoD2CCollection = {
  __typename?: "ShippingInfoD2CCollection";
  items: Array<Maybe<ShippingInfoD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type ShippingInfoD2CCursorCollection = {
  __typename?: "ShippingInfoD2CCursorCollection";
  items: Array<Maybe<ShippingInfoD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type ShippingInfoD2CDeliveryTime = {
  __typename?: "ShippingInfoD2CDeliveryTime";
  json: Scalars["JSON"]["output"];
  links: ShippingInfoD2CDeliveryTimeLinks;
};

export type ShippingInfoD2CDeliveryTimeAssets = {
  __typename?: "ShippingInfoD2CDeliveryTimeAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ShippingInfoD2CDeliveryTimeEntries = {
  __typename?: "ShippingInfoD2CDeliveryTimeEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ShippingInfoD2CDeliveryTimeLinks = {
  __typename?: "ShippingInfoD2CDeliveryTimeLinks";
  assets: ShippingInfoD2CDeliveryTimeAssets;
  entries: ShippingInfoD2CDeliveryTimeEntries;
  resources: ShippingInfoD2CDeliveryTimeResources;
};

export type ShippingInfoD2CDeliveryTimeResources = {
  __typename?: "ShippingInfoD2CDeliveryTimeResources";
  block: Array<ShippingInfoD2CDeliveryTimeResourcesBlock>;
  hyperlink: Array<ShippingInfoD2CDeliveryTimeResourcesHyperlink>;
  inline: Array<ShippingInfoD2CDeliveryTimeResourcesInline>;
};

export type ShippingInfoD2CDeliveryTimeResourcesBlock = ResourceLink & {
  __typename?: "ShippingInfoD2CDeliveryTimeResourcesBlock";
  sys: ResourceSys;
};

export type ShippingInfoD2CDeliveryTimeResourcesHyperlink = ResourceLink & {
  __typename?: "ShippingInfoD2CDeliveryTimeResourcesHyperlink";
  sys: ResourceSys;
};

export type ShippingInfoD2CDeliveryTimeResourcesInline = ResourceLink & {
  __typename?: "ShippingInfoD2CDeliveryTimeResourcesInline";
  sys: ResourceSys;
};

export type ShippingInfoD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<ShippingInfoD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ShippingInfoD2CFilter>>>;
  baseSite?: InputMaybe<Scalars["String"]["input"]>;
  baseSite_contains?: InputMaybe<Scalars["String"]["input"]>;
  baseSite_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  baseSite_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  baseSite_not?: InputMaybe<Scalars["String"]["input"]>;
  baseSite_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  baseSite_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  deliveryTime_contains?: InputMaybe<Scalars["String"]["input"]>;
  deliveryTime_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  deliveryTime_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  returnDetail_contains?: InputMaybe<Scalars["String"]["input"]>;
  returnDetail_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  returnDetail_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  shippingDetail_contains?: InputMaybe<Scalars["String"]["input"]>;
  shippingDetail_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  shippingDetail_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type ShippingInfoD2CLinkingCollections = {
  __typename?: "ShippingInfoD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type ShippingInfoD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ShippingInfoD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ShippingInfoD2COrder {
  BaseSiteAsc = "baseSite_ASC",
  BaseSiteDesc = "baseSite_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type ShippingInfoD2CReturnDetail = {
  __typename?: "ShippingInfoD2CReturnDetail";
  json: Scalars["JSON"]["output"];
  links: ShippingInfoD2CReturnDetailLinks;
};

export type ShippingInfoD2CReturnDetailAssets = {
  __typename?: "ShippingInfoD2CReturnDetailAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ShippingInfoD2CReturnDetailEntries = {
  __typename?: "ShippingInfoD2CReturnDetailEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ShippingInfoD2CReturnDetailLinks = {
  __typename?: "ShippingInfoD2CReturnDetailLinks";
  assets: ShippingInfoD2CReturnDetailAssets;
  entries: ShippingInfoD2CReturnDetailEntries;
  resources: ShippingInfoD2CReturnDetailResources;
};

export type ShippingInfoD2CReturnDetailResources = {
  __typename?: "ShippingInfoD2CReturnDetailResources";
  block: Array<ShippingInfoD2CReturnDetailResourcesBlock>;
  hyperlink: Array<ShippingInfoD2CReturnDetailResourcesHyperlink>;
  inline: Array<ShippingInfoD2CReturnDetailResourcesInline>;
};

export type ShippingInfoD2CReturnDetailResourcesBlock = ResourceLink & {
  __typename?: "ShippingInfoD2CReturnDetailResourcesBlock";
  sys: ResourceSys;
};

export type ShippingInfoD2CReturnDetailResourcesHyperlink = ResourceLink & {
  __typename?: "ShippingInfoD2CReturnDetailResourcesHyperlink";
  sys: ResourceSys;
};

export type ShippingInfoD2CReturnDetailResourcesInline = ResourceLink & {
  __typename?: "ShippingInfoD2CReturnDetailResourcesInline";
  sys: ResourceSys;
};

export type ShippingInfoD2CShippingDetail = {
  __typename?: "ShippingInfoD2CShippingDetail";
  json: Scalars["JSON"]["output"];
  links: ShippingInfoD2CShippingDetailLinks;
};

export type ShippingInfoD2CShippingDetailAssets = {
  __typename?: "ShippingInfoD2CShippingDetailAssets";
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ShippingInfoD2CShippingDetailEntries = {
  __typename?: "ShippingInfoD2CShippingDetailEntries";
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ShippingInfoD2CShippingDetailLinks = {
  __typename?: "ShippingInfoD2CShippingDetailLinks";
  assets: ShippingInfoD2CShippingDetailAssets;
  entries: ShippingInfoD2CShippingDetailEntries;
  resources: ShippingInfoD2CShippingDetailResources;
};

export type ShippingInfoD2CShippingDetailResources = {
  __typename?: "ShippingInfoD2CShippingDetailResources";
  block: Array<ShippingInfoD2CShippingDetailResourcesBlock>;
  hyperlink: Array<ShippingInfoD2CShippingDetailResourcesHyperlink>;
  inline: Array<ShippingInfoD2CShippingDetailResourcesInline>;
};

export type ShippingInfoD2CShippingDetailResourcesBlock = ResourceLink & {
  __typename?: "ShippingInfoD2CShippingDetailResourcesBlock";
  sys: ResourceSys;
};

export type ShippingInfoD2CShippingDetailResourcesHyperlink = ResourceLink & {
  __typename?: "ShippingInfoD2CShippingDetailResourcesHyperlink";
  sys: ResourceSys;
};

export type ShippingInfoD2CShippingDetailResourcesInline = ResourceLink & {
  __typename?: "ShippingInfoD2CShippingDetailResourcesInline";
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/socialLinks) */
export type SocialLinks = Entry &
  _Node & {
    __typename?: "SocialLinks";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<SocialLinksLinkingCollections>;
    platform?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    url?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/socialLinks) */
export type SocialLinksInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/socialLinks) */
export type SocialLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/socialLinks) */
export type SocialLinksPlatformArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/socialLinks) */
export type SocialLinksUrlArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SocialLinksCollection = {
  __typename?: "SocialLinksCollection";
  items: Array<Maybe<SocialLinks>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type SocialLinksCursorCollection = {
  __typename?: "SocialLinksCursorCollection";
  items: Array<Maybe<SocialLinks>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type SocialLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<SocialLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SocialLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  platform?: InputMaybe<Scalars["String"]["input"]>;
  platform_contains?: InputMaybe<Scalars["String"]["input"]>;
  platform_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  platform_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  platform_not?: InputMaybe<Scalars["String"]["input"]>;
  platform_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  platform_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  url_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url_not?: InputMaybe<Scalars["String"]["input"]>;
  url_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SocialLinksLinkingCollections = {
  __typename?: "SocialLinksLinkingCollections";
  athleteCollection?: Maybe<AthleteCollection>;
  athleteCursorCollection?: Maybe<AthleteCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};

export type SocialLinksLinkingCollectionsAthleteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SocialLinksLinkingCollectionsAthleteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SocialLinksLinkingCollectionsAthleteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<SocialLinksLinkingCollectionsAthleteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SocialLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SocialLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SocialLinksLinkingCollectionsAthleteCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum SocialLinksLinkingCollectionsAthleteCursorCollectionOrder {
  CountryAsc = "country_ASC",
  CountryDesc = "country_DESC",
  FirstNameAsc = "firstName_ASC",
  FirstNameDesc = "firstName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LastNameAsc = "lastName_ASC",
  LastNameDesc = "lastName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TeamAsc = "team_ASC",
  TeamDesc = "team_DESC",
}

export enum SocialLinksOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PlatformAsc = "platform_ASC",
  PlatformDesc = "platform_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  UrlAsc = "url_ASC",
  UrlDesc = "url_DESC",
}

export type Sys = {
  __typename?: "Sys";
  environmentId: Scalars["String"]["output"];
  firstPublishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["String"]["output"];
  /** The locale that was requested. */
  locale?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  publishedVersion?: Maybe<Scalars["Int"]["output"]>;
  spaceId: Scalars["String"]["output"];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstPublishedAt_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  id_contains?: InputMaybe<Scalars["String"]["input"]>;
  id_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id_not?: InputMaybe<Scalars["String"]["input"]>;
  id_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  publishedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  publishedAt_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  publishedVersion?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedVersion_gt?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_gte?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  publishedVersion_lt?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_lte?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_not?: InputMaybe<Scalars["Float"]["input"]>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2C = Entry &
  _Node & {
    __typename?: "TabContainerD2C";
    _id: Scalars["ID"]["output"];
    columnWidth?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    itemsCollection?: Maybe<TabContainerD2CItemsCollection>;
    itemsCursorCollection?: Maybe<TabContainerD2CItemsCursorCollection>;
    linkedFrom?: Maybe<TabContainerD2CLinkingCollections>;
    showNavigationArrows?: Maybe<Scalars["Boolean"]["output"]>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
    uiConfiguration?: Maybe<UiConfiguration>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CColumnWidthArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CItemsCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<TabContainerItemD2CFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CShowNavigationArrowsArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerD2c) */
export type TabContainerD2CUiConfigurationArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<UiConfigurationFilter>;
};

export type TabContainerD2CCollection = {
  __typename?: "TabContainerD2CCollection";
  items: Array<Maybe<TabContainerD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type TabContainerD2CCursorCollection = {
  __typename?: "TabContainerD2CCursorCollection";
  items: Array<Maybe<TabContainerD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type TabContainerD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabContainerD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabContainerD2CFilter>>>;
  columnWidth?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  columnWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  columnWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  columnWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  items?: InputMaybe<CfTabContainerItemD2CNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNavigationArrows?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNavigationArrows_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showNavigationArrows_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration?: InputMaybe<CfUiConfigurationNestedFilter>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CItemsCollection = {
  __typename?: "TabContainerD2CItemsCollection";
  items: Array<Maybe<TabContainerItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum TabContainerD2CItemsCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export type TabContainerD2CItemsCursorCollection = {
  __typename?: "TabContainerD2CItemsCursorCollection";
  items: Array<Maybe<TabContainerItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum TabContainerD2CItemsCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export type TabContainerD2CLinkingCollections = {
  __typename?: "TabContainerD2CLinkingCollections";
  contentPageCollection?: Maybe<ContentPageCollection>;
  contentPageCursorCollection?: Maybe<ContentPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  homePageCollection?: Maybe<HomePageCollection>;
  homePageCursorCollection?: Maybe<HomePageCursorCollection>;
};

export type TabContainerD2CLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CLinkingCollectionsContentPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CLinkingCollectionsContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CLinkingCollectionsContentPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CLinkingCollectionsHomePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerD2CLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerD2CLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum TabContainerD2CLinkingCollectionsContentPageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerD2CLinkingCollectionsContentPageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageTypeAsc = "pageType_ASC",
  PageTypeDesc = "pageType_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerD2CLinkingCollectionsHomePageCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerD2CLinkingCollectionsHomePageCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SlugAsc = "slug_ASC",
  SlugDesc = "slug_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerD2COrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2C = Entry &
  _Node & {
    __typename?: "TabContainerItemD2C";
    _id: Scalars["ID"]["output"];
    contentBlocksCollection?: Maybe<TabContainerItemD2CContentBlocksCollection>;
    contentBlocksCursorCollection?: Maybe<TabContainerItemD2CContentBlocksCursorCollection>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<TabContainerItemD2CLinkingCollections>;
    sys: Sys;
    title?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2CContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2CContentBlocksCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListingFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2CContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2CContentBlocksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<ProductListingFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2CInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2CLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/tabContainerItemD2c) */
export type TabContainerItemD2CTitleArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerItemD2CCollection = {
  __typename?: "TabContainerItemD2CCollection";
  items: Array<Maybe<TabContainerItemD2C>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type TabContainerItemD2CContentBlocksCollection = {
  __typename?: "TabContainerItemD2CContentBlocksCollection";
  items: Array<Maybe<ProductListing>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export enum TabContainerItemD2CContentBlocksCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type TabContainerItemD2CContentBlocksCursorCollection = {
  __typename?: "TabContainerItemD2CContentBlocksCursorCollection";
  items: Array<Maybe<ProductListing>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export enum TabContainerItemD2CContentBlocksCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export type TabContainerItemD2CCursorCollection = {
  __typename?: "TabContainerItemD2CCursorCollection";
  items: Array<Maybe<TabContainerItemD2C>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type TabContainerItemD2CFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabContainerItemD2CFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabContainerItemD2CFilter>>>;
  contentBlocks?: InputMaybe<CfProductListingNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TabContainerItemD2CLinkingCollections = {
  __typename?: "TabContainerItemD2CLinkingCollections";
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  tabContainerD2CCollection?: Maybe<TabContainerD2CCollection>;
  tabContainerD2CCursorCollection?: Maybe<TabContainerD2CCursorCollection>;
};

export type TabContainerItemD2CLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerItemD2CLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerItemD2CLinkingCollectionsTabContainerD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2CLinkingCollectionsTabContainerD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TabContainerItemD2CLinkingCollectionsTabContainerD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TabContainerItemD2CLinkingCollectionsTabContainerD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum TabContainerItemD2CLinkingCollectionsTabContainerD2CCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerItemD2CLinkingCollectionsTabContainerD2CCursorCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum TabContainerItemD2COrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: "TaxonomyConcept";
  id?: Maybe<Scalars["String"]["output"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/teaserItem) */
export type TeaserItem = Entry &
  _Node & {
    __typename?: "TeaserItem";
    _id: Scalars["ID"]["output"];
    contentfulMetadata: ContentfulMetadata;
    image?: Maybe<MediaImage>;
    internalName?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<LinkAction>;
    linkedFrom?: Maybe<TeaserItemLinkingCollections>;
    sys: Sys;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/teaserItem) */
export type TeaserItemImageArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<MediaImageFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/teaserItem) */
export type TeaserItemInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/teaserItem) */
export type TeaserItemLinkArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
  where?: InputMaybe<LinkActionFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/teaserItem) */
export type TeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TeaserItemCollection = {
  __typename?: "TeaserItemCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type TeaserItemCursorCollection = {
  __typename?: "TeaserItemCursorCollection";
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type TeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeaserItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image?: InputMaybe<CfMediaImageNestedFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link?: InputMaybe<CfLinkActionNestedFilter>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type TeaserItemLinkingCollections = {
  __typename?: "TeaserItemLinkingCollections";
  divisionNavigationCollection?: Maybe<DivisionNavigationCollection>;
  divisionNavigationCursorCollection?: Maybe<DivisionNavigationCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sectionTeaserCollection?: Maybe<SectionTeaserCollection>;
  sectionTeaserCursorCollection?: Maybe<SectionTeaserCursorCollection>;
};

export type TeaserItemLinkingCollectionsDivisionNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsDivisionNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TeaserItemLinkingCollectionsDivisionNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsDivisionNavigationCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TeaserItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TeaserItemLinkingCollectionsSectionTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsSectionTeaserCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TeaserItemLinkingCollectionsSectionTeaserCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsSectionTeaserCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum TeaserItemLinkingCollectionsDivisionNavigationCollectionOrder {
  AriaLabelAsc = "ariaLabel_ASC",
  AriaLabelDesc = "ariaLabel_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum TeaserItemLinkingCollectionsDivisionNavigationCursorCollectionOrder {
  AriaLabelAsc = "ariaLabel_ASC",
  AriaLabelDesc = "ariaLabel_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum TeaserItemLinkingCollectionsSectionTeaserCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum TeaserItemLinkingCollectionsSectionTeaserCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum TeaserItemOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars["String"]["input"]>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfiguration = Entry &
  _Node & {
    __typename?: "UiConfiguration";
    _id: Scalars["ID"]["output"];
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<UiConfigurationLinkingCollections>;
    paddingBottom?: Maybe<Scalars["String"]["output"]>;
    paddingTop?: Maybe<Scalars["String"]["output"]>;
    sys: Sys;
    textColor?: Maybe<Scalars["String"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationBackgroundColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationPaddingBottomArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationPaddingTopArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/uiConfiguration) */
export type UiConfigurationTextColorArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationCollection = {
  __typename?: "UiConfigurationCollection";
  items: Array<Maybe<UiConfiguration>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type UiConfigurationCursorCollection = {
  __typename?: "UiConfigurationCursorCollection";
  items: Array<Maybe<UiConfiguration>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type UiConfigurationFilter = {
  AND?: InputMaybe<Array<InputMaybe<UiConfigurationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UiConfigurationFilter>>>;
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  backgroundColor_not?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingBottom?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paddingBottom_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingBottom_not?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingTop?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paddingTop_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingTop_not?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  textColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textColor_not?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UiConfigurationLinkingCollections = {
  __typename?: "UiConfigurationLinkingCollections";
  accordionD2CCollection?: Maybe<AccordionD2CCollection>;
  accordionD2CCursorCollection?: Maybe<AccordionD2CCursorCollection>;
  contentSliderD2CCollection?: Maybe<ContentSliderD2CCollection>;
  contentSliderD2CCursorCollection?: Maybe<ContentSliderD2CCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  geometryTableCollection?: Maybe<GeometryTableCollection>;
  geometryTableCursorCollection?: Maybe<GeometryTableCursorCollection>;
  hotspotCollection?: Maybe<HotspotCollection>;
  hotspotCursorCollection?: Maybe<HotspotCursorCollection>;
  productListingCollection?: Maybe<ProductListingCollection>;
  productListingCursorCollection?: Maybe<ProductListingCursorCollection>;
  sectionClaimCollection?: Maybe<SectionClaimCollection>;
  sectionClaimCursorCollection?: Maybe<SectionClaimCursorCollection>;
  sectionCounterCollection?: Maybe<SectionCounterCollection>;
  sectionCounterCursorCollection?: Maybe<SectionCounterCursorCollection>;
  sectionGalleryCollection?: Maybe<SectionGalleryCollection>;
  sectionGalleryCursorCollection?: Maybe<SectionGalleryCursorCollection>;
  sectionIntroTextCollection?: Maybe<SectionIntroTextCollection>;
  sectionIntroTextCursorCollection?: Maybe<SectionIntroTextCursorCollection>;
  sectionMediaCollection?: Maybe<SectionMediaCollection>;
  sectionMediaCursorCollection?: Maybe<SectionMediaCursorCollection>;
  sectionQuoteCollection?: Maybe<SectionQuoteCollection>;
  sectionQuoteCursorCollection?: Maybe<SectionQuoteCursorCollection>;
  sectionSliderCollection?: Maybe<SectionSliderCollection>;
  sectionSliderCursorCollection?: Maybe<SectionSliderCursorCollection>;
  sectionTaglineCollection?: Maybe<SectionTaglineCollection>;
  sectionTaglineCursorCollection?: Maybe<SectionTaglineCursorCollection>;
  sectionTextCollection?: Maybe<SectionTextCollection>;
  sectionTextCursorCollection?: Maybe<SectionTextCursorCollection>;
  sectionTextImageCollection?: Maybe<SectionTextImageCollection>;
  sectionTextImageCursorCollection?: Maybe<SectionTextImageCursorCollection>;
  tabContainerD2CCollection?: Maybe<TabContainerD2CCollection>;
  tabContainerD2CCursorCollection?: Maybe<TabContainerD2CCursorCollection>;
};

export type UiConfigurationLinkingCollectionsAccordionD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsAccordionD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsAccordionD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsAccordionD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsContentSliderD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsContentSliderD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsContentSliderD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsContentSliderD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsGeometryTableCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsGeometryTableCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsGeometryTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsGeometryTableCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsHotspotCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsHotspotCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsHotspotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsHotspotCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsProductListingCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsProductListingCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsProductListingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsProductListingCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionClaimCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionClaimCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionClaimCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionClaimCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionCounterCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionCounterCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionCounterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionCounterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionGalleryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionGalleryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionIntroTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionIntroTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionIntroTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionIntroTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionMediaCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionMediaCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionMediaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionQuoteCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionQuoteCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionSliderCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTaglineCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTaglineCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTaglineCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTaglineCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTextCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTextImageCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTextImageCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsSectionTextImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsSectionTextImageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsTabContainerD2CCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsTabContainerD2CCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UiConfigurationLinkingCollectionsTabContainerD2CCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<UiConfigurationLinkingCollectionsTabContainerD2CCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum UiConfigurationLinkingCollectionsAccordionD2CCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsAccordionD2CCursorCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsContentSliderD2CCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BehaviorAsc = "behavior_ASC",
  BehaviorDesc = "behavior_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationLayoutAsc = "navigationLayout_ASC",
  NavigationLayoutDesc = "navigationLayout_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsContentSliderD2CCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BehaviorAsc = "behavior_ASC",
  BehaviorDesc = "behavior_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  NavigationLayoutAsc = "navigationLayout_ASC",
  NavigationLayoutDesc = "navigationLayout_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsGeometryTableCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  DefaultUnitAsc = "defaultUnit_ASC",
  DefaultUnitDesc = "defaultUnit_DESC",
  FrameSizeAsc = "frameSize_ASC",
  FrameSizeDesc = "frameSize_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowUnitToggleAsc = "showUnitToggle_ASC",
  ShowUnitToggleDesc = "showUnitToggle_DESC",
  SizesInAsc = "sizesIn_ASC",
  SizesInDesc = "sizesIn_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UnitInchesAsc = "unitInches_ASC",
  UnitInchesDesc = "unitInches_DESC",
  UnitMmAsc = "unitMm_ASC",
  UnitMmDesc = "unitMm_DESC",
}

export enum UiConfigurationLinkingCollectionsGeometryTableCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  DefaultUnitAsc = "defaultUnit_ASC",
  DefaultUnitDesc = "defaultUnit_DESC",
  FrameSizeAsc = "frameSize_ASC",
  FrameSizeDesc = "frameSize_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowUnitToggleAsc = "showUnitToggle_ASC",
  ShowUnitToggleDesc = "showUnitToggle_DESC",
  SizesInAsc = "sizesIn_ASC",
  SizesInDesc = "sizesIn_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  UnitInchesAsc = "unitInches_ASC",
  UnitInchesDesc = "unitInches_DESC",
  UnitMmAsc = "unitMm_ASC",
  UnitMmDesc = "unitMm_DESC",
}

export enum UiConfigurationLinkingCollectionsHotspotCollectionOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  HotspotColorAsc = "hotspotColor_ASC",
  HotspotColorDesc = "hotspotColor_DESC",
  ImageUrlAsc = "imageUrl_ASC",
  ImageUrlDesc = "imageUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum UiConfigurationLinkingCollectionsHotspotCursorCollectionOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  HotspotColorAsc = "hotspotColor_ASC",
  HotspotColorDesc = "hotspotColor_DESC",
  ImageUrlAsc = "imageUrl_ASC",
  ImageUrlDesc = "imageUrl_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum UiConfigurationLinkingCollectionsProductListingCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum UiConfigurationLinkingCollectionsProductListingCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  DefaultSortAsc = "defaultSort_ASC",
  DefaultSortDesc = "defaultSort_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PageSizeAsc = "pageSize_ASC",
  PageSizeDesc = "pageSize_DESC",
  PaginationModeAsc = "paginationMode_ASC",
  PaginationModeDesc = "paginationMode_DESC",
  ProductCategoryAsc = "productCategory_ASC",
  ProductCategoryDesc = "productCategory_DESC",
  SearchQueryAsc = "searchQuery_ASC",
  SearchQueryDesc = "searchQuery_DESC",
  ShowCarouselNavigationArrowsAsc = "showCarouselNavigationArrows_ASC",
  ShowCarouselNavigationArrowsDesc = "showCarouselNavigationArrows_DESC",
  ShowFiltersAsc = "showFilters_ASC",
  ShowFiltersDesc = "showFilters_DESC",
  ShowSortingAsc = "showSorting_ASC",
  ShowSortingDesc = "showSorting_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionClaimCollectionOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OffsetLeftPercentAsc = "offsetLeftPercent_ASC",
  OffsetLeftPercentDesc = "offsetLeftPercent_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionClaimCursorCollectionOrder {
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OffsetLeftPercentAsc = "offsetLeftPercent_ASC",
  OffsetLeftPercentDesc = "offsetLeftPercent_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextAsc = "text_ASC",
  TextDesc = "text_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionCounterCollectionOrder {
  FootnoteAsc = "footnote_ASC",
  FootnoteDesc = "footnote_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionCounterCursorCollectionOrder {
  FootnoteAsc = "footnote_ASC",
  FootnoteDesc = "footnote_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionGalleryCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionGalleryCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  VariantAsc = "variant_ASC",
  VariantDesc = "variant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionIntroTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionIntroTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineLevelAsc = "headlineLevel_ASC",
  HeadlineLevelDesc = "headlineLevel_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionMediaCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionMediaCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  AspectRatioAsc = "aspectRatio_ASC",
  AspectRatioDesc = "aspectRatio_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  BackgroundVideoAsc = "backgroundVideo_ASC",
  BackgroundVideoDesc = "backgroundVideo_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  LoopAsc = "loop_ASC",
  LoopDesc = "loop_DESC",
  MutedAsc = "muted_ASC",
  MutedDesc = "muted_DESC",
  ProgressbarColorAsc = "progressbarColor_ASC",
  ProgressbarColorDesc = "progressbarColor_DESC",
  ShowControlsAsc = "showControls_ASC",
  ShowControlsDesc = "showControls_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionQuoteCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionQuoteCursorCollectionOrder {
  AuthorNameAsc = "authorName_ASC",
  AuthorNameDesc = "authorName_DESC",
  AuthorTeamAsc = "authorTeam_ASC",
  AuthorTeamDesc = "authorTeam_DESC",
  EyebrowAsc = "eyebrow_ASC",
  EyebrowDesc = "eyebrow_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  QuoteTypeAsc = "quoteType_ASC",
  QuoteTypeDesc = "quoteType_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionSliderCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionSliderCursorCollectionOrder {
  AutoplayDurationAsc = "autoplayDuration_ASC",
  AutoplayDurationDesc = "autoplayDuration_DESC",
  AutoplayAsc = "autoplay_ASC",
  AutoplayDesc = "autoplay_DESC",
  FullWidthAsc = "fullWidth_ASC",
  FullWidthDesc = "fullWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTaglineCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTaglineCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTextCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTextCursorCollectionOrder {
  AnchorIdAsc = "anchorId_ASC",
  AnchorIdDesc = "anchorId_DESC",
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  HeadlineDashAsc = "headlineDash_ASC",
  HeadlineDashDesc = "headlineDash_DESC",
  HeadlineVariantAsc = "headlineVariant_ASC",
  HeadlineVariantDesc = "headlineVariant_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColumnsAsc = "textColumns_ASC",
  TextColumnsDesc = "textColumns_DESC",
  TextVariantAsc = "textVariant_ASC",
  TextVariantDesc = "textVariant_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTextImageCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsSectionTextImageCursorCollectionOrder {
  ContainerWidthAsc = "containerWidth_ASC",
  ContainerWidthDesc = "containerWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  OrderReverseAsc = "orderReverse_ASC",
  OrderReverseDesc = "orderReverse_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum UiConfigurationLinkingCollectionsTabContainerD2CCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum UiConfigurationLinkingCollectionsTabContainerD2CCursorCollectionOrder {
  ColumnWidthAsc = "columnWidth_ASC",
  ColumnWidthDesc = "columnWidth_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ShowNavigationArrowsAsc = "showNavigationArrows_ASC",
  ShowNavigationArrowsDesc = "showNavigationArrows_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum UiConfigurationOrder {
  BackgroundColorAsc = "backgroundColor_ASC",
  BackgroundColorDesc = "backgroundColor_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  PaddingBottomAsc = "paddingBottom_ASC",
  PaddingBottomDesc = "paddingBottom_DESC",
  PaddingTopAsc = "paddingTop_ASC",
  PaddingTopDesc = "paddingTop_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TextColorAsc = "textColor_ASC",
  TextColorDesc = "textColor_DESC",
}

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/video) */
export type Video = Entry &
  _Node & {
    __typename?: "Video";
    _id: Scalars["ID"]["output"];
    caption?: Maybe<Scalars["String"]["output"]>;
    contentfulMetadata: ContentfulMetadata;
    internalName?: Maybe<Scalars["String"]["output"]>;
    linkedFrom?: Maybe<VideoLinkingCollections>;
    sys: Sys;
    video?: Maybe<Scalars["JSON"]["output"]>;
  };

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/video) */
export type VideoCaptionArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/video) */
export type VideoInternalNameArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/video) */
export type VideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** [See type definition](https://app.contentful.com/spaces/er3l2x25q5uz/content_types/video) */
export type VideoVideoArgs = {
  locale?: InputMaybe<Scalars["String"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoCollection = {
  __typename?: "VideoCollection";
  items: Array<Maybe<Video>>;
  limit: Scalars["Int"]["output"];
  skip: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

export type VideoCursorCollection = {
  __typename?: "VideoCursorCollection";
  items: Array<Maybe<Video>>;
  limit: Scalars["Int"]["output"];
  pages: CursorPages;
};

export type VideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  video_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollections = {
  __typename?: "VideoLinkingCollections";
  catalogCollection?: Maybe<CatalogCollection>;
  catalogCursorCollection?: Maybe<CatalogCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
};

export type VideoLinkingCollectionsCatalogCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsCatalogCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollectionsCatalogCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsCatalogCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollectionsProductCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsProductCollectionOrder>>>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  skip?: InputMaybe<Scalars["Int"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VideoLinkingCollectionsProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsProductCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars["String"]["input"]>;
  pagePrev?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  useFallbackLocale?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum VideoLinkingCollectionsCatalogCollectionOrder {
  CatalogIdAsc = "catalogId_ASC",
  CatalogIdDesc = "catalogId_DESC",
  CatalogNameAsc = "catalogName_ASC",
  CatalogNameDesc = "catalogName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum VideoLinkingCollectionsCatalogCursorCollectionOrder {
  CatalogIdAsc = "catalogId_ASC",
  CatalogIdDesc = "catalogId_DESC",
  CatalogNameAsc = "catalogName_ASC",
  CatalogNameDesc = "catalogName_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
  TitleAsc = "title_ASC",
  TitleDesc = "title_DESC",
}

export enum VideoLinkingCollectionsProductCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum VideoLinkingCollectionsProductCursorCollectionOrder {
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  ProductCodeAsc = "productCode_ASC",
  ProductCodeDesc = "productCode_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export enum VideoOrder {
  CaptionAsc = "caption_ASC",
  CaptionDesc = "caption_DESC",
  InternalNameAsc = "internalName_ASC",
  InternalNameDesc = "internalName_DESC",
  SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC",
  SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC",
  SysIdAsc = "sys_id_ASC",
  SysIdDesc = "sys_id_DESC",
  SysPublishedAtAsc = "sys_publishedAt_ASC",
  SysPublishedAtDesc = "sys_publishedAt_DESC",
  SysPublishedVersionAsc = "sys_publishedVersion_ASC",
  SysPublishedVersionDesc = "sys_publishedVersion_DESC",
}

export type _Node = {
  _id: Scalars["ID"]["output"];
};

export type CfAccordionItemD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAccordionItemD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAccordionItemD2CNestedFilter>>>;
  contentBlocksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfAthleteNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAthleteNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAthleteNestedFilter>>>;
  biography_contains?: InputMaybe<Scalars["String"]["input"]>;
  biography_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  biography_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  country_contains?: InputMaybe<Scalars["String"]["input"]>;
  country_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  country_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  country_not?: InputMaybe<Scalars["String"]["input"]>;
  country_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  firstName_contains?: InputMaybe<Scalars["String"]["input"]>;
  firstName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  firstName_not?: InputMaybe<Scalars["String"]["input"]>;
  firstName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastName_contains?: InputMaybe<Scalars["String"]["input"]>;
  lastName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastName_not?: InputMaybe<Scalars["String"]["input"]>;
  lastName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resultsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  socialLinksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  team?: InputMaybe<Scalars["String"]["input"]>;
  team_contains?: InputMaybe<Scalars["String"]["input"]>;
  team_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  team_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  team_not?: InputMaybe<Scalars["String"]["input"]>;
  team_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  team_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfAthleteResultsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAthleteResultsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAthleteResultsNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  date_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  date_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  position?: InputMaybe<Scalars["String"]["input"]>;
  position_contains?: InputMaybe<Scalars["String"]["input"]>;
  position_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  position_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  position_not?: InputMaybe<Scalars["String"]["input"]>;
  position_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  position_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  race?: InputMaybe<Scalars["String"]["input"]>;
  race_contains?: InputMaybe<Scalars["String"]["input"]>;
  race_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  race_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  race_not?: InputMaybe<Scalars["String"]["input"]>;
  race_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  race_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfContentPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentPageNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageType?: InputMaybe<Scalars["String"]["input"]>;
  pageType_contains?: InputMaybe<Scalars["String"]["input"]>;
  pageType_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageType_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pageType_not?: InputMaybe<Scalars["String"]["input"]>;
  pageType_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  pageType_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  primaryTopic_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sectionsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoMetadata_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug?: InputMaybe<Scalars["String"]["input"]>;
  slug_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slug_not?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfCounterItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCounterItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCounterItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  prefix_contains?: InputMaybe<Scalars["String"]["input"]>;
  prefix_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  prefix_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  prefix_not?: InputMaybe<Scalars["String"]["input"]>;
  prefix_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  prefix_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline?: InputMaybe<Scalars["String"]["input"]>;
  subline_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline_not?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  suffix_contains?: InputMaybe<Scalars["String"]["input"]>;
  suffix_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  suffix_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  suffix_not?: InputMaybe<Scalars["String"]["input"]>;
  suffix_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  suffix_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["Int"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_gt?: InputMaybe<Scalars["Int"]["input"]>;
  value_gte?: InputMaybe<Scalars["Int"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  value_lt?: InputMaybe<Scalars["Int"]["input"]>;
  value_lte?: InputMaybe<Scalars["Int"]["input"]>;
  value_not?: InputMaybe<Scalars["Int"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type CfEditorialTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfEditorialTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfEditorialTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CfHeadlineBlockNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeadlineBlockNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeadlineBlockNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrow?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow_not?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline?: InputMaybe<Scalars["String"]["input"]>;
  subline_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  subline_not?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfImageNestedFilter>>>;
  alternativeText?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  alternativeText_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  alternativeText_not?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfLinkActionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLinkActionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLinkActionNestedFilter>>>;
  anchor?: InputMaybe<Scalars["String"]["input"]>;
  anchor_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchor_not?: InputMaybe<Scalars["String"]["input"]>;
  anchor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  externalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalPage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  microcopy_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  target?: InputMaybe<Scalars["String"]["input"]>;
  target_contains?: InputMaybe<Scalars["String"]["input"]>;
  target_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  target_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  target_not?: InputMaybe<Scalars["String"]["input"]>;
  target_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  target_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant?: InputMaybe<Scalars["String"]["input"]>;
  variant_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant_not?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  page_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  url_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url_not?: InputMaybe<Scalars["String"]["input"]>;
  url_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfMediaImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMediaImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMediaImageNestedFilter>>>;
  alternativeText?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  alternativeText_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  alternativeText_not?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  alternativeText_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hasFocalPoint?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFocalPoint_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFocalPoint_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMicrocopyItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMicrocopyItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMicrocopyItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_not?: InputMaybe<Scalars["String"]["input"]>;
  key_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  value_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  value_not?: InputMaybe<Scalars["String"]["input"]>;
  value_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfMicrocopyNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMicrocopyNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMicrocopyNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  key_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  key_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_not?: InputMaybe<Scalars["String"]["input"]>;
  key_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  value?: InputMaybe<Scalars["String"]["input"]>;
  value_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  value_not?: InputMaybe<Scalars["String"]["input"]>;
  value_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfNavigationColumnD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationColumnD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationColumnD2CNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline?: InputMaybe<Scalars["String"]["input"]>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_not?: InputMaybe<Scalars["String"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  itemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  teaser_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_not?: InputMaybe<Scalars["String"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfNavigationItemD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationItemD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationItemD2CNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  megaMenu_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type CfNavigationLinkItemD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationLinkItemD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationLinkItemD2CNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  label_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  label_not?: InputMaybe<Scalars["String"]["input"]>;
  label_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  subItemsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type CfNavigationMegaMenuD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationMegaMenuD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationMegaMenuD2CNestedFilter>>>;
  columnsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  mobileTeaser_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  secondaryColumnsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceLinksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  teasersCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfNavigationTeaserD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationTeaserD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationTeaserD2CNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  eyebrow_not?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_contains?: InputMaybe<Scalars["String"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  bottomContentAreaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  canonicalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  noIndex_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  nofollow_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  path_contains?: InputMaybe<Scalars["String"]["input"]>;
  path_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  path_not?: InputMaybe<Scalars["String"]["input"]>;
  path_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoDescription?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoDescription_not?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoKeywords_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoTitle?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  seoTitle_not?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  topContentAreaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfPrimaryTopicProductCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPrimaryTopicProductCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPrimaryTopicProductCategoryNestedFilter>>>;
  commerceCategoryId?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_contains?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  commerceCategoryId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  commerceCategoryId_not?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  commerceCategoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  lastImportDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastImportDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  lastImportDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastImportDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  parentTopicsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceLastModifiedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceLastModifiedDate_gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  sourceLastModifiedDate_lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_not?: InputMaybe<Scalars["DateTime"]["input"]>;
  sourceLastModifiedDate_not_in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  sourcePlpUrl?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourcePlpUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sourcePlpUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  sourcePlpUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sourceSystemUid?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceSystemUid_gt?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_gte?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sourceSystemUid_lt?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_lte?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_not?: InputMaybe<Scalars["Int"]["input"]>;
  sourceSystemUid_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfProductListItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductListItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductListItemNestedFilter>>>;
  colorCode?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  colorCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  colorCode_not?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  colorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode?: InputMaybe<Scalars["String"]["input"]>;
  productCode_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCode_not?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfProductListingNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductListingNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductListingNestedFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultSort?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultSort_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  defaultSort_not?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  defaultSort_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageSize_gt?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_gte?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  pageSize_lt?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_lte?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_not?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  paginationMode?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_contains?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paginationMode_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paginationMode_not?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paginationMode_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCategory?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCategory_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productCategory_not?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  productCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_contains?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchQuery_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  searchQuery_not?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  searchQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  showCarouselNavigationArrows?: InputMaybe<Scalars["Boolean"]["input"]>;
  showCarouselNavigationArrows_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showCarouselNavigationArrows_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showFilters_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  showSorting_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  specificProductsCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant?: InputMaybe<Scalars["String"]["input"]>;
  variant_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  variant_not?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfSectionHeroNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSectionHeroNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSectionHeroNestedFilter>>>;
  additionalSlidesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplayDuration_gt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_gte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplayDuration_lt?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_lte?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not?: InputMaybe<Scalars["Int"]["input"]>;
  autoplayDuration_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  autoplay_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoplay_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  backgroundColor_not?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  buttonsPosition?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  buttonsPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  buttonsPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  buttonsPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  content_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineSize?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineSize_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineSize_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineSize_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  heroLayout?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_contains?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  heroLayout_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  heroLayout_not?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  heroLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  mediaCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  presentation?: InputMaybe<Scalars["String"]["input"]>;
  presentation_contains?: InputMaybe<Scalars["String"]["input"]>;
  presentation_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  presentation_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  presentation_not?: InputMaybe<Scalars["String"]["input"]>;
  presentation_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  presentation_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  svg_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  textColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textColor_not?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textHorizontalPosition?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textHorizontalPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textHorizontalPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textHorizontalPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVerticalPosition?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVerticalPosition_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVerticalPosition_not?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVerticalPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfSectionTaglineNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSectionTaglineNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSectionTaglineNestedFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars["String"]["input"]>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  text_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfSectionTextImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSectionTextImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSectionTextImageNestedFilter>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  media_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderReverse_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfSectionTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSectionTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSectionTextNestedFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineDash?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineDash_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineDash_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineVariant?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  headlineVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headlineVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  headlineVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  headline_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  textColumns?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColumns_gt?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_gte?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  textColumns_lt?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_lte?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_not?: InputMaybe<Scalars["Int"]["input"]>;
  textColumns_not_in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  textVariant?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textVariant_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textVariant_not?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  text_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  uiConfiguration_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfSeoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSeoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSeoNestedFilter>>>;
  canonicalUrl?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  canonicalUrl_not?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  description_not?: InputMaybe<Scalars["String"]["input"]>;
  description_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  excludeLinksFromRankingsNofollow?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludeLinksFromRankingsNofollow_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludeLinksFromRankingsNofollow_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  hideFromSearchEnginesNoindex_not?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  keywords_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  openGraphImage_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfSocialLinksNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSocialLinksNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSocialLinksNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  platform?: InputMaybe<Scalars["String"]["input"]>;
  platform_contains?: InputMaybe<Scalars["String"]["input"]>;
  platform_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  platform_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  platform_not?: InputMaybe<Scalars["String"]["input"]>;
  platform_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  platform_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  url_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  url_not?: InputMaybe<Scalars["String"]["input"]>;
  url_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfTabContainerItemD2CNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabContainerItemD2CNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabContainerItemD2CNestedFilter>>>;
  contentBlocksCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  title_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_not?: InputMaybe<Scalars["String"]["input"]>;
  title_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfTeaserItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTeaserItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTeaserItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  link_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
};

export type CfUiConfigurationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfUiConfigurationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfUiConfigurationNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  backgroundColor_not?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingBottom?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paddingBottom_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingBottom_not?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingTop?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  paddingTop_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paddingTop_not?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  paddingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  textColor_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  textColor_not?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfVideoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  caption?: InputMaybe<Scalars["String"]["input"]>;
  caption_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  caption_not?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
  video_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CfbottomContentAreaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfbottomContentAreaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfbottomContentAreaMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  microcopiesCollection_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  sys?: InputMaybe<SysFilter>;
  ui?: InputMaybe<Scalars["String"]["input"]>;
  ui_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  ui_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ui_not?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  ui_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CfcontentBlocksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentBlocksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentBlocksMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  anchorId_not?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerWidth_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  containerWidth_not?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  containerWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfcontentSectionsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentSectionsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentSectionsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfentriesMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfentriesMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfentriesMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfentryMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfentryMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfentryMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfitemsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfitemsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfitemsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfmediaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfmediaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfmediaMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfsectionsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfsectionsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfsectionsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CftopContentAreaMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CftopContentAreaMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CftopContentAreaMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars["String"]["input"]>;
  internalName_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_exists?: InputMaybe<Scalars["Boolean"]["input"]>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  internalName_not?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_contains?: InputMaybe<Scalars["String"]["input"]>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ConfigFragment = {
  __typename: "Config";
  _id: string;
  slugProductListingPage?: string | null;
  slugProductDetailPage?: string | null;
  sys: { __typename?: "Sys"; id: string };
};

export type ConfigQueryVariables = Exact<{
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ConfigQuery = {
  __typename?: "Query";
  configCollection?: {
    __typename?: "ConfigCollection";
    items: Array<{
      __typename: "Config";
      _id: string;
      slugProductListingPage?: string | null;
      slugProductDetailPage?: string | null;
      sys: { __typename?: "Sys"; id: string };
    } | null>;
  } | null;
};

export type DivisionNavigationQueryVariables = Exact<{
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  baseStoreUid: Scalars["String"]["input"];
}>;

export type DivisionNavigationQuery = {
  __typename?: "Query";
  divisionNavigationCollection?: {
    __typename?: "DivisionNavigationCollection";
    items: Array<{
      __typename: "DivisionNavigation";
      internalName?: string | null;
      ariaLabel?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      divisionsCollection?: {
        __typename?: "DivisionNavigationDivisionsCollection";
        items: Array<{
          __typename: "TeaserItem";
          internalName?: string | null;
          sys: { __typename?: "Sys"; id: string };
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          link?: {
            __typename: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type HomePageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type HomePageQuery = {
  __typename?: "Query";
  homePageCollection?: {
    __typename?: "HomePageCollection";
    items: Array<{
      __typename: "HomePage";
      title?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      seoMetadata?: {
        __typename: "Seo";
        title?: string | null;
        description?: string | null;
        keywords?: Array<string | null> | null;
        canonicalUrl?: string | null;
        hideFromSearchEnginesNoindex?: boolean | null;
        excludeLinksFromRankingsNofollow?: boolean | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        openGraphImage?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
      } | null;
      introSectionCollection?: {
        __typename?: "HomePageIntroSectionCollection";
        items: Array<{ __typename: "SectionHero"; sectionReference: { __typename?: "Sys"; id: string } } | null>;
      } | null;
      contentSectionsCollection?: {
        __typename?: "HomePageContentSectionsCollection";
        items: Array<
          | { __typename: "AccordionD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "ContentSliderD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "GeometryTable"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "Hotspot"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "ProductListing"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionClaim"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionCounter"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionGallery"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionMedia"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionQuote"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionSlider"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionTeaser"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionText"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionTextImage"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "TabContainerD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | null
        >;
      } | null;
      bottomSectionCollection?: {
        __typename?: "HomePageBottomSectionCollection";
        items: Array<{ __typename: "SectionTagline"; sectionReference: { __typename?: "Sys"; id: string } } | null>;
      } | null;
    } | null>;
  } | null;
};

export type NavigationQueryVariables = Exact<{
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  conceptIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  storeConceptIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type NavigationQuery = {
  __typename?: "Query";
  header?: {
    __typename?: "NavigationD2CCollection";
    items: Array<{
      __typename: "NavigationD2C";
      internalName?: string | null;
      navigationType?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      navigationItemsCollection?: {
        __typename?: "NavigationD2CNavigationItemsCollection";
        items: Array<{
          __typename?: "NavigationItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          megaMenu?: {
            __typename?: "NavigationMegaMenuD2C";
            columnsCollection?: {
              __typename?: "NavigationMegaMenuD2CColumnsCollection";
              items: Array<{
                __typename?: "NavigationColumnD2C";
                headline?: string | null;
                text?: string | null;
                sys: { __typename?: "Sys"; id: string };
                itemsCollection?: {
                  __typename?: "NavigationColumnD2CItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                    subItemsCollection?: {
                      __typename?: "NavigationLinkItemD2CSubItemsCollection";
                      items: Array<{
                        __typename?: "NavigationLinkItemD2C";
                        internalName?: string | null;
                        label?: string | null;
                        sys: { __typename?: "Sys"; id: string };
                        link?: {
                          __typename?: "LinkAction";
                          text?: string | null;
                          externalUrl?: string | null;
                          anchor?: string | null;
                          target?: string | null;
                          variant?: string | null;
                          sys: { __typename?: "Sys"; id: string };
                          microcopy?: {
                            __typename?: "MicrocopyItem";
                            key?: string | null;
                            value?: string | null;
                          } | null;
                          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                        } | null;
                      } | null>;
                    } | null;
                  } | null>;
                } | null;
                cta?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                teaser?: {
                  __typename?: "NavigationTeaserD2C";
                  eyebrow?: string | null;
                  description?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                  image?: {
                    __typename: "MediaImage";
                    alternativeText?: string | null;
                    caption?: string | null;
                    image?: any | null;
                    hasFocalPoint?: boolean | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
            secondaryColumnsCollection?: {
              __typename?: "NavigationMegaMenuD2CSecondaryColumnsCollection";
              items: Array<{
                __typename?: "NavigationColumnD2C";
                headline?: string | null;
                text?: string | null;
                sys: { __typename?: "Sys"; id: string };
                itemsCollection?: {
                  __typename?: "NavigationColumnD2CItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                    subItemsCollection?: {
                      __typename?: "NavigationLinkItemD2CSubItemsCollection";
                      items: Array<{
                        __typename?: "NavigationLinkItemD2C";
                        internalName?: string | null;
                        label?: string | null;
                        sys: { __typename?: "Sys"; id: string };
                        link?: {
                          __typename?: "LinkAction";
                          text?: string | null;
                          externalUrl?: string | null;
                          anchor?: string | null;
                          target?: string | null;
                          variant?: string | null;
                          sys: { __typename?: "Sys"; id: string };
                          microcopy?: {
                            __typename?: "MicrocopyItem";
                            key?: string | null;
                            value?: string | null;
                          } | null;
                          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                        } | null;
                      } | null>;
                    } | null;
                  } | null>;
                } | null;
                cta?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                teaser?: {
                  __typename?: "NavigationTeaserD2C";
                  eyebrow?: string | null;
                  description?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                  image?: {
                    __typename: "MediaImage";
                    alternativeText?: string | null;
                    caption?: string | null;
                    image?: any | null;
                    hasFocalPoint?: boolean | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
            serviceLinksCollection?: {
              __typename?: "NavigationMegaMenuD2CServiceLinksCollection";
              items: Array<{
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null>;
            } | null;
            teasersCollection?: {
              __typename?: "NavigationMegaMenuD2CTeasersCollection";
              items: Array<{
                __typename?: "NavigationTeaserD2C";
                eyebrow?: string | null;
                description?: string | null;
                sys: { __typename?: "Sys"; id: string };
                headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                image?: {
                  __typename: "MediaImage";
                  alternativeText?: string | null;
                  caption?: string | null;
                  image?: any | null;
                  hasFocalPoint?: boolean | null;
                  sys: { __typename?: "Sys"; id: string };
                } | null;
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
              } | null>;
            } | null;
            mobileTeaser?: {
              __typename?: "NavigationTeaserD2C";
              eyebrow?: string | null;
              description?: string | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      serviceLinksCollection?: {
        __typename?: "NavigationD2CServiceLinksCollection";
        items: Array<{
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null>;
      } | null;
      teaser?: {
        __typename?: "NavigationTeaserD2C";
        eyebrow?: string | null;
        description?: string | null;
        sys: { __typename?: "Sys"; id: string };
        headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
        link?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
      } | null;
      columnsCollection?: {
        __typename?: "NavigationD2CColumnsCollection";
        items: Array<{
          __typename?: "NavigationColumnD2C";
          headline?: string | null;
          text?: string | null;
          sys: { __typename?: "Sys"; id: string };
          itemsCollection?: {
            __typename?: "NavigationColumnD2CItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
              subItemsCollection?: {
                __typename?: "NavigationLinkItemD2CSubItemsCollection";
                items: Array<{
                  __typename?: "NavigationLinkItemD2C";
                  internalName?: string | null;
                  label?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null>;
              } | null;
            } | null>;
          } | null;
          cta?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          teaser?: {
            __typename?: "NavigationTeaserD2C";
            eyebrow?: string | null;
            description?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
            image?: {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      addressesCollection?: {
        __typename?: "NavigationD2CAddressesCollection";
        items: Array<{
          __typename?: "NavigationColumnD2C";
          headline?: string | null;
          text?: string | null;
          sys: { __typename?: "Sys"; id: string };
          itemsCollection?: {
            __typename?: "NavigationColumnD2CItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
              subItemsCollection?: {
                __typename?: "NavigationLinkItemD2CSubItemsCollection";
                items: Array<{
                  __typename?: "NavigationLinkItemD2C";
                  internalName?: string | null;
                  label?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null>;
              } | null;
            } | null>;
          } | null;
          cta?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          teaser?: {
            __typename?: "NavigationTeaserD2C";
            eyebrow?: string | null;
            description?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
            image?: {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
  footer?: {
    __typename?: "NavigationD2CCollection";
    items: Array<{
      __typename: "NavigationD2C";
      internalName?: string | null;
      navigationType?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      navigationItemsCollection?: {
        __typename?: "NavigationD2CNavigationItemsCollection";
        items: Array<{
          __typename?: "NavigationItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          megaMenu?: {
            __typename?: "NavigationMegaMenuD2C";
            columnsCollection?: {
              __typename?: "NavigationMegaMenuD2CColumnsCollection";
              items: Array<{
                __typename?: "NavigationColumnD2C";
                headline?: string | null;
                text?: string | null;
                sys: { __typename?: "Sys"; id: string };
                itemsCollection?: {
                  __typename?: "NavigationColumnD2CItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                    subItemsCollection?: {
                      __typename?: "NavigationLinkItemD2CSubItemsCollection";
                      items: Array<{
                        __typename?: "NavigationLinkItemD2C";
                        internalName?: string | null;
                        label?: string | null;
                        sys: { __typename?: "Sys"; id: string };
                        link?: {
                          __typename?: "LinkAction";
                          text?: string | null;
                          externalUrl?: string | null;
                          anchor?: string | null;
                          target?: string | null;
                          variant?: string | null;
                          sys: { __typename?: "Sys"; id: string };
                          microcopy?: {
                            __typename?: "MicrocopyItem";
                            key?: string | null;
                            value?: string | null;
                          } | null;
                          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                        } | null;
                      } | null>;
                    } | null;
                  } | null>;
                } | null;
                cta?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                teaser?: {
                  __typename?: "NavigationTeaserD2C";
                  eyebrow?: string | null;
                  description?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                  image?: {
                    __typename: "MediaImage";
                    alternativeText?: string | null;
                    caption?: string | null;
                    image?: any | null;
                    hasFocalPoint?: boolean | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
            secondaryColumnsCollection?: {
              __typename?: "NavigationMegaMenuD2CSecondaryColumnsCollection";
              items: Array<{
                __typename?: "NavigationColumnD2C";
                headline?: string | null;
                text?: string | null;
                sys: { __typename?: "Sys"; id: string };
                itemsCollection?: {
                  __typename?: "NavigationColumnD2CItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                    subItemsCollection?: {
                      __typename?: "NavigationLinkItemD2CSubItemsCollection";
                      items: Array<{
                        __typename?: "NavigationLinkItemD2C";
                        internalName?: string | null;
                        label?: string | null;
                        sys: { __typename?: "Sys"; id: string };
                        link?: {
                          __typename?: "LinkAction";
                          text?: string | null;
                          externalUrl?: string | null;
                          anchor?: string | null;
                          target?: string | null;
                          variant?: string | null;
                          sys: { __typename?: "Sys"; id: string };
                          microcopy?: {
                            __typename?: "MicrocopyItem";
                            key?: string | null;
                            value?: string | null;
                          } | null;
                          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                        } | null;
                      } | null>;
                    } | null;
                  } | null>;
                } | null;
                cta?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                teaser?: {
                  __typename?: "NavigationTeaserD2C";
                  eyebrow?: string | null;
                  description?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                  image?: {
                    __typename: "MediaImage";
                    alternativeText?: string | null;
                    caption?: string | null;
                    image?: any | null;
                    hasFocalPoint?: boolean | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null;
              } | null>;
            } | null;
            serviceLinksCollection?: {
              __typename?: "NavigationMegaMenuD2CServiceLinksCollection";
              items: Array<{
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null>;
            } | null;
            teasersCollection?: {
              __typename?: "NavigationMegaMenuD2CTeasersCollection";
              items: Array<{
                __typename?: "NavigationTeaserD2C";
                eyebrow?: string | null;
                description?: string | null;
                sys: { __typename?: "Sys"; id: string };
                headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
                image?: {
                  __typename: "MediaImage";
                  alternativeText?: string | null;
                  caption?: string | null;
                  image?: any | null;
                  hasFocalPoint?: boolean | null;
                  sys: { __typename?: "Sys"; id: string };
                } | null;
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
              } | null>;
            } | null;
            mobileTeaser?: {
              __typename?: "NavigationTeaserD2C";
              eyebrow?: string | null;
              description?: string | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      serviceLinksCollection?: {
        __typename?: "NavigationD2CServiceLinksCollection";
        items: Array<{
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null>;
      } | null;
      teaser?: {
        __typename?: "NavigationTeaserD2C";
        eyebrow?: string | null;
        description?: string | null;
        sys: { __typename?: "Sys"; id: string };
        headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
        link?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
      } | null;
      columnsCollection?: {
        __typename?: "NavigationD2CColumnsCollection";
        items: Array<{
          __typename?: "NavigationColumnD2C";
          headline?: string | null;
          text?: string | null;
          sys: { __typename?: "Sys"; id: string };
          itemsCollection?: {
            __typename?: "NavigationColumnD2CItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
              subItemsCollection?: {
                __typename?: "NavigationLinkItemD2CSubItemsCollection";
                items: Array<{
                  __typename?: "NavigationLinkItemD2C";
                  internalName?: string | null;
                  label?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null>;
              } | null;
            } | null>;
          } | null;
          cta?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          teaser?: {
            __typename?: "NavigationTeaserD2C";
            eyebrow?: string | null;
            description?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
            image?: {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
      addressesCollection?: {
        __typename?: "NavigationD2CAddressesCollection";
        items: Array<{
          __typename?: "NavigationColumnD2C";
          headline?: string | null;
          text?: string | null;
          sys: { __typename?: "Sys"; id: string };
          itemsCollection?: {
            __typename?: "NavigationColumnD2CItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
              subItemsCollection?: {
                __typename?: "NavigationLinkItemD2CSubItemsCollection";
                items: Array<{
                  __typename?: "NavigationLinkItemD2C";
                  internalName?: string | null;
                  label?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  link?: {
                    __typename?: "LinkAction";
                    text?: string | null;
                    externalUrl?: string | null;
                    anchor?: string | null;
                    target?: string | null;
                    variant?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                  } | null;
                } | null>;
              } | null;
            } | null>;
          } | null;
          cta?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          teaser?: {
            __typename?: "NavigationTeaserD2C";
            eyebrow?: string | null;
            description?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
            image?: {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type NavigationD2cFieldsFragment = {
  __typename: "NavigationD2C";
  internalName?: string | null;
  navigationType?: string | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  navigationItemsCollection?: {
    __typename?: "NavigationD2CNavigationItemsCollection";
    items: Array<{
      __typename?: "NavigationItemD2C";
      internalName?: string | null;
      label?: string | null;
      sys: { __typename?: "Sys"; id: string };
      link?: {
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      megaMenu?: {
        __typename?: "NavigationMegaMenuD2C";
        columnsCollection?: {
          __typename?: "NavigationMegaMenuD2CColumnsCollection";
          items: Array<{
            __typename?: "NavigationColumnD2C";
            headline?: string | null;
            text?: string | null;
            sys: { __typename?: "Sys"; id: string };
            itemsCollection?: {
              __typename?: "NavigationColumnD2CItemsCollection";
              items: Array<{
                __typename?: "NavigationLinkItemD2C";
                internalName?: string | null;
                label?: string | null;
                sys: { __typename?: "Sys"; id: string };
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                subItemsCollection?: {
                  __typename?: "NavigationLinkItemD2CSubItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                  } | null>;
                } | null;
              } | null>;
            } | null;
            cta?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
            teaser?: {
              __typename?: "NavigationTeaserD2C";
              eyebrow?: string | null;
              description?: string | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null;
          } | null>;
        } | null;
        secondaryColumnsCollection?: {
          __typename?: "NavigationMegaMenuD2CSecondaryColumnsCollection";
          items: Array<{
            __typename?: "NavigationColumnD2C";
            headline?: string | null;
            text?: string | null;
            sys: { __typename?: "Sys"; id: string };
            itemsCollection?: {
              __typename?: "NavigationColumnD2CItemsCollection";
              items: Array<{
                __typename?: "NavigationLinkItemD2C";
                internalName?: string | null;
                label?: string | null;
                sys: { __typename?: "Sys"; id: string };
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
                subItemsCollection?: {
                  __typename?: "NavigationLinkItemD2CSubItemsCollection";
                  items: Array<{
                    __typename?: "NavigationLinkItemD2C";
                    internalName?: string | null;
                    label?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                    link?: {
                      __typename?: "LinkAction";
                      text?: string | null;
                      externalUrl?: string | null;
                      anchor?: string | null;
                      target?: string | null;
                      variant?: string | null;
                      sys: { __typename?: "Sys"; id: string };
                      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                    } | null;
                  } | null>;
                } | null;
              } | null>;
            } | null;
            cta?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
            teaser?: {
              __typename?: "NavigationTeaserD2C";
              eyebrow?: string | null;
              description?: string | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null;
          } | null>;
        } | null;
        serviceLinksCollection?: {
          __typename?: "NavigationMegaMenuD2CServiceLinksCollection";
          items: Array<{
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null>;
        } | null;
        teasersCollection?: {
          __typename?: "NavigationMegaMenuD2CTeasersCollection";
          items: Array<{
            __typename?: "NavigationTeaserD2C";
            eyebrow?: string | null;
            description?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
            image?: {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
          } | null>;
        } | null;
        mobileTeaser?: {
          __typename?: "NavigationTeaserD2C";
          eyebrow?: string | null;
          description?: string | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  serviceLinksCollection?: {
    __typename?: "NavigationD2CServiceLinksCollection";
    items: Array<{
      __typename?: "LinkAction";
      text?: string | null;
      externalUrl?: string | null;
      anchor?: string | null;
      target?: string | null;
      variant?: string | null;
      sys: { __typename?: "Sys"; id: string };
      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
    } | null>;
  } | null;
  teaser?: {
    __typename?: "NavigationTeaserD2C";
    eyebrow?: string | null;
    description?: string | null;
    sys: { __typename?: "Sys"; id: string };
    headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
    image?: {
      __typename: "MediaImage";
      alternativeText?: string | null;
      caption?: string | null;
      image?: any | null;
      hasFocalPoint?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
    } | null;
    link?: {
      __typename?: "LinkAction";
      text?: string | null;
      externalUrl?: string | null;
      anchor?: string | null;
      target?: string | null;
      variant?: string | null;
      sys: { __typename?: "Sys"; id: string };
      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
    } | null;
  } | null;
  columnsCollection?: {
    __typename?: "NavigationD2CColumnsCollection";
    items: Array<{
      __typename?: "NavigationColumnD2C";
      headline?: string | null;
      text?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "NavigationColumnD2CItemsCollection";
        items: Array<{
          __typename?: "NavigationLinkItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          subItemsCollection?: {
            __typename?: "NavigationLinkItemD2CSubItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
      cta?: {
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      teaser?: {
        __typename?: "NavigationTeaserD2C";
        eyebrow?: string | null;
        description?: string | null;
        sys: { __typename?: "Sys"; id: string };
        headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
        link?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  addressesCollection?: {
    __typename?: "NavigationD2CAddressesCollection";
    items: Array<{
      __typename?: "NavigationColumnD2C";
      headline?: string | null;
      text?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "NavigationColumnD2CItemsCollection";
        items: Array<{
          __typename?: "NavigationLinkItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          subItemsCollection?: {
            __typename?: "NavigationLinkItemD2CSubItemsCollection";
            items: Array<{
              __typename?: "NavigationLinkItemD2C";
              internalName?: string | null;
              label?: string | null;
              sys: { __typename?: "Sys"; id: string };
              link?: {
                __typename?: "LinkAction";
                text?: string | null;
                externalUrl?: string | null;
                anchor?: string | null;
                target?: string | null;
                variant?: string | null;
                sys: { __typename?: "Sys"; id: string };
                microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
              } | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
      cta?: {
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      teaser?: {
        __typename?: "NavigationTeaserD2C";
        eyebrow?: string | null;
        description?: string | null;
        sys: { __typename?: "Sys"; id: string };
        headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
        link?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type NavigationItemD2cFieldsFragment = {
  __typename?: "NavigationItemD2C";
  internalName?: string | null;
  label?: string | null;
  sys: { __typename?: "Sys"; id: string };
  link?: {
    __typename?: "LinkAction";
    text?: string | null;
    externalUrl?: string | null;
    anchor?: string | null;
    target?: string | null;
    variant?: string | null;
    sys: { __typename?: "Sys"; id: string };
    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
  } | null;
  megaMenu?: {
    __typename?: "NavigationMegaMenuD2C";
    columnsCollection?: {
      __typename?: "NavigationMegaMenuD2CColumnsCollection";
      items: Array<{
        __typename?: "NavigationColumnD2C";
        headline?: string | null;
        text?: string | null;
        sys: { __typename?: "Sys"; id: string };
        itemsCollection?: {
          __typename?: "NavigationColumnD2CItemsCollection";
          items: Array<{
            __typename?: "NavigationLinkItemD2C";
            internalName?: string | null;
            label?: string | null;
            sys: { __typename?: "Sys"; id: string };
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
            subItemsCollection?: {
              __typename?: "NavigationLinkItemD2CSubItemsCollection";
              items: Array<{
                __typename?: "NavigationLinkItemD2C";
                internalName?: string | null;
                label?: string | null;
                sys: { __typename?: "Sys"; id: string };
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
              } | null>;
            } | null;
          } | null>;
        } | null;
        cta?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
        teaser?: {
          __typename?: "NavigationTeaserD2C";
          eyebrow?: string | null;
          description?: string | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    secondaryColumnsCollection?: {
      __typename?: "NavigationMegaMenuD2CSecondaryColumnsCollection";
      items: Array<{
        __typename?: "NavigationColumnD2C";
        headline?: string | null;
        text?: string | null;
        sys: { __typename?: "Sys"; id: string };
        itemsCollection?: {
          __typename?: "NavigationColumnD2CItemsCollection";
          items: Array<{
            __typename?: "NavigationLinkItemD2C";
            internalName?: string | null;
            label?: string | null;
            sys: { __typename?: "Sys"; id: string };
            link?: {
              __typename?: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null;
            subItemsCollection?: {
              __typename?: "NavigationLinkItemD2CSubItemsCollection";
              items: Array<{
                __typename?: "NavigationLinkItemD2C";
                internalName?: string | null;
                label?: string | null;
                sys: { __typename?: "Sys"; id: string };
                link?: {
                  __typename?: "LinkAction";
                  text?: string | null;
                  externalUrl?: string | null;
                  anchor?: string | null;
                  target?: string | null;
                  variant?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
                  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
                } | null;
              } | null>;
            } | null;
          } | null>;
        } | null;
        cta?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
        teaser?: {
          __typename?: "NavigationTeaserD2C";
          eyebrow?: string | null;
          description?: string | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null;
      } | null>;
    } | null;
    serviceLinksCollection?: {
      __typename?: "NavigationMegaMenuD2CServiceLinksCollection";
      items: Array<{
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null>;
    } | null;
    teasersCollection?: {
      __typename?: "NavigationMegaMenuD2CTeasersCollection";
      items: Array<{
        __typename?: "NavigationTeaserD2C";
        eyebrow?: string | null;
        description?: string | null;
        sys: { __typename?: "Sys"; id: string };
        headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
        link?: {
          __typename?: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null;
      } | null>;
    } | null;
    mobileTeaser?: {
      __typename?: "NavigationTeaserD2C";
      eyebrow?: string | null;
      description?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
      image?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      link?: {
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type NavigationColumnD2cFieldsFragment = {
  __typename?: "NavigationColumnD2C";
  headline?: string | null;
  text?: string | null;
  sys: { __typename?: "Sys"; id: string };
  itemsCollection?: {
    __typename?: "NavigationColumnD2CItemsCollection";
    items: Array<{
      __typename?: "NavigationLinkItemD2C";
      internalName?: string | null;
      label?: string | null;
      sys: { __typename?: "Sys"; id: string };
      link?: {
        __typename?: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      subItemsCollection?: {
        __typename?: "NavigationLinkItemD2CSubItemsCollection";
        items: Array<{
          __typename?: "NavigationLinkItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          link?: {
            __typename?: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
  cta?: {
    __typename?: "LinkAction";
    text?: string | null;
    externalUrl?: string | null;
    anchor?: string | null;
    target?: string | null;
    variant?: string | null;
    sys: { __typename?: "Sys"; id: string };
    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
  } | null;
  teaser?: {
    __typename?: "NavigationTeaserD2C";
    eyebrow?: string | null;
    description?: string | null;
    sys: { __typename?: "Sys"; id: string };
    headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
    image?: {
      __typename: "MediaImage";
      alternativeText?: string | null;
      caption?: string | null;
      image?: any | null;
      hasFocalPoint?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
    } | null;
    link?: {
      __typename?: "LinkAction";
      text?: string | null;
      externalUrl?: string | null;
      anchor?: string | null;
      target?: string | null;
      variant?: string | null;
      sys: { __typename?: "Sys"; id: string };
      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
    } | null;
  } | null;
};

export type NavigationTeaserD2cFieldsFragment = {
  __typename?: "NavigationTeaserD2C";
  eyebrow?: string | null;
  description?: string | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: { __typename?: "NavigationTeaserD2CHeadline"; json: any } | null;
  image?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  link?: {
    __typename?: "LinkAction";
    text?: string | null;
    externalUrl?: string | null;
    anchor?: string | null;
    target?: string | null;
    variant?: string | null;
    sys: { __typename?: "Sys"; id: string };
    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
  } | null;
};

export type PageByPathQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type PageByPathQuery = {
  __typename?: "Query";
  contentPageCollection?: {
    __typename?: "ContentPageCollection";
    items: Array<{
      __typename: "ContentPage";
      _id: string;
      slug?: string | null;
      title?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      seoMetadata?: {
        __typename: "Seo";
        title?: string | null;
        description?: string | null;
        keywords?: Array<string | null> | null;
        canonicalUrl?: string | null;
        hideFromSearchEnginesNoindex?: boolean | null;
        excludeLinksFromRankingsNofollow?: boolean | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        openGraphImage?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
      } | null;
      contentfulMetadata: {
        __typename?: "ContentfulMetadata";
        tags: Array<{ __typename?: "ContentfulTag"; id?: string | null; name?: string | null } | null>;
      };
      sectionsCollection?: {
        __typename?: "ContentPageSectionsCollection";
        items: Array<
          | { __typename: "AccordionD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "ContentSliderD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "GeometryTable"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "Hotspot"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "ProductListing"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionClaim"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionCounter"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionGallery"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionHero"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionIntroText"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionMedia"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionQuote"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionSlider"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionTagline"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionTeaser"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionText"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "SectionTextImage"; sectionReference: { __typename?: "Sys"; id: string } }
          | { __typename: "TabContainerD2C"; sectionReference: { __typename?: "Sys"; id: string } }
          | null
        >;
      } | null;
    } | null>;
  } | null;
};

export type ProductEnrichmentByProductCodeQueryVariables = Exact<{
  productCode: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ProductEnrichmentByProductCodeQuery = {
  __typename?: "Query";
  productEnrichmentCollection?: {
    __typename?: "ProductEnrichmentCollection";
    items: Array<{
      __typename: "ProductEnrichment";
      internalName?: string | null;
      productCode?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      firstContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
      secondContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
      thirdContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
    } | null>;
  } | null;
};

export type CategoryEnrichmentByCategoryCodeQueryVariables = Exact<{
  categoryCode: Scalars["String"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type CategoryEnrichmentByCategoryCodeQuery = {
  __typename?: "Query";
  categoryEnrichmentCollection?: {
    __typename?: "CategoryEnrichmentCollection";
    items: Array<{
      __typename: "CategoryEnrichment";
      internalName?: string | null;
      categoryCode?: Array<string | null> | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      firstContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
      secondContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
      thirdContent?:
        | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
        | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
        | null;
    } | null>;
  } | null;
};

export type SectionHeroByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionHeroByIdsQuery = {
  __typename?: "Query";
  sectionHeroCollection?: {
    __typename?: "SectionHeroCollection";
    items: Array<{
      __typename: "SectionHero";
      heroLayout?: string | null;
      presentation?: string | null;
      autoplay?: boolean | null;
      autoplayDuration?: number | null;
      internalName?: string | null;
      textColor?: string | null;
      backgroundColor?: string | null;
      headlineSize?: string | null;
      textHorizontalPosition?: string | null;
      textVerticalPosition?: string | null;
      buttonsPosition?: string | null;
      additionalSlidesCollection?: {
        __typename?: "SectionHeroAdditionalSlidesCollection";
        items: Array<{
          __typename: "SectionHero";
          internalName?: string | null;
          textColor?: string | null;
          backgroundColor?: string | null;
          headlineSize?: string | null;
          textHorizontalPosition?: string | null;
          textVerticalPosition?: string | null;
          buttonsPosition?: string | null;
          sys: { __typename?: "Sys"; id: string };
          content?: {
            __typename: "HeadlineBlock";
            eyebrow?: string | null;
            subline?: string | null;
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
          } | null;
          svg?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          mediaCollection?: {
            __typename?: "SectionHeroMediaCollection";
            items: Array<
              | {
                  __typename: "MediaImage";
                  alternativeText?: string | null;
                  caption?: string | null;
                  image?: any | null;
                  hasFocalPoint?: boolean | null;
                  sys: { __typename?: "Sys"; id: string };
                }
              | {
                  __typename: "MediaVideo";
                  internalName?: string | null;
                  video?: any | null;
                  poster?: any | null;
                  externalVideoUrl?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                }
              | null
            >;
          } | null;
          ctaCollection?: {
            __typename?: "SectionHeroCtaCollection";
            items: Array<{
              __typename: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
      sys: { __typename?: "Sys"; id: string };
      content?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      svg?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      mediaCollection?: {
        __typename?: "SectionHeroMediaCollection";
        items: Array<
          | {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | {
              __typename: "MediaVideo";
              internalName?: string | null;
              video?: any | null;
              poster?: any | null;
              externalVideoUrl?: string | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | null
        >;
      } | null;
      ctaCollection?: {
        __typename?: "SectionHeroCtaCollection";
        items: Array<{
          __typename: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
};

export type SectionSliderByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionSliderByIdsQuery = {
  __typename?: "Query";
  sectionSliderCollection?: {
    __typename?: "SectionSliderCollection";
    items: Array<{
      __typename: "SectionSlider";
      internalName?: string | null;
      autoplay?: boolean | null;
      autoplayDuration?: number | null;
      fullWidth?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
      slidesCollection?: {
        __typename?: "SectionSliderSlidesCollection";
        items: Array<{
          __typename: "SectionHero";
          internalName?: string | null;
          textColor?: string | null;
          backgroundColor?: string | null;
          headlineSize?: string | null;
          textHorizontalPosition?: string | null;
          textVerticalPosition?: string | null;
          buttonsPosition?: string | null;
          sys: { __typename?: "Sys"; id: string };
          content?: {
            __typename: "HeadlineBlock";
            eyebrow?: string | null;
            subline?: string | null;
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
          } | null;
          svg?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          mediaCollection?: {
            __typename?: "SectionHeroMediaCollection";
            items: Array<
              | {
                  __typename: "MediaImage";
                  alternativeText?: string | null;
                  caption?: string | null;
                  image?: any | null;
                  hasFocalPoint?: boolean | null;
                  sys: { __typename?: "Sys"; id: string };
                }
              | {
                  __typename: "MediaVideo";
                  internalName?: string | null;
                  video?: any | null;
                  poster?: any | null;
                  externalVideoUrl?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                }
              | null
            >;
          } | null;
          ctaCollection?: {
            __typename?: "SectionHeroCtaCollection";
            items: Array<{
              __typename: "LinkAction";
              text?: string | null;
              externalUrl?: string | null;
              anchor?: string | null;
              target?: string | null;
              variant?: string | null;
              sys: { __typename?: "Sys"; id: string };
              microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
              internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
            } | null>;
          } | null;
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type AccordionByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type AccordionByIdsQuery = {
  __typename?: "Query";
  accordionD2CCollection?: {
    __typename?: "AccordionD2CCollection";
    items: Array<{
      __typename: "AccordionD2C";
      internalName?: string | null;
      columnWidth?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "AccordionD2CItemsCollection";
        items: Array<{
          __typename: "AccordionItemD2C";
          internalName?: string | null;
          label?: string | null;
          sys: { __typename?: "Sys"; id: string };
          contentBlocksCollection?: {
            __typename?: "AccordionItemD2CContentBlocksCollection";
            items: Array<
              | {
                  __typename: "GeometryTable";
                  internalName?: string | null;
                  containerWidth?: string | null;
                  showUnitToggle?: boolean | null;
                  defaultUnit?: string | null;
                  frameSize?: string | null;
                  title?: string | null;
                  sizesIn?: string | null;
                  unitMm?: string | null;
                  unitInches?: string | null;
                  productCodes?: Array<string | null> | null;
                  anchorId?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  uiConfiguration?: {
                    __typename: "UiConfiguration";
                    internalName?: string | null;
                    backgroundColor?: string | null;
                    paddingTop?: string | null;
                    paddingBottom?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                }
              | {
                  __typename: "SectionMedia";
                  internalName?: string | null;
                  fullWidth?: boolean | null;
                  containerWidth?: string | null;
                  anchorId?: string | null;
                  aspectRatio?: string | null;
                  progressbarColor?: string | null;
                  headlineColor?: string | null;
                  autoplay?: boolean | null;
                  muted?: boolean | null;
                  loop?: boolean | null;
                  showControls?: boolean | null;
                  backgroundVideo?: boolean | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: {
                    __typename: "HeadlineBlock";
                    eyebrow?: string | null;
                    subline?: string | null;
                    sys: { __typename?: "Sys"; id: string; locale?: string | null };
                    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
                  } | null;
                  media?:
                    | {
                        __typename: "MediaImage";
                        alternativeText?: string | null;
                        caption?: string | null;
                        image?: any | null;
                        hasFocalPoint?: boolean | null;
                        sys: { __typename?: "Sys"; id: string };
                      }
                    | {
                        __typename: "MediaVideo";
                        internalName?: string | null;
                        video?: any | null;
                        poster?: any | null;
                        externalVideoUrl?: string | null;
                        sys: { __typename?: "Sys"; id: string };
                      }
                    | null;
                  uiConfiguration?: {
                    __typename: "UiConfiguration";
                    internalName?: string | null;
                    backgroundColor?: string | null;
                    paddingTop?: string | null;
                    paddingBottom?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                }
              | {
                  __typename: "SectionText";
                  internalName?: string | null;
                  headlineVariant?: string | null;
                  headlineDash?: boolean | null;
                  textVariant?: string | null;
                  containerWidth?: string | null;
                  textColumns?: number | null;
                  anchorId?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                  headline?: {
                    __typename: "HeadlineBlock";
                    eyebrow?: string | null;
                    subline?: string | null;
                    sys: { __typename?: "Sys"; id: string; locale?: string | null };
                    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
                  } | null;
                  text?: {
                    __typename: "EditorialText";
                    sys: { __typename?: "Sys"; id: string; locale?: string | null };
                    text?: { __typename?: "EditorialTextText"; json: any } | null;
                  } | null;
                  uiConfiguration?: {
                    __typename: "UiConfiguration";
                    internalName?: string | null;
                    backgroundColor?: string | null;
                    paddingTop?: string | null;
                    paddingBottom?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                  } | null;
                }
              | null
            >;
          } | null;
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type ContentSliderByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ContentSliderByIdsQuery = {
  __typename?: "Query";
  contentSliderD2CCollection?: {
    __typename?: "ContentSliderD2CCollection";
    items: Array<{
      __typename: "ContentSliderD2C";
      internalName?: string | null;
      containerWidth?: string | null;
      behavior?: string | null;
      autoplay?: boolean | null;
      autoplayDuration?: number | null;
      navigationLayout?: string | null;
      showNavigationArrows?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
      slidesCollection?: {
        __typename?: "ContentSliderD2CSlidesCollection";
        items: Array<{
          __typename: "SectionTextImage";
          internalName?: string | null;
          orderReverse?: boolean | null;
          containerWidth?: string | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: {
            __typename: "HeadlineBlock";
            eyebrow?: string | null;
            subline?: string | null;
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
          } | null;
          text?: {
            __typename: "EditorialText";
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            text?: { __typename?: "EditorialTextText"; json: any } | null;
          } | null;
          media?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          cta?: {
            __typename: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
          uiConfiguration?: {
            __typename: "UiConfiguration";
            internalName?: string | null;
            backgroundColor?: string | null;
            paddingTop?: string | null;
            paddingBottom?: string | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionClaimByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SectionClaimByIdsQuery = {
  __typename?: "Query";
  sectionClaimCollection?: {
    __typename?: "SectionClaimCollection";
    items: Array<{
      __typename: "SectionClaim";
      internalName?: string | null;
      fullWidth?: boolean | null;
      claimText?: string | null;
      offsetLeft?: number | null;
      sys: { __typename?: "Sys"; id: string };
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionTaglineByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SectionTaglineByIdsQuery = {
  __typename?: "Query";
  sectionTaglineCollection?: {
    __typename?: "SectionTaglineCollection";
    items: Array<{
      __typename: "SectionTagline";
      internalName?: string | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      text?: { __typename?: "SectionTaglineText"; json: any } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionTextByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionTextByIdsQuery = {
  __typename?: "Query";
  sectionTextCollection?: {
    __typename?: "SectionTextCollection";
    items: Array<{
      __typename: "SectionText";
      internalName?: string | null;
      headlineVariant?: string | null;
      headlineDash?: boolean | null;
      textVariant?: string | null;
      containerWidth?: string | null;
      textColumns?: number | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      text?: {
        __typename: "EditorialText";
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        text?: { __typename?: "EditorialTextText"; json: any } | null;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionIntroTextByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionIntroTextByIdsQuery = {
  __typename?: "Query";
  sectionIntroTextCollection?: {
    __typename?: "SectionIntroTextCollection";
    items: Array<{
      __typename: "SectionIntroText";
      internalName?: string | null;
      headlineLevel?: string | null;
      headlineVariant?: string | null;
      textVariant?: string | null;
      containerWidth?: string | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      headlineIntro?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      textIntro?: {
        __typename: "EditorialText";
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        text?: { __typename?: "EditorialTextText"; json: any } | null;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionQuoteByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SectionQuoteByIdsQuery = {
  __typename?: "Query";
  sectionQuoteCollection?: {
    __typename?: "SectionQuoteCollection";
    items: Array<{
      __typename: "SectionQuote";
      internalName?: string | null;
      eyebrow?: string | null;
      quoteType?: string | null;
      authorName?: string | null;
      authorTeam?: string | null;
      sys: { __typename?: "Sys"; id: string; locale?: string | null };
      quoteText?: { __typename?: "SectionQuoteQuoteText"; json: any } | null;
      authorImage?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      athlete?: {
        __typename: "Athlete";
        internalName?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        team?: string | null;
        sys: { __typename?: "Sys"; id: string };
        image?: {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        } | null;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionCounterByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SectionCounterByIdsQuery = {
  __typename?: "Query";
  sectionCounterCollection?: {
    __typename?: "SectionCounterCollection";
    items: Array<{
      __typename: "SectionCounter";
      internalName?: string | null;
      footnote?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "SectionCounterItemsCollection";
        items: Array<{
          __typename: "CounterItem";
          internalName?: string | null;
          prefix?: string | null;
          value?: number | null;
          suffix?: string | null;
          subline?: string | null;
          sys: { __typename?: "Sys"; id: string };
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionTextImageByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionTextImageByIdsQuery = {
  __typename?: "Query";
  sectionTextImageCollection?: {
    __typename?: "SectionTextImageCollection";
    items: Array<{
      __typename: "SectionTextImage";
      internalName?: string | null;
      orderReverse?: boolean | null;
      containerWidth?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      text?: {
        __typename: "EditorialText";
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        text?: { __typename?: "EditorialTextText"; json: any } | null;
      } | null;
      media?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      cta?: {
        __typename: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionGalleryByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionGalleryByIdsQuery = {
  __typename?: "Query";
  sectionGalleryCollection?: {
    __typename?: "SectionGalleryCollection";
    items: Array<{
      __typename: "SectionGallery";
      internalName?: string | null;
      variant?: string | null;
      fullWidth?: boolean | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      itemsCollection?: {
        __typename?: "SectionGalleryItemsCollection";
        items: Array<
          | {
              __typename: "GalleryItem";
              internalName?: string | null;
              sys: { __typename?: "Sys"; id: string };
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
            }
          | {
              __typename: "GalleryItemWithText";
              internalName?: string | null;
              sys: { __typename?: "Sys"; id: string };
              text?: {
                __typename: "SectionText";
                internalName?: string | null;
                headlineVariant?: string | null;
                headlineDash?: boolean | null;
                textVariant?: string | null;
                containerWidth?: string | null;
                textColumns?: number | null;
                anchorId?: string | null;
                sys: { __typename?: "Sys"; id: string };
                headline?: {
                  __typename: "HeadlineBlock";
                  eyebrow?: string | null;
                  subline?: string | null;
                  sys: { __typename?: "Sys"; id: string; locale?: string | null };
                  headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
                } | null;
                text?: {
                  __typename: "EditorialText";
                  sys: { __typename?: "Sys"; id: string; locale?: string | null };
                  text?: { __typename?: "EditorialTextText"; json: any } | null;
                } | null;
                uiConfiguration?: {
                  __typename: "UiConfiguration";
                  internalName?: string | null;
                  backgroundColor?: string | null;
                  paddingTop?: string | null;
                  paddingBottom?: string | null;
                  sys: { __typename?: "Sys"; id: string };
                } | null;
              } | null;
              image?: {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
            }
          | null
        >;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionTeaserByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionTeaserByIdsQuery = {
  __typename?: "Query";
  sectionTeaserCollection?: {
    __typename?: "SectionTeaserCollection";
    items: Array<{
      __typename: "SectionTeaser";
      internalName?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "SectionTeaserItemsCollection";
        items: Array<{
          __typename: "TeaserItem";
          internalName?: string | null;
          sys: { __typename?: "Sys"; id: string };
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
          link?: {
            __typename: "LinkAction";
            text?: string | null;
            externalUrl?: string | null;
            anchor?: string | null;
            target?: string | null;
            variant?: string | null;
            sys: { __typename?: "Sys"; id: string };
            microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
            internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
          } | null;
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionHotspotByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SectionHotspotByIdsQuery = {
  __typename?: "Query";
  hotspotCollection?: {
    __typename?: "HotspotCollection";
    items: Array<{
      __typename: "Hotspot";
      internalName?: string | null;
      imageUrl?: string | null;
      hotspots?: any | null;
      fullWidth?: boolean | null;
      hotspotColor?: string | null;
      sys: { __typename?: "Sys"; id: string };
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type SectionMediaByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SectionMediaByIdsQuery = {
  __typename?: "Query";
  sectionMediaCollection?: {
    __typename?: "SectionMediaCollection";
    items: Array<{
      __typename: "SectionMedia";
      internalName?: string | null;
      fullWidth?: boolean | null;
      containerWidth?: string | null;
      anchorId?: string | null;
      aspectRatio?: string | null;
      progressbarColor?: string | null;
      headlineColor?: string | null;
      autoplay?: boolean | null;
      muted?: boolean | null;
      loop?: boolean | null;
      showControls?: boolean | null;
      backgroundVideo?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      media?:
        | {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          }
        | {
            __typename: "MediaVideo";
            internalName?: string | null;
            video?: any | null;
            poster?: any | null;
            externalVideoUrl?: string | null;
            sys: { __typename?: "Sys"; id: string };
          }
        | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type ProductListingByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ProductListingByIdsQuery = {
  __typename?: "Query";
  productListingCollection?: {
    __typename?: "ProductListingCollection";
    items: Array<{
      __typename: "ProductListing";
      internalName?: string | null;
      title?: string | null;
      productCategory?: string | null;
      defaultSort?: string | null;
      searchQuery?: string | null;
      showFilters?: boolean | null;
      showSorting?: boolean | null;
      showCarouselNavigationArrows?: boolean | null;
      variant?: string | null;
      paginationMode?: string | null;
      pageSize?: number | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string };
      specificProductsCollection?: {
        __typename?: "ProductListingSpecificProductsCollection";
        items: Array<{
          __typename: "ProductListItem";
          productCode?: string | null;
          colorCode?: string | null;
          sys: { __typename?: "Sys"; id: string };
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type GeometryTableByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GeometryTableByIdsQuery = {
  __typename?: "Query";
  geometryTableCollection?: {
    __typename?: "GeometryTableCollection";
    items: Array<{
      __typename: "GeometryTable";
      internalName?: string | null;
      containerWidth?: string | null;
      showUnitToggle?: boolean | null;
      defaultUnit?: string | null;
      frameSize?: string | null;
      title?: string | null;
      sizesIn?: string | null;
      unitMm?: string | null;
      unitInches?: string | null;
      productCodes?: Array<string | null> | null;
      anchorId?: string | null;
      sys: { __typename?: "Sys"; id: string };
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

export type TabContainerByIdsQueryVariables = Exact<{
  ids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  locale?: InputMaybe<Scalars["String"]["input"]>;
  preview?: InputMaybe<Scalars["Boolean"]["input"]>;
  taxonomies: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type TabContainerByIdsQuery = {
  __typename?: "Query";
  tabContainerD2CCollection?: {
    __typename?: "TabContainerD2CCollection";
    items: Array<{
      __typename: "TabContainerD2C";
      internalName?: string | null;
      title?: string | null;
      showNavigationArrows?: boolean | null;
      columnWidth?: string | null;
      sys: { __typename?: "Sys"; id: string };
      itemsCollection?: {
        __typename?: "TabContainerD2CItemsCollection";
        items: Array<{
          __typename: "TabContainerItemD2C";
          internalName?: string | null;
          title?: string | null;
          sys: { __typename?: "Sys"; id: string };
          contentBlocksCollection?: {
            __typename?: "TabContainerItemD2CContentBlocksCollection";
            items: Array<{ __typename: "ProductListing"; sectionReference: { __typename?: "Sys"; id: string } } | null>;
          } | null;
        } | null>;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
};

type SectionReference_AccordionD2C_Fragment = {
  __typename: "AccordionD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_AccordionItemD2C_Fragment = {
  __typename: "AccordionItemD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Athlete_Fragment = {
  __typename: "Athlete";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_AthleteResults_Fragment = {
  __typename: "AthleteResults";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Campaign_Fragment = {
  __typename: "Campaign";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Catalog_Fragment = {
  __typename: "Catalog";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_CategoryEnrichment_Fragment = {
  __typename: "CategoryEnrichment";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Collection_Fragment = {
  __typename: "Collection";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Config_Fragment = { __typename: "Config"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_ContentItem_Fragment = {
  __typename: "ContentItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ContentPage_Fragment = {
  __typename: "ContentPage";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ContentSliderD2C_Fragment = {
  __typename: "ContentSliderD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_CounterItem_Fragment = {
  __typename: "CounterItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_DivisionNavigation_Fragment = {
  __typename: "DivisionNavigation";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Document_Fragment = {
  __typename: "Document";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_EditorialText_Fragment = {
  __typename: "EditorialText";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_GalleryItem_Fragment = {
  __typename: "GalleryItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_GalleryItemWithText_Fragment = {
  __typename: "GalleryItemWithText";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_GeometryTable_Fragment = {
  __typename: "GeometryTable";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_HeadlineBlock_Fragment = {
  __typename: "HeadlineBlock";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_HomePage_Fragment = {
  __typename: "HomePage";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Hotspot_Fragment = {
  __typename: "Hotspot";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Image_Fragment = { __typename: "Image"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_Link_Fragment = { __typename: "Link"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_LinkAction_Fragment = {
  __typename: "LinkAction";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_List_Fragment = { __typename: "List"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_MediaImage_Fragment = {
  __typename: "MediaImage";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_MediaVideo_Fragment = {
  __typename: "MediaVideo";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Microcopy_Fragment = {
  __typename: "Microcopy";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_MicrocopyItem_Fragment = {
  __typename: "MicrocopyItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Migrations_Fragment = {
  __typename: "Migrations";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationColumnD2C_Fragment = {
  __typename: "NavigationColumnD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationD2C_Fragment = {
  __typename: "NavigationD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationItemD2C_Fragment = {
  __typename: "NavigationItemD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationLinkItemD2C_Fragment = {
  __typename: "NavigationLinkItemD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationMegaMenuD2C_Fragment = {
  __typename: "NavigationMegaMenuD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_NavigationTeaserD2C_Fragment = {
  __typename: "NavigationTeaserD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Page_Fragment = { __typename: "Page"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_PageSectionItem_Fragment = {
  __typename: "PageSectionItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_PageSectionList_Fragment = {
  __typename: "PageSectionList";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_PrimaryTopicCollection_Fragment = {
  __typename: "PrimaryTopicCollection";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_PrimaryTopicProductCategory_Fragment = {
  __typename: "PrimaryTopicProductCategory";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Product_Fragment = {
  __typename: "Product";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ProductEnrichment_Fragment = {
  __typename: "ProductEnrichment";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ProductFamily_Fragment = {
  __typename: "ProductFamily";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ProductListItem_Fragment = {
  __typename: "ProductListItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_ProductListing_Fragment = {
  __typename: "ProductListing";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionClaim_Fragment = {
  __typename: "SectionClaim";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionCounter_Fragment = {
  __typename: "SectionCounter";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionGallery_Fragment = {
  __typename: "SectionGallery";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionHero_Fragment = {
  __typename: "SectionHero";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionIntroText_Fragment = {
  __typename: "SectionIntroText";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionMedia_Fragment = {
  __typename: "SectionMedia";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionQuote_Fragment = {
  __typename: "SectionQuote";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionSlider_Fragment = {
  __typename: "SectionSlider";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionTagline_Fragment = {
  __typename: "SectionTagline";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionTeaser_Fragment = {
  __typename: "SectionTeaser";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionText_Fragment = {
  __typename: "SectionText";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SectionTextImage_Fragment = {
  __typename: "SectionTextImage";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Seo_Fragment = { __typename: "Seo"; sectionReference: { __typename?: "Sys"; id: string } };

type SectionReference_ShippingInfoD2C_Fragment = {
  __typename: "ShippingInfoD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_SocialLinks_Fragment = {
  __typename: "SocialLinks";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_TabContainerD2C_Fragment = {
  __typename: "TabContainerD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_TabContainerItemD2C_Fragment = {
  __typename: "TabContainerItemD2C";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_TeaserItem_Fragment = {
  __typename: "TeaserItem";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_UiConfiguration_Fragment = {
  __typename: "UiConfiguration";
  sectionReference: { __typename?: "Sys"; id: string };
};

type SectionReference_Video_Fragment = { __typename: "Video"; sectionReference: { __typename?: "Sys"; id: string } };

export type SectionReferenceFragment =
  | SectionReference_AccordionD2C_Fragment
  | SectionReference_AccordionItemD2C_Fragment
  | SectionReference_Athlete_Fragment
  | SectionReference_AthleteResults_Fragment
  | SectionReference_Campaign_Fragment
  | SectionReference_Catalog_Fragment
  | SectionReference_CategoryEnrichment_Fragment
  | SectionReference_Collection_Fragment
  | SectionReference_Config_Fragment
  | SectionReference_ContentItem_Fragment
  | SectionReference_ContentPage_Fragment
  | SectionReference_ContentSliderD2C_Fragment
  | SectionReference_CounterItem_Fragment
  | SectionReference_DivisionNavigation_Fragment
  | SectionReference_Document_Fragment
  | SectionReference_EditorialText_Fragment
  | SectionReference_GalleryItem_Fragment
  | SectionReference_GalleryItemWithText_Fragment
  | SectionReference_GeometryTable_Fragment
  | SectionReference_HeadlineBlock_Fragment
  | SectionReference_HomePage_Fragment
  | SectionReference_Hotspot_Fragment
  | SectionReference_Image_Fragment
  | SectionReference_Link_Fragment
  | SectionReference_LinkAction_Fragment
  | SectionReference_List_Fragment
  | SectionReference_MediaImage_Fragment
  | SectionReference_MediaVideo_Fragment
  | SectionReference_Microcopy_Fragment
  | SectionReference_MicrocopyItem_Fragment
  | SectionReference_Migrations_Fragment
  | SectionReference_NavigationColumnD2C_Fragment
  | SectionReference_NavigationD2C_Fragment
  | SectionReference_NavigationItemD2C_Fragment
  | SectionReference_NavigationLinkItemD2C_Fragment
  | SectionReference_NavigationMegaMenuD2C_Fragment
  | SectionReference_NavigationTeaserD2C_Fragment
  | SectionReference_Page_Fragment
  | SectionReference_PageSectionItem_Fragment
  | SectionReference_PageSectionList_Fragment
  | SectionReference_PrimaryTopicCollection_Fragment
  | SectionReference_PrimaryTopicProductCategory_Fragment
  | SectionReference_Product_Fragment
  | SectionReference_ProductEnrichment_Fragment
  | SectionReference_ProductFamily_Fragment
  | SectionReference_ProductListItem_Fragment
  | SectionReference_ProductListing_Fragment
  | SectionReference_SectionClaim_Fragment
  | SectionReference_SectionCounter_Fragment
  | SectionReference_SectionGallery_Fragment
  | SectionReference_SectionHero_Fragment
  | SectionReference_SectionIntroText_Fragment
  | SectionReference_SectionMedia_Fragment
  | SectionReference_SectionQuote_Fragment
  | SectionReference_SectionSlider_Fragment
  | SectionReference_SectionTagline_Fragment
  | SectionReference_SectionTeaser_Fragment
  | SectionReference_SectionText_Fragment
  | SectionReference_SectionTextImage_Fragment
  | SectionReference_Seo_Fragment
  | SectionReference_ShippingInfoD2C_Fragment
  | SectionReference_SocialLinks_Fragment
  | SectionReference_TabContainerD2C_Fragment
  | SectionReference_TabContainerItemD2C_Fragment
  | SectionReference_TeaserItem_Fragment
  | SectionReference_UiConfiguration_Fragment
  | SectionReference_Video_Fragment;

export type AccordionFragment = {
  __typename: "AccordionD2C";
  internalName?: string | null;
  columnWidth?: string | null;
  sys: { __typename?: "Sys"; id: string };
  itemsCollection?: {
    __typename?: "AccordionD2CItemsCollection";
    items: Array<{
      __typename: "AccordionItemD2C";
      internalName?: string | null;
      label?: string | null;
      sys: { __typename?: "Sys"; id: string };
      contentBlocksCollection?: {
        __typename?: "AccordionItemD2CContentBlocksCollection";
        items: Array<
          | {
              __typename: "GeometryTable";
              internalName?: string | null;
              containerWidth?: string | null;
              showUnitToggle?: boolean | null;
              defaultUnit?: string | null;
              frameSize?: string | null;
              title?: string | null;
              sizesIn?: string | null;
              unitMm?: string | null;
              unitInches?: string | null;
              productCodes?: Array<string | null> | null;
              anchorId?: string | null;
              sys: { __typename?: "Sys"; id: string };
              uiConfiguration?: {
                __typename: "UiConfiguration";
                internalName?: string | null;
                backgroundColor?: string | null;
                paddingTop?: string | null;
                paddingBottom?: string | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
            }
          | {
              __typename: "SectionMedia";
              internalName?: string | null;
              fullWidth?: boolean | null;
              containerWidth?: string | null;
              anchorId?: string | null;
              aspectRatio?: string | null;
              progressbarColor?: string | null;
              headlineColor?: string | null;
              autoplay?: boolean | null;
              muted?: boolean | null;
              loop?: boolean | null;
              showControls?: boolean | null;
              backgroundVideo?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: {
                __typename: "HeadlineBlock";
                eyebrow?: string | null;
                subline?: string | null;
                sys: { __typename?: "Sys"; id: string; locale?: string | null };
                headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
              } | null;
              media?:
                | {
                    __typename: "MediaImage";
                    alternativeText?: string | null;
                    caption?: string | null;
                    image?: any | null;
                    hasFocalPoint?: boolean | null;
                    sys: { __typename?: "Sys"; id: string };
                  }
                | {
                    __typename: "MediaVideo";
                    internalName?: string | null;
                    video?: any | null;
                    poster?: any | null;
                    externalVideoUrl?: string | null;
                    sys: { __typename?: "Sys"; id: string };
                  }
                | null;
              uiConfiguration?: {
                __typename: "UiConfiguration";
                internalName?: string | null;
                backgroundColor?: string | null;
                paddingTop?: string | null;
                paddingBottom?: string | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
            }
          | {
              __typename: "SectionText";
              internalName?: string | null;
              headlineVariant?: string | null;
              headlineDash?: boolean | null;
              textVariant?: string | null;
              containerWidth?: string | null;
              textColumns?: number | null;
              anchorId?: string | null;
              sys: { __typename?: "Sys"; id: string };
              headline?: {
                __typename: "HeadlineBlock";
                eyebrow?: string | null;
                subline?: string | null;
                sys: { __typename?: "Sys"; id: string; locale?: string | null };
                headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
              } | null;
              text?: {
                __typename: "EditorialText";
                sys: { __typename?: "Sys"; id: string; locale?: string | null };
                text?: { __typename?: "EditorialTextText"; json: any } | null;
              } | null;
              uiConfiguration?: {
                __typename: "UiConfiguration";
                internalName?: string | null;
                backgroundColor?: string | null;
                paddingTop?: string | null;
                paddingBottom?: string | null;
                sys: { __typename?: "Sys"; id: string };
              } | null;
            }
          | null
        >;
      } | null;
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type AccordionItemFragment = {
  __typename: "AccordionItemD2C";
  internalName?: string | null;
  label?: string | null;
  sys: { __typename?: "Sys"; id: string };
  contentBlocksCollection?: {
    __typename?: "AccordionItemD2CContentBlocksCollection";
    items: Array<
      | {
          __typename: "GeometryTable";
          internalName?: string | null;
          containerWidth?: string | null;
          showUnitToggle?: boolean | null;
          defaultUnit?: string | null;
          frameSize?: string | null;
          title?: string | null;
          sizesIn?: string | null;
          unitMm?: string | null;
          unitInches?: string | null;
          productCodes?: Array<string | null> | null;
          anchorId?: string | null;
          sys: { __typename?: "Sys"; id: string };
          uiConfiguration?: {
            __typename: "UiConfiguration";
            internalName?: string | null;
            backgroundColor?: string | null;
            paddingTop?: string | null;
            paddingBottom?: string | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        }
      | {
          __typename: "SectionMedia";
          internalName?: string | null;
          fullWidth?: boolean | null;
          containerWidth?: string | null;
          anchorId?: string | null;
          aspectRatio?: string | null;
          progressbarColor?: string | null;
          headlineColor?: string | null;
          autoplay?: boolean | null;
          muted?: boolean | null;
          loop?: boolean | null;
          showControls?: boolean | null;
          backgroundVideo?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: {
            __typename: "HeadlineBlock";
            eyebrow?: string | null;
            subline?: string | null;
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
          } | null;
          media?:
            | {
                __typename: "MediaImage";
                alternativeText?: string | null;
                caption?: string | null;
                image?: any | null;
                hasFocalPoint?: boolean | null;
                sys: { __typename?: "Sys"; id: string };
              }
            | {
                __typename: "MediaVideo";
                internalName?: string | null;
                video?: any | null;
                poster?: any | null;
                externalVideoUrl?: string | null;
                sys: { __typename?: "Sys"; id: string };
              }
            | null;
          uiConfiguration?: {
            __typename: "UiConfiguration";
            internalName?: string | null;
            backgroundColor?: string | null;
            paddingTop?: string | null;
            paddingBottom?: string | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        }
      | {
          __typename: "SectionText";
          internalName?: string | null;
          headlineVariant?: string | null;
          headlineDash?: boolean | null;
          textVariant?: string | null;
          containerWidth?: string | null;
          textColumns?: number | null;
          anchorId?: string | null;
          sys: { __typename?: "Sys"; id: string };
          headline?: {
            __typename: "HeadlineBlock";
            eyebrow?: string | null;
            subline?: string | null;
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
          } | null;
          text?: {
            __typename: "EditorialText";
            sys: { __typename?: "Sys"; id: string; locale?: string | null };
            text?: { __typename?: "EditorialTextText"; json: any } | null;
          } | null;
          uiConfiguration?: {
            __typename: "UiConfiguration";
            internalName?: string | null;
            backgroundColor?: string | null;
            paddingTop?: string | null;
            paddingBottom?: string | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        }
      | null
    >;
  } | null;
};

export type ContentSliderFragment = {
  __typename: "ContentSliderD2C";
  internalName?: string | null;
  containerWidth?: string | null;
  behavior?: string | null;
  autoplay?: boolean | null;
  autoplayDuration?: number | null;
  navigationLayout?: string | null;
  showNavigationArrows?: boolean | null;
  sys: { __typename?: "Sys"; id: string };
  slidesCollection?: {
    __typename?: "ContentSliderD2CSlidesCollection";
    items: Array<{
      __typename: "SectionTextImage";
      internalName?: string | null;
      orderReverse?: boolean | null;
      containerWidth?: string | null;
      sys: { __typename?: "Sys"; id: string };
      headline?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      text?: {
        __typename: "EditorialText";
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        text?: { __typename?: "EditorialTextText"; json: any } | null;
      } | null;
      media?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      cta?: {
        __typename: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
      uiConfiguration?: {
        __typename: "UiConfiguration";
        internalName?: string | null;
        backgroundColor?: string | null;
        paddingTop?: string | null;
        paddingBottom?: string | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type CounterItemFragment = {
  __typename: "CounterItem";
  internalName?: string | null;
  prefix?: string | null;
  value?: number | null;
  suffix?: string | null;
  subline?: string | null;
  sys: { __typename?: "Sys"; id: string };
};

export type GeometryTableFragment = {
  __typename: "GeometryTable";
  internalName?: string | null;
  containerWidth?: string | null;
  showUnitToggle?: boolean | null;
  defaultUnit?: string | null;
  frameSize?: string | null;
  title?: string | null;
  sizesIn?: string | null;
  unitMm?: string | null;
  unitInches?: string | null;
  productCodes?: Array<string | null> | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string };
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type LinkActionFragment = {
  __typename?: "LinkAction";
  text?: string | null;
  externalUrl?: string | null;
  anchor?: string | null;
  target?: string | null;
  variant?: string | null;
  sys: { __typename?: "Sys"; id: string };
  microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
  internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
};

export type MediaImageFragment = {
  __typename: "MediaImage";
  alternativeText?: string | null;
  caption?: string | null;
  image?: any | null;
  hasFocalPoint?: boolean | null;
  sys: { __typename?: "Sys"; id: string };
};

export type SectionMediaFragment = {
  __typename: "SectionMedia";
  internalName?: string | null;
  fullWidth?: boolean | null;
  containerWidth?: string | null;
  anchorId?: string | null;
  aspectRatio?: string | null;
  progressbarColor?: string | null;
  headlineColor?: string | null;
  autoplay?: boolean | null;
  muted?: boolean | null;
  loop?: boolean | null;
  showControls?: boolean | null;
  backgroundVideo?: boolean | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  media?:
    | {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      }
    | {
        __typename: "MediaVideo";
        internalName?: string | null;
        video?: any | null;
        poster?: any | null;
        externalVideoUrl?: string | null;
        sys: { __typename?: "Sys"; id: string };
      }
    | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type MediaVideoFragment = {
  __typename: "MediaVideo";
  internalName?: string | null;
  video?: any | null;
  poster?: any | null;
  externalVideoUrl?: string | null;
  sys: { __typename?: "Sys"; id: string };
};

export type ProductListingFragment = {
  __typename: "ProductListing";
  internalName?: string | null;
  title?: string | null;
  productCategory?: string | null;
  defaultSort?: string | null;
  searchQuery?: string | null;
  showFilters?: boolean | null;
  showSorting?: boolean | null;
  showCarouselNavigationArrows?: boolean | null;
  variant?: string | null;
  paginationMode?: string | null;
  pageSize?: number | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string };
  specificProductsCollection?: {
    __typename?: "ProductListingSpecificProductsCollection";
    items: Array<{
      __typename: "ProductListItem";
      productCode?: string | null;
      colorCode?: string | null;
      sys: { __typename?: "Sys"; id: string };
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionClaimFragment = {
  __typename: "SectionClaim";
  internalName?: string | null;
  fullWidth?: boolean | null;
  claimText?: string | null;
  offsetLeft?: number | null;
  sys: { __typename?: "Sys"; id: string };
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionCounterFragment = {
  __typename: "SectionCounter";
  internalName?: string | null;
  footnote?: string | null;
  sys: { __typename?: "Sys"; id: string };
  itemsCollection?: {
    __typename?: "SectionCounterItemsCollection";
    items: Array<{
      __typename: "CounterItem";
      internalName?: string | null;
      prefix?: string | null;
      value?: number | null;
      suffix?: string | null;
      subline?: string | null;
      sys: { __typename?: "Sys"; id: string };
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionGalleryFragment = {
  __typename: "SectionGallery";
  internalName?: string | null;
  variant?: string | null;
  fullWidth?: boolean | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  itemsCollection?: {
    __typename?: "SectionGalleryItemsCollection";
    items: Array<
      | {
          __typename: "GalleryItem";
          internalName?: string | null;
          sys: { __typename?: "Sys"; id: string };
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        }
      | {
          __typename: "GalleryItemWithText";
          internalName?: string | null;
          sys: { __typename?: "Sys"; id: string };
          text?: {
            __typename: "SectionText";
            internalName?: string | null;
            headlineVariant?: string | null;
            headlineDash?: boolean | null;
            textVariant?: string | null;
            containerWidth?: string | null;
            textColumns?: number | null;
            anchorId?: string | null;
            sys: { __typename?: "Sys"; id: string };
            headline?: {
              __typename: "HeadlineBlock";
              eyebrow?: string | null;
              subline?: string | null;
              sys: { __typename?: "Sys"; id: string; locale?: string | null };
              headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
            } | null;
            text?: {
              __typename: "EditorialText";
              sys: { __typename?: "Sys"; id: string; locale?: string | null };
              text?: { __typename?: "EditorialTextText"; json: any } | null;
            } | null;
            uiConfiguration?: {
              __typename: "UiConfiguration";
              internalName?: string | null;
              backgroundColor?: string | null;
              paddingTop?: string | null;
              paddingBottom?: string | null;
              sys: { __typename?: "Sys"; id: string };
            } | null;
          } | null;
          image?: {
            __typename: "MediaImage";
            alternativeText?: string | null;
            caption?: string | null;
            image?: any | null;
            hasFocalPoint?: boolean | null;
            sys: { __typename?: "Sys"; id: string };
          } | null;
        }
      | null
    >;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionHeroFragment = {
  __typename: "SectionHero";
  heroLayout?: string | null;
  presentation?: string | null;
  autoplay?: boolean | null;
  autoplayDuration?: number | null;
  internalName?: string | null;
  textColor?: string | null;
  backgroundColor?: string | null;
  headlineSize?: string | null;
  textHorizontalPosition?: string | null;
  textVerticalPosition?: string | null;
  buttonsPosition?: string | null;
  additionalSlidesCollection?: {
    __typename?: "SectionHeroAdditionalSlidesCollection";
    items: Array<{
      __typename: "SectionHero";
      internalName?: string | null;
      textColor?: string | null;
      backgroundColor?: string | null;
      headlineSize?: string | null;
      textHorizontalPosition?: string | null;
      textVerticalPosition?: string | null;
      buttonsPosition?: string | null;
      sys: { __typename?: "Sys"; id: string };
      content?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      svg?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      mediaCollection?: {
        __typename?: "SectionHeroMediaCollection";
        items: Array<
          | {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | {
              __typename: "MediaVideo";
              internalName?: string | null;
              video?: any | null;
              poster?: any | null;
              externalVideoUrl?: string | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | null
        >;
      } | null;
      ctaCollection?: {
        __typename?: "SectionHeroCtaCollection";
        items: Array<{
          __typename: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
  sys: { __typename?: "Sys"; id: string };
  content?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  svg?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  mediaCollection?: {
    __typename?: "SectionHeroMediaCollection";
    items: Array<
      | {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        }
      | {
          __typename: "MediaVideo";
          internalName?: string | null;
          video?: any | null;
          poster?: any | null;
          externalVideoUrl?: string | null;
          sys: { __typename?: "Sys"; id: string };
        }
      | null
    >;
  } | null;
  ctaCollection?: {
    __typename?: "SectionHeroCtaCollection";
    items: Array<{
      __typename: "LinkAction";
      text?: string | null;
      externalUrl?: string | null;
      anchor?: string | null;
      target?: string | null;
      variant?: string | null;
      sys: { __typename?: "Sys"; id: string };
      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
    } | null>;
  } | null;
};

export type SectionHeroSlideFragment = {
  __typename: "SectionHero";
  internalName?: string | null;
  textColor?: string | null;
  backgroundColor?: string | null;
  headlineSize?: string | null;
  textHorizontalPosition?: string | null;
  textVerticalPosition?: string | null;
  buttonsPosition?: string | null;
  sys: { __typename?: "Sys"; id: string };
  content?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  svg?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  mediaCollection?: {
    __typename?: "SectionHeroMediaCollection";
    items: Array<
      | {
          __typename: "MediaImage";
          alternativeText?: string | null;
          caption?: string | null;
          image?: any | null;
          hasFocalPoint?: boolean | null;
          sys: { __typename?: "Sys"; id: string };
        }
      | {
          __typename: "MediaVideo";
          internalName?: string | null;
          video?: any | null;
          poster?: any | null;
          externalVideoUrl?: string | null;
          sys: { __typename?: "Sys"; id: string };
        }
      | null
    >;
  } | null;
  ctaCollection?: {
    __typename?: "SectionHeroCtaCollection";
    items: Array<{
      __typename: "LinkAction";
      text?: string | null;
      externalUrl?: string | null;
      anchor?: string | null;
      target?: string | null;
      variant?: string | null;
      sys: { __typename?: "Sys"; id: string };
      microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
      internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
    } | null>;
  } | null;
};

export type SectionHotspotFragment = {
  __typename: "Hotspot";
  internalName?: string | null;
  imageUrl?: string | null;
  hotspots?: any | null;
  fullWidth?: boolean | null;
  hotspotColor?: string | null;
  sys: { __typename?: "Sys"; id: string };
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionIntroTextFragment = {
  __typename: "SectionIntroText";
  internalName?: string | null;
  headlineLevel?: string | null;
  headlineVariant?: string | null;
  textVariant?: string | null;
  containerWidth?: string | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  headlineIntro?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  textIntro?: {
    __typename: "EditorialText";
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    text?: { __typename?: "EditorialTextText"; json: any } | null;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionQuoteFragment = {
  __typename: "SectionQuote";
  internalName?: string | null;
  eyebrow?: string | null;
  quoteType?: string | null;
  authorName?: string | null;
  authorTeam?: string | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  quoteText?: { __typename?: "SectionQuoteQuoteText"; json: any } | null;
  authorImage?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  athlete?: {
    __typename: "Athlete";
    internalName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    team?: string | null;
    sys: { __typename?: "Sys"; id: string };
    image?: {
      __typename: "MediaImage";
      alternativeText?: string | null;
      caption?: string | null;
      image?: any | null;
      hasFocalPoint?: boolean | null;
      sys: { __typename?: "Sys"; id: string };
    } | null;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionSliderFragment = {
  __typename: "SectionSlider";
  internalName?: string | null;
  autoplay?: boolean | null;
  autoplayDuration?: number | null;
  fullWidth?: boolean | null;
  sys: { __typename?: "Sys"; id: string };
  slidesCollection?: {
    __typename?: "SectionSliderSlidesCollection";
    items: Array<{
      __typename: "SectionHero";
      internalName?: string | null;
      textColor?: string | null;
      backgroundColor?: string | null;
      headlineSize?: string | null;
      textHorizontalPosition?: string | null;
      textVerticalPosition?: string | null;
      buttonsPosition?: string | null;
      sys: { __typename?: "Sys"; id: string };
      content?: {
        __typename: "HeadlineBlock";
        eyebrow?: string | null;
        subline?: string | null;
        sys: { __typename?: "Sys"; id: string; locale?: string | null };
        headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
      } | null;
      svg?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      mediaCollection?: {
        __typename?: "SectionHeroMediaCollection";
        items: Array<
          | {
              __typename: "MediaImage";
              alternativeText?: string | null;
              caption?: string | null;
              image?: any | null;
              hasFocalPoint?: boolean | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | {
              __typename: "MediaVideo";
              internalName?: string | null;
              video?: any | null;
              poster?: any | null;
              externalVideoUrl?: string | null;
              sys: { __typename?: "Sys"; id: string };
            }
          | null
        >;
      } | null;
      ctaCollection?: {
        __typename?: "SectionHeroCtaCollection";
        items: Array<{
          __typename: "LinkAction";
          text?: string | null;
          externalUrl?: string | null;
          anchor?: string | null;
          target?: string | null;
          variant?: string | null;
          sys: { __typename?: "Sys"; id: string };
          microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
          internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
        } | null>;
      } | null;
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionTaglineFragment = {
  __typename: "SectionTagline";
  internalName?: string | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  text?: { __typename?: "SectionTaglineText"; json: any } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionTeaserFragment = {
  __typename: "SectionTeaser";
  internalName?: string | null;
  sys: { __typename?: "Sys"; id: string };
  itemsCollection?: {
    __typename?: "SectionTeaserItemsCollection";
    items: Array<{
      __typename: "TeaserItem";
      internalName?: string | null;
      sys: { __typename?: "Sys"; id: string };
      image?: {
        __typename: "MediaImage";
        alternativeText?: string | null;
        caption?: string | null;
        image?: any | null;
        hasFocalPoint?: boolean | null;
        sys: { __typename?: "Sys"; id: string };
      } | null;
      link?: {
        __typename: "LinkAction";
        text?: string | null;
        externalUrl?: string | null;
        anchor?: string | null;
        target?: string | null;
        variant?: string | null;
        sys: { __typename?: "Sys"; id: string };
        microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
        internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
      } | null;
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionTextFragment = {
  __typename: "SectionText";
  internalName?: string | null;
  headlineVariant?: string | null;
  headlineDash?: boolean | null;
  textVariant?: string | null;
  containerWidth?: string | null;
  textColumns?: number | null;
  anchorId?: string | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  text?: {
    __typename: "EditorialText";
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    text?: { __typename?: "EditorialTextText"; json: any } | null;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type SectionTextImageFragment = {
  __typename: "SectionTextImage";
  internalName?: string | null;
  orderReverse?: boolean | null;
  containerWidth?: string | null;
  sys: { __typename?: "Sys"; id: string };
  headline?: {
    __typename: "HeadlineBlock";
    eyebrow?: string | null;
    subline?: string | null;
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
  } | null;
  text?: {
    __typename: "EditorialText";
    sys: { __typename?: "Sys"; id: string; locale?: string | null };
    text?: { __typename?: "EditorialTextText"; json: any } | null;
  } | null;
  media?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  cta?: {
    __typename: "LinkAction";
    text?: string | null;
    externalUrl?: string | null;
    anchor?: string | null;
    target?: string | null;
    variant?: string | null;
    sys: { __typename?: "Sys"; id: string };
    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type TabContainerFragment = {
  __typename: "TabContainerD2C";
  internalName?: string | null;
  title?: string | null;
  showNavigationArrows?: boolean | null;
  columnWidth?: string | null;
  sys: { __typename?: "Sys"; id: string };
  itemsCollection?: {
    __typename?: "TabContainerD2CItemsCollection";
    items: Array<{
      __typename: "TabContainerItemD2C";
      internalName?: string | null;
      title?: string | null;
      sys: { __typename?: "Sys"; id: string };
      contentBlocksCollection?: {
        __typename?: "TabContainerItemD2CContentBlocksCollection";
        items: Array<{ __typename: "ProductListing"; sectionReference: { __typename?: "Sys"; id: string } } | null>;
      } | null;
    } | null>;
  } | null;
  uiConfiguration?: {
    __typename: "UiConfiguration";
    internalName?: string | null;
    backgroundColor?: string | null;
    paddingTop?: string | null;
    paddingBottom?: string | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type TabContainerItemFragment = {
  __typename: "TabContainerItemD2C";
  internalName?: string | null;
  title?: string | null;
  sys: { __typename?: "Sys"; id: string };
  contentBlocksCollection?: {
    __typename?: "TabContainerItemD2CContentBlocksCollection";
    items: Array<{ __typename: "ProductListing"; sectionReference: { __typename?: "Sys"; id: string } } | null>;
  } | null;
};

export type TeaserItemFragment = {
  __typename: "TeaserItem";
  internalName?: string | null;
  sys: { __typename?: "Sys"; id: string };
  image?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
  link?: {
    __typename: "LinkAction";
    text?: string | null;
    externalUrl?: string | null;
    anchor?: string | null;
    target?: string | null;
    variant?: string | null;
    sys: { __typename?: "Sys"; id: string };
    microcopy?: { __typename?: "MicrocopyItem"; key?: string | null; value?: string | null } | null;
    internalPage?: { __typename?: "ContentPage"; slug?: string | null } | null;
  } | null;
};

export type CategoryEnrichmentFragment = {
  __typename: "CategoryEnrichment";
  internalName?: string | null;
  categoryCode?: Array<string | null> | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  firstContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
  secondContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
  thirdContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
};

export type EditorialTextFragment = {
  __typename: "EditorialText";
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  text?: { __typename?: "EditorialTextText"; json: any } | null;
};

export type HeadlineBlockFragment = {
  __typename: "HeadlineBlock";
  eyebrow?: string | null;
  subline?: string | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  headline?: { __typename?: "HeadlineBlockHeadline"; json: any } | null;
};

export type ProductEnrichmentFragment = {
  __typename: "ProductEnrichment";
  internalName?: string | null;
  productCode?: string | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  firstContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
  secondContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
  thirdContent?:
    | { __typename: "SectionCounter"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionGallery"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionHero"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionMedia"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionQuote"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTagline"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionText"; sys: { __typename?: "Sys"; id: string } }
    | { __typename: "SectionTextImage"; sys: { __typename?: "Sys"; id: string } }
    | null;
};

export type SeoMetadataFragment = {
  __typename: "Seo";
  title?: string | null;
  description?: string | null;
  keywords?: Array<string | null> | null;
  canonicalUrl?: string | null;
  hideFromSearchEnginesNoindex?: boolean | null;
  excludeLinksFromRankingsNofollow?: boolean | null;
  sys: { __typename?: "Sys"; id: string; locale?: string | null };
  openGraphImage?: {
    __typename: "MediaImage";
    alternativeText?: string | null;
    caption?: string | null;
    image?: any | null;
    hasFocalPoint?: boolean | null;
    sys: { __typename?: "Sys"; id: string };
  } | null;
};

export type UiConfigurationFragment = {
  __typename: "UiConfiguration";
  internalName?: string | null;
  backgroundColor?: string | null;
  paddingTop?: string | null;
  paddingBottom?: string | null;
  sys: { __typename?: "Sys"; id: string };
};

export const ConfigFragmentDoc = gql`
  fragment Config on Config {
    __typename
    _id
    sys {
      id
    }
    slugProductListingPage
    slugProductDetailPage
  }
`;
export const LinkActionFragmentDoc = gql`
  fragment LinkAction on LinkAction {
    sys {
      id
    }
    text
    microcopy {
      key
      value
    }
    internalPage {
      slug
    }
    externalUrl
    anchor
    target
    variant
  }
`;
export const MediaImageFragmentDoc = gql`
  fragment MediaImage on MediaImage {
    __typename
    sys {
      id
    }
    alternativeText
    caption
    image
    hasFocalPoint
  }
`;
export const NavigationTeaserD2cFieldsFragmentDoc = gql`
  fragment NavigationTeaserD2cFields on NavigationTeaserD2C {
    sys {
      id
    }
    eyebrow
    headline {
      json
    }
    description
    image {
      ...MediaImage
    }
    link {
      ...LinkAction
    }
  }
  ${MediaImageFragmentDoc}
  ${LinkActionFragmentDoc}
`;
export const NavigationColumnD2cFieldsFragmentDoc = gql`
  fragment NavigationColumnD2cFields on NavigationColumnD2C {
    sys {
      id
    }
    headline
    text
    itemsCollection(
      limit: 50
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
    ) {
      items {
        sys {
          id
        }
        internalName
        label
        link {
          ...LinkAction
        }
        subItemsCollection(
          limit: 12
          where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
        ) {
          items {
            sys {
              id
            }
            internalName
            label
            link {
              ...LinkAction
            }
          }
        }
      }
    }
    cta {
      ...LinkAction
    }
    teaser(where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }) {
      ...NavigationTeaserD2cFields
    }
  }
  ${LinkActionFragmentDoc}
  ${NavigationTeaserD2cFieldsFragmentDoc}
`;
export const NavigationItemD2cFieldsFragmentDoc = gql`
  fragment NavigationItemD2cFields on NavigationItemD2C {
    sys {
      id
    }
    internalName
    label
    link {
      ...LinkAction
    }
    megaMenu(
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
    ) {
      columnsCollection(limit: 6) {
        items {
          ...NavigationColumnD2cFields
        }
      }
      secondaryColumnsCollection(limit: 4) {
        items {
          ...NavigationColumnD2cFields
        }
      }
      serviceLinksCollection(limit: 6) {
        items {
          ...LinkAction
        }
      }
      teasersCollection(
        limit: 4
        where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
      ) {
        items {
          ...NavigationTeaserD2cFields
        }
      }
      mobileTeaser(
        where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
      ) {
        ...NavigationTeaserD2cFields
      }
    }
  }
  ${LinkActionFragmentDoc}
  ${NavigationColumnD2cFieldsFragmentDoc}
  ${NavigationTeaserD2cFieldsFragmentDoc}
`;
export const NavigationD2cFieldsFragmentDoc = gql`
  fragment NavigationD2cFields on NavigationD2C {
    __typename
    sys {
      id
      locale
    }
    internalName
    navigationType
    navigationItemsCollection(
      limit: 8
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }
    ) {
      items {
        ...NavigationItemD2cFields
      }
    }
    serviceLinksCollection(limit: 6) {
      items {
        ...LinkAction
      }
    }
    teaser(where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $storeConceptIds } } }) {
      ...NavigationTeaserD2cFields
    }
    columnsCollection(limit: 4) {
      items {
        ...NavigationColumnD2cFields
      }
    }
    addressesCollection(limit: 3) {
      items {
        ...NavigationColumnD2cFields
      }
    }
  }
  ${NavigationItemD2cFieldsFragmentDoc}
  ${LinkActionFragmentDoc}
  ${NavigationTeaserD2cFieldsFragmentDoc}
  ${NavigationColumnD2cFieldsFragmentDoc}
`;
export const HeadlineBlockFragmentDoc = gql`
  fragment HeadlineBlock on HeadlineBlock {
    __typename
    sys {
      id
      locale
    }
    eyebrow
    headline {
      json
    }
    subline
  }
`;
export const EditorialTextFragmentDoc = gql`
  fragment EditorialText on EditorialText {
    __typename
    sys {
      id
      locale
    }
    text {
      json
    }
  }
`;
export const UiConfigurationFragmentDoc = gql`
  fragment UIConfiguration on UiConfiguration {
    __typename
    sys {
      id
    }
    internalName
    backgroundColor
    paddingTop
    paddingBottom
  }
`;
export const SectionTextFragmentDoc = gql`
  fragment SectionText on SectionText {
    __typename
    sys {
      id
    }
    internalName
    headline {
      __typename
      sys {
        id
      }
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    text {
      __typename
      sys {
        id
      }
      ... on EditorialText {
        ...EditorialText
      }
    }
    headlineVariant
    headlineDash
    textVariant
    containerWidth
    textColumns
    anchorId
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${HeadlineBlockFragmentDoc}
  ${EditorialTextFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const MediaVideoFragmentDoc = gql`
  fragment MediaVideo on MediaVideo {
    __typename
    sys {
      id
    }
    internalName
    video
    poster
    externalVideoUrl
  }
`;
export const SectionMediaFragmentDoc = gql`
  fragment SectionMedia on SectionMedia {
    __typename
    sys {
      id
    }
    internalName
    fullWidth
    containerWidth
    anchorId
    headline {
      ...HeadlineBlock
    }
    headlineColor
    media {
      __typename
      ... on MediaImage {
        ...MediaImage
      }
      ... on MediaVideo {
        ...MediaVideo
      }
    }
    aspectRatio
    progressbarColor
    autoplay
    muted
    loop
    showControls
    backgroundVideo
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${HeadlineBlockFragmentDoc}
  ${MediaImageFragmentDoc}
  ${MediaVideoFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const GeometryTableFragmentDoc = gql`
  fragment GeometryTable on GeometryTable {
    __typename
    sys {
      id
    }
    internalName
    containerWidth
    showUnitToggle
    defaultUnit
    frameSize
    title
    sizesIn
    unitMm
    unitInches
    productCodes
    anchorId
    uiConfiguration: uiConfigurationSingle {
      ...UIConfiguration
    }
  }
  ${UiConfigurationFragmentDoc}
`;
export const AccordionItemFragmentDoc = gql`
  fragment AccordionItem on AccordionItemD2C {
    __typename
    sys {
      id
    }
    internalName
    label
    contentBlocksCollection(limit: 5) {
      items {
        __typename
        ... on SectionText {
          ...SectionText
        }
        ... on SectionMedia {
          ...SectionMedia
        }
        ... on GeometryTable {
          ...GeometryTable
        }
      }
    }
  }
  ${SectionTextFragmentDoc}
  ${SectionMediaFragmentDoc}
  ${GeometryTableFragmentDoc}
`;
export const AccordionFragmentDoc = gql`
  fragment Accordion on AccordionD2C {
    __typename
    sys {
      id
    }
    internalName
    columnWidth
    itemsCollection(limit: 10) {
      items {
        __typename
        ... on AccordionItemD2C {
          ...AccordionItem
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${AccordionItemFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionTextImageFragmentDoc = gql`
  fragment SectionTextImage on SectionTextImage {
    __typename
    sys {
      id
    }
    internalName
    headline {
      __typename
      sys {
        id
      }
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    text {
      __typename
      sys {
        id
      }
      ... on EditorialText {
        ...EditorialText
      }
    }
    media {
      __typename
      sys {
        id
      }
      ... on MediaImage {
        ...MediaImage
      }
    }
    cta {
      __typename
      sys {
        id
      }
      ... on LinkAction {
        ...LinkAction
      }
    }
    orderReverse
    containerWidth
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${HeadlineBlockFragmentDoc}
  ${EditorialTextFragmentDoc}
  ${MediaImageFragmentDoc}
  ${LinkActionFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const ContentSliderFragmentDoc = gql`
  fragment ContentSlider on ContentSliderD2C {
    __typename
    sys {
      id
    }
    internalName
    containerWidth
    behavior
    autoplay
    autoplayDuration
    navigationLayout
    showNavigationArrows
    slidesCollection(
      limit: 20
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        ... on SectionTextImage {
          ...SectionTextImage
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${SectionTextImageFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const ProductListingFragmentDoc = gql`
  fragment ProductListing on ProductListing {
    __typename
    sys {
      id
    }
    internalName
    title
    productCategory
    specificProductsCollection(limit: 50) {
      items {
        ... on ProductListItem {
          __typename
          sys {
            id
          }
          productCode
          colorCode
        }
      }
    }
    defaultSort
    searchQuery
    showFilters
    showSorting
    showCarouselNavigationArrows
    variant
    paginationMode
    pageSize
    anchorId
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${UiConfigurationFragmentDoc}
`;
export const SectionClaimFragmentDoc = gql`
  fragment SectionClaim on SectionClaim {
    __typename
    sys {
      id
    }
    internalName
    claimText: text
    fullWidth
    offsetLeft: offsetLeftPercent
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${UiConfigurationFragmentDoc}
`;
export const CounterItemFragmentDoc = gql`
  fragment CounterItem on CounterItem {
    __typename
    sys {
      id
    }
    internalName
    prefix
    value
    suffix
    subline
  }
`;
export const SectionCounterFragmentDoc = gql`
  fragment SectionCounter on SectionCounter {
    __typename
    sys {
      id
    }
    internalName
    footnote
    itemsCollection(limit: 4) {
      items {
        ... on CounterItem {
          ...CounterItem
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${CounterItemFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionGalleryFragmentDoc = gql`
  fragment SectionGallery on SectionGallery {
    __typename
    sys {
      id
    }
    internalName
    variant
    fullWidth
    anchorId
    headline {
      __typename
      sys {
        id
      }
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    itemsCollection(limit: 20) {
      items {
        __typename
        ... on GalleryItem {
          sys {
            id
          }
          internalName
          image {
            __typename
            sys {
              id
            }
            ... on MediaImage {
              ...MediaImage
            }
          }
        }
        ... on GalleryItemWithText {
          sys {
            id
          }
          internalName
          text {
            __typename
            sys {
              id
            }
            ... on SectionText {
              ...SectionText
            }
          }
          image {
            __typename
            sys {
              id
            }
            ... on MediaImage {
              ...MediaImage
            }
          }
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${HeadlineBlockFragmentDoc}
  ${MediaImageFragmentDoc}
  ${SectionTextFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionHeroSlideFragmentDoc = gql`
  fragment SectionHeroSlide on SectionHero {
    __typename
    sys {
      id
    }
    internalName
    content {
      __typename
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    svg {
      __typename
      ... on MediaImage {
        ...MediaImage
      }
    }
    mediaCollection(limit: 5) {
      items {
        __typename
        ... on MediaImage {
          sys {
            id
          }
          ...MediaImage
        }
        ... on MediaVideo {
          sys {
            id
          }
          ...MediaVideo
        }
      }
    }
    ctaCollection(limit: 2) {
      items {
        __typename
        ...LinkAction
      }
    }
    textColor
    backgroundColor
    headlineSize
    textHorizontalPosition
    textVerticalPosition
    buttonsPosition
  }
  ${HeadlineBlockFragmentDoc}
  ${MediaImageFragmentDoc}
  ${MediaVideoFragmentDoc}
  ${LinkActionFragmentDoc}
`;
export const SectionHeroFragmentDoc = gql`
  fragment SectionHero on SectionHero {
    ...SectionHeroSlide
    heroLayout
    presentation
    autoplay
    autoplayDuration
    additionalSlidesCollection(
      limit: 4
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        ...SectionHeroSlide
      }
    }
  }
  ${SectionHeroSlideFragmentDoc}
`;
export const SectionHotspotFragmentDoc = gql`
  fragment SectionHotspot on Hotspot {
    __typename
    sys {
      id
    }
    internalName
    imageUrl
    hotspots
    fullWidth
    hotspotColor
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${UiConfigurationFragmentDoc}
`;
export const SectionIntroTextFragmentDoc = gql`
  fragment SectionIntroText on SectionIntroText {
    __typename
    sys {
      id
    }
    internalName
    headline {
      __typename
      sys {
        id
      }
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    headlineIntro {
      __typename
      sys {
        id
      }
      ... on HeadlineBlock {
        ...HeadlineBlock
      }
    }
    textIntro {
      __typename
      sys {
        id
      }
      ... on EditorialText {
        ...EditorialText
      }
    }
    headlineLevel
    headlineVariant
    textVariant
    containerWidth
    anchorId
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${HeadlineBlockFragmentDoc}
  ${EditorialTextFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionQuoteFragmentDoc = gql`
  fragment SectionQuote on SectionQuote {
    __typename
    sys {
      id
      locale
    }
    internalName
    eyebrow
    quoteText {
      json
    }
    quoteType
    authorName
    authorTeam
    authorImage {
      __typename
      sys {
        id
      }
      ... on MediaImage {
        ...MediaImage
      }
    }
    athlete {
      __typename
      sys {
        id
      }
      internalName
      firstName
      lastName
      team
      image {
        __typename
        sys {
          id
        }
        ... on MediaImage {
          ...MediaImage
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${MediaImageFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionSliderFragmentDoc = gql`
  fragment SectionSlider on SectionSlider {
    __typename
    sys {
      id
    }
    internalName
    slidesCollection(
      limit: 5
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        ... on SectionHero {
          ...SectionHeroSlide
        }
      }
    }
    autoplay
    autoplayDuration
    fullWidth
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${SectionHeroSlideFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionTaglineFragmentDoc = gql`
  fragment SectionTagline on SectionTagline {
    __typename
    sys {
      id
      locale
    }
    internalName
    text {
      json
    }
    anchorId
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${UiConfigurationFragmentDoc}
`;
export const TeaserItemFragmentDoc = gql`
  fragment TeaserItem on TeaserItem {
    __typename
    sys {
      id
    }
    internalName
    image {
      ...MediaImage
    }
    link {
      __typename
      ...LinkAction
    }
  }
  ${MediaImageFragmentDoc}
  ${LinkActionFragmentDoc}
`;
export const SectionTeaserFragmentDoc = gql`
  fragment SectionTeaser on SectionTeaser {
    __typename
    sys {
      id
    }
    internalName
    itemsCollection(limit: 3) {
      items {
        ...TeaserItem
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${TeaserItemFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const SectionReferenceFragmentDoc = gql`
  fragment SectionReference on Entry {
    __typename
    sectionReference: sys {
      id
    }
  }
`;
export const TabContainerItemFragmentDoc = gql`
  fragment TabContainerItem on TabContainerItemD2C {
    __typename
    sys {
      id
    }
    internalName
    title
    contentBlocksCollection(limit: 5) {
      items {
        ...SectionReference
      }
    }
  }
  ${SectionReferenceFragmentDoc}
`;
export const TabContainerFragmentDoc = gql`
  fragment TabContainer on TabContainerD2C {
    __typename
    sys {
      id
    }
    internalName
    title
    showNavigationArrows
    columnWidth
    itemsCollection(
      limit: 8
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        ... on TabContainerItemD2C {
          ...TabContainerItem
        }
      }
    }
    uiConfiguration {
      ...UIConfiguration
    }
  }
  ${TabContainerItemFragmentDoc}
  ${UiConfigurationFragmentDoc}
`;
export const CategoryEnrichmentFragmentDoc = gql`
  fragment CategoryEnrichment on CategoryEnrichment {
    __typename
    sys {
      id
      locale
    }
    internalName
    categoryCode
    firstContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    secondContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    thirdContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
  }
`;
export const ProductEnrichmentFragmentDoc = gql`
  fragment ProductEnrichment on ProductEnrichment {
    __typename
    sys {
      id
      locale
    }
    internalName
    productCode
    firstContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    secondContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    thirdContent {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
  }
`;
export const SeoMetadataFragmentDoc = gql`
  fragment SeoMetadata on Seo {
    __typename
    sys {
      id
      locale
    }
    title
    description
    keywords
    canonicalUrl
    hideFromSearchEnginesNoindex
    excludeLinksFromRankingsNofollow
    openGraphImage {
      ...MediaImage
    }
  }
  ${MediaImageFragmentDoc}
`;
export const ConfigDocument = gql`
  query config($locale: String, $preview: Boolean) {
    configCollection(limit: 1, preview: $preview, locale: $locale, order: sys_publishedAt_DESC) {
      items {
        ...Config
      }
    }
  }
  ${ConfigFragmentDoc}
`;
export const DivisionNavigationDocument = gql`
  query divisionNavigation($locale: String, $preview: Boolean, $baseStoreUid: String!) {
    divisionNavigationCollection(
      limit: 1
      locale: $locale
      preview: $preview
      order: sys_publishedAt_DESC
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: [$baseStoreUid] } } }
    ) {
      items {
        __typename
        sys {
          id
          locale
        }
        internalName
        ariaLabel
        divisionsCollection(limit: 4) {
          items {
            ...TeaserItem
          }
        }
      }
    }
  }
  ${TeaserItemFragmentDoc}
`;
export const HomePageDocument = gql`
  query homePage($locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    homePageCollection(
      limit: 1
      locale: $locale
      preview: $preview
      where: { contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        sys {
          id
          locale
        }
        title
        seoMetadata {
          ...SeoMetadata
        }
        introSectionCollection(limit: 1) {
          items {
            ...SectionReference
          }
        }
        contentSectionsCollection(limit: 50) {
          items {
            ...SectionReference
          }
        }
        bottomSectionCollection(limit: 2) {
          items {
            ...SectionReference
          }
        }
      }
    }
  }
  ${SeoMetadataFragmentDoc}
  ${SectionReferenceFragmentDoc}
`;
export const NavigationDocument = gql`
  query navigation($locale: String, $preview: Boolean, $conceptIds: [String!]!, $storeConceptIds: [String!]!) {
    header: navigationD2CCollection(
      limit: 1
      locale: $locale
      preview: $preview
      order: sys_publishedAt_DESC
      where: {
        navigationType: "Top Navigation"
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $conceptIds } }
      }
    ) {
      items {
        ...NavigationD2cFields
      }
    }
    footer: navigationD2CCollection(
      limit: 1
      locale: $locale
      preview: $preview
      order: sys_publishedAt_DESC
      where: {
        navigationType: "Footer Navigation"
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $conceptIds } }
      }
    ) {
      items {
        ...NavigationD2cFields
      }
    }
  }
  ${NavigationD2cFieldsFragmentDoc}
`;
export const PageByPathDocument = gql`
  query pageByPath($slug: String!, $locale: String, $preview: Boolean, $taxonomies: [String!]) {
    contentPageCollection(
      limit: 1
      locale: $locale
      preview: $preview
      where: { slug: $slug, contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } } }
    ) {
      items {
        __typename
        _id
        sys {
          id
          locale
        }
        slug
        title
        seoMetadata {
          ...SeoMetadata
        }
        contentfulMetadata {
          tags {
            id
            name
          }
        }
        sectionsCollection(limit: 50) {
          items {
            ...SectionReference
          }
        }
      }
    }
  }
  ${SeoMetadataFragmentDoc}
  ${SectionReferenceFragmentDoc}
`;
export const ProductEnrichmentByProductCodeDocument = gql`
  query productEnrichmentByProductCode(
    $productCode: String!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    productEnrichmentCollection(
      limit: 1
      locale: $locale
      preview: $preview
      where: {
        productCode: $productCode
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
    ) {
      items {
        ...ProductEnrichment
      }
    }
  }
  ${ProductEnrichmentFragmentDoc}
`;
export const CategoryEnrichmentByCategoryCodeDocument = gql`
  query categoryEnrichmentByCategoryCode(
    $categoryCode: String!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    categoryEnrichmentCollection(
      limit: 1
      locale: $locale
      preview: $preview
      where: {
        categoryCode_contains_some: [$categoryCode]
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
    ) {
      items {
        ...CategoryEnrichment
      }
    }
  }
  ${CategoryEnrichmentFragmentDoc}
`;
export const SectionHeroByIdsDocument = gql`
  query sectionHeroByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    sectionHeroCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionHero
      }
    }
  }
  ${SectionHeroFragmentDoc}
`;
export const SectionSliderByIdsDocument = gql`
  query sectionSliderByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    sectionSliderCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionSlider
      }
    }
  }
  ${SectionSliderFragmentDoc}
`;
export const AccordionByIdsDocument = gql`
  query accordionByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    accordionD2CCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...Accordion
      }
    }
  }
  ${AccordionFragmentDoc}
`;
export const ContentSliderByIdsDocument = gql`
  query contentSliderByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    contentSliderD2CCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...ContentSlider
      }
    }
  }
  ${ContentSliderFragmentDoc}
`;
export const SectionClaimByIdsDocument = gql`
  query sectionClaimByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    sectionClaimCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...SectionClaim
      }
    }
  }
  ${SectionClaimFragmentDoc}
`;
export const SectionTaglineByIdsDocument = gql`
  query sectionTaglineByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    sectionTaglineCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...SectionTagline
      }
    }
  }
  ${SectionTaglineFragmentDoc}
`;
export const SectionTextByIdsDocument = gql`
  query sectionTextByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    sectionTextCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionText
      }
    }
  }
  ${SectionTextFragmentDoc}
`;
export const SectionIntroTextByIdsDocument = gql`
  query sectionIntroTextByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    sectionIntroTextCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionIntroText
      }
    }
  }
  ${SectionIntroTextFragmentDoc}
`;
export const SectionQuoteByIdsDocument = gql`
  query sectionQuoteByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    sectionQuoteCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...SectionQuote
      }
    }
  }
  ${SectionQuoteFragmentDoc}
`;
export const SectionCounterByIdsDocument = gql`
  query sectionCounterByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    sectionCounterCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...SectionCounter
      }
    }
  }
  ${SectionCounterFragmentDoc}
`;
export const SectionTextImageByIdsDocument = gql`
  query sectionTextImageByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    sectionTextImageCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionTextImage
      }
    }
  }
  ${SectionTextImageFragmentDoc}
`;
export const SectionGalleryByIdsDocument = gql`
  query sectionGalleryByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    sectionGalleryCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionGallery
      }
    }
  }
  ${SectionGalleryFragmentDoc}
`;
export const SectionTeaserByIdsDocument = gql`
  query sectionTeaserByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    sectionTeaserCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionTeaser
      }
    }
  }
  ${SectionTeaserFragmentDoc}
`;
export const SectionHotspotByIdsDocument = gql`
  query sectionHotspotByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    hotspotCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...SectionHotspot
      }
    }
  }
  ${SectionHotspotFragmentDoc}
`;
export const SectionMediaByIdsDocument = gql`
  query sectionMediaByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean, $taxonomies: [String!]!) {
    sectionMediaCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...SectionMedia
      }
    }
  }
  ${SectionMediaFragmentDoc}
`;
export const ProductListingByIdsDocument = gql`
  query productListingByIds($ids: [String!]!, $limit: Int!, $locale: String, $preview: Boolean) {
    productListingCollection(where: { sys: { id_in: $ids } }, limit: $limit, locale: $locale, preview: $preview) {
      items {
        ...ProductListing
      }
    }
  }
  ${ProductListingFragmentDoc}
`;
export const GeometryTableByIdsDocument = gql`
  query geometryTableByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    geometryTableCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...GeometryTable
      }
    }
  }
  ${GeometryTableFragmentDoc}
`;
export const TabContainerByIdsDocument = gql`
  query tabContainerByIds(
    $ids: [String!]!
    $limit: Int!
    $locale: String
    $preview: Boolean
    $taxonomies: [String!]!
  ) {
    tabContainerD2CCollection(
      where: {
        sys: { id_in: $ids }
        contentfulMetadata: { concepts_exists: true, concepts: { id_contains_all: $taxonomies } }
      }
      limit: $limit
      locale: $locale
      preview: $preview
    ) {
      items {
        ...TabContainer
      }
    }
  }
  ${TabContainerFragmentDoc}
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();
const ConfigDocumentString = print(ConfigDocument);
const DivisionNavigationDocumentString = print(DivisionNavigationDocument);
const HomePageDocumentString = print(HomePageDocument);
const NavigationDocumentString = print(NavigationDocument);
const PageByPathDocumentString = print(PageByPathDocument);
const ProductEnrichmentByProductCodeDocumentString = print(ProductEnrichmentByProductCodeDocument);
const CategoryEnrichmentByCategoryCodeDocumentString = print(CategoryEnrichmentByCategoryCodeDocument);
const SectionHeroByIdsDocumentString = print(SectionHeroByIdsDocument);
const SectionSliderByIdsDocumentString = print(SectionSliderByIdsDocument);
const AccordionByIdsDocumentString = print(AccordionByIdsDocument);
const ContentSliderByIdsDocumentString = print(ContentSliderByIdsDocument);
const SectionClaimByIdsDocumentString = print(SectionClaimByIdsDocument);
const SectionTaglineByIdsDocumentString = print(SectionTaglineByIdsDocument);
const SectionTextByIdsDocumentString = print(SectionTextByIdsDocument);
const SectionIntroTextByIdsDocumentString = print(SectionIntroTextByIdsDocument);
const SectionQuoteByIdsDocumentString = print(SectionQuoteByIdsDocument);
const SectionCounterByIdsDocumentString = print(SectionCounterByIdsDocument);
const SectionTextImageByIdsDocumentString = print(SectionTextImageByIdsDocument);
const SectionGalleryByIdsDocumentString = print(SectionGalleryByIdsDocument);
const SectionTeaserByIdsDocumentString = print(SectionTeaserByIdsDocument);
const SectionHotspotByIdsDocumentString = print(SectionHotspotByIdsDocument);
const SectionMediaByIdsDocumentString = print(SectionMediaByIdsDocument);
const ProductListingByIdsDocumentString = print(ProductListingByIdsDocument);
const GeometryTableByIdsDocumentString = print(GeometryTableByIdsDocument);
const TabContainerByIdsDocumentString = print(TabContainerByIdsDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    config(
      variables?: ConfigQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{ data: ConfigQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<ConfigQuery>(ConfigDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "config",
        "query",
        variables,
      );
    },
    divisionNavigation(
      variables: DivisionNavigationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: DivisionNavigationQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<DivisionNavigationQuery>(DivisionNavigationDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "divisionNavigation",
        "query",
        variables,
      );
    },
    homePage(
      variables: HomePageQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{ data: HomePageQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<HomePageQuery>(HomePageDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "homePage",
        "query",
        variables,
      );
    },
    navigation(
      variables: NavigationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{ data: NavigationQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<NavigationQuery>(NavigationDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "navigation",
        "query",
        variables,
      );
    },
    pageByPath(
      variables: PageByPathQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{ data: PageByPathQuery; errors?: GraphQLError[]; extensions?: any; headers: Headers; status: number }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<PageByPathQuery>(PageByPathDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "pageByPath",
        "query",
        variables,
      );
    },
    productEnrichmentByProductCode(
      variables: ProductEnrichmentByProductCodeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: ProductEnrichmentByProductCodeQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<ProductEnrichmentByProductCodeQuery>(
            ProductEnrichmentByProductCodeDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "productEnrichmentByProductCode",
        "query",
        variables,
      );
    },
    categoryEnrichmentByCategoryCode(
      variables: CategoryEnrichmentByCategoryCodeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: CategoryEnrichmentByCategoryCodeQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<CategoryEnrichmentByCategoryCodeQuery>(
            CategoryEnrichmentByCategoryCodeDocumentString,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "categoryEnrichmentByCategoryCode",
        "query",
        variables,
      );
    },
    sectionHeroByIds(
      variables: SectionHeroByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionHeroByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionHeroByIdsQuery>(SectionHeroByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionHeroByIds",
        "query",
        variables,
      );
    },
    sectionSliderByIds(
      variables: SectionSliderByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionSliderByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionSliderByIdsQuery>(SectionSliderByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionSliderByIds",
        "query",
        variables,
      );
    },
    accordionByIds(
      variables: AccordionByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: AccordionByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<AccordionByIdsQuery>(AccordionByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "accordionByIds",
        "query",
        variables,
      );
    },
    contentSliderByIds(
      variables: ContentSliderByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: ContentSliderByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<ContentSliderByIdsQuery>(ContentSliderByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "contentSliderByIds",
        "query",
        variables,
      );
    },
    sectionClaimByIds(
      variables: SectionClaimByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionClaimByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionClaimByIdsQuery>(SectionClaimByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionClaimByIds",
        "query",
        variables,
      );
    },
    sectionTaglineByIds(
      variables: SectionTaglineByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionTaglineByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionTaglineByIdsQuery>(SectionTaglineByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionTaglineByIds",
        "query",
        variables,
      );
    },
    sectionTextByIds(
      variables: SectionTextByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionTextByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionTextByIdsQuery>(SectionTextByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionTextByIds",
        "query",
        variables,
      );
    },
    sectionIntroTextByIds(
      variables: SectionIntroTextByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionIntroTextByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionIntroTextByIdsQuery>(SectionIntroTextByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionIntroTextByIds",
        "query",
        variables,
      );
    },
    sectionQuoteByIds(
      variables: SectionQuoteByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionQuoteByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionQuoteByIdsQuery>(SectionQuoteByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionQuoteByIds",
        "query",
        variables,
      );
    },
    sectionCounterByIds(
      variables: SectionCounterByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionCounterByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionCounterByIdsQuery>(SectionCounterByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionCounterByIds",
        "query",
        variables,
      );
    },
    sectionTextImageByIds(
      variables: SectionTextImageByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionTextImageByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionTextImageByIdsQuery>(SectionTextImageByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionTextImageByIds",
        "query",
        variables,
      );
    },
    sectionGalleryByIds(
      variables: SectionGalleryByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionGalleryByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionGalleryByIdsQuery>(SectionGalleryByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionGalleryByIds",
        "query",
        variables,
      );
    },
    sectionTeaserByIds(
      variables: SectionTeaserByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionTeaserByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionTeaserByIdsQuery>(SectionTeaserByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionTeaserByIds",
        "query",
        variables,
      );
    },
    sectionHotspotByIds(
      variables: SectionHotspotByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionHotspotByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionHotspotByIdsQuery>(SectionHotspotByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionHotspotByIds",
        "query",
        variables,
      );
    },
    sectionMediaByIds(
      variables: SectionMediaByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: SectionMediaByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<SectionMediaByIdsQuery>(SectionMediaByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "sectionMediaByIds",
        "query",
        variables,
      );
    },
    productListingByIds(
      variables: ProductListingByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: ProductListingByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<ProductListingByIdsQuery>(ProductListingByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "productListingByIds",
        "query",
        variables,
      );
    },
    geometryTableByIds(
      variables: GeometryTableByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: GeometryTableByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<GeometryTableByIdsQuery>(GeometryTableByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "geometryTableByIds",
        "query",
        variables,
      );
    },
    tabContainerByIds(
      variables: TabContainerByIdsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<{
      data: TabContainerByIdsQuery;
      errors?: GraphQLError[];
      extensions?: any;
      headers: Headers;
      status: number;
    }> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.rawRequest<TabContainerByIdsQuery>(TabContainerByIdsDocumentString, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "tabContainerByIds",
        "query",
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
